/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Kontoadresse",
        "address_information": "Adressdaten",
        "billing_address_same_message": "Die Rechnungsadresse entspricht der Kontoadresse.",
        "buy_canada_tax_free": "Steuerfrei in Kanada einkaufen?",
        "buy_canada_tax_free_description": "Wenn Sie Ihre GST-/HST- sowie ihre QST-Nummer angeben, werden keine Steuern auf den Einkauf aufgeschlagen. Wenn Sie diese Felder nicht ausfüllen, werden Steuern aufgeschlagen. Für Einkäufe in British Columbia, Manitoba und Saskatchewan ist die Validierung des Steuerausweises erforderlich. Bitte senden Sie diesen vor dem Abschluss des Kaufs an {<contact_email>}. Wir melden uns schnellstmöglich bei Ihnen.",
        "city": "Ort",
        "country": "Land",
        "country_not_supported_message": "Wenden Sie sich an unser {<sales_team>}, um das Land zu ändern.",
        "disable_trial_conversion_message": "Setzen Sie sich mit unserem Team in Verbindung, um den besten Tarif für Ihr Land zu finden. Kontaktieren Sie uns über den {<live_chat>}.",
        "enter_address_manually": "Adresse manuell eingeben",
        "european_vat_id": "EU-Umsatzsteuer-ID",
        "gst_hst_number": "GST-/HST-Steuernummer",
        "postal_code": "Postleitzahl",
        "province": "Provinz",
        "pst_number": "PST-Steuernummer",
        "qst_number": "QST-Steuernummer",
        "sfi_message": "Sind Sie ein sog. ausgewähltes Finanzinstitut (SLFI)?",
        "state": "Bundesland",
        "street": "Straße",
        "suggestions_attribution": "Vorschläge von Google",
        "suggestions_not_found": "Adresse konnte nicht gefunden werden. Versuchen Sie es erneut oder geben Sie die Adresse manuell ein.",
        "tax_tooltip": "Geben Sie die Geschäftssteuer-ID hier ein. Dadurch kann die Steuer in den Rechnungen ordnungsgemäß abgewickelt werden.",
        "title": "Rechnungsadresse",
        "validation_message": {
          "city_required": "Ort ist erforderlich.",
          "country_required": "Land ist erforderlich.",
          "province_required": "Provinz ist erforderlich.",
          "state_required": "Bundesland ist erforderlich.",
          "street_required": "Geben Sie die Straße ein.",
          "tax_invalid": "Die Steuer-ID konnte nicht validiert werden. Überprüfen Sie die Eingabe und versuchen Sie es erneut.",
          "zip_required": "Postleitzahl ist erforderlich."
        },
        "zip": "Postleitzahl"
      },
      "call_to_action": {
        "cancel": "Abbrechen",
        "clear": "Löschen",
        "submit": "Senden"
      },
      "cancel_account": {
        "cancel_account": "Konto kündigen",
        "cancel_trial": "Testversion kündigen",
        "contact_information": {
          "call_international": "International: + 1 919 745 6111",
          "call_toll_free": "Gebührenfrei anrufen: +1 800 441 3453",
          "call_uk": "UK: +44 800 680 0621",
          "here_for_you": "Wir sind für Sie da",
          "visit_support": "Support aufrufen"
        },
        "contact_us": "Kontakt",
        "continue_cancellation": "Kündigen",
        "did_you_know": "Schon gewusst?",
        "did_you_know_desc": "Wenn Sie das ShareFile-Konto kündigen, verzichten Sie u. a. auf folgende großartigen Features:",
        "download_now": "Jetzt herunterladen",
        "error_banner": "Abbrechen fehlgeschlagen. Bitte versuchen Sie es erneut oder wenden Sie sich an unser Support-Team",
        "features": {
          "customer_access": "Unbeschränkter Zugriff für Ihre Kunden",
          "customer_access_desc": "Geben Sie Ihren Kunden kostenlosen Zugriff auf Dateien und legen Sie fest, welche Dateien angezeigt werden.",
          "customer_support": "Kundensupport",
          "customer_support_desc": "per E-Mail oder Telefon. Wir sind für Sie da.",
          "esignature": "E-Signatur",
          "esignature_desc": "Senden Sie Dateien zur Signatur direkt vom ShareFile-Konto.",
          "sharefile_mobile": "Mobile ShareFile-Apps",
          "sharefile_mobile_desc": "Greifen Sie jederzeit von Ihrem Smartphone oder Tablet aus auf Dateien und Ordner zu.",
          "sharefile_plugin": "ShareFile Plug-In für Microsoft Outlook",
          "sharefile_plugin_desc": "Senden Sie große Dateien sicher direkt aus Outlook.",
          "total_security": "Höchste Sicherheit",
          "total_security_desc": "Datenschutz, dem Sie vertrauen können."
        },
        "form": {
          "account_name": "Kontoname",
          "back_to_admin": "Zurück zu 'Kontoverwaltung'",
          "cancel_my_account": "Konto kündigen",
          "cancel_my_trial": "Testversion kündigen",
          "cancellation_reason": {
            "Lacks_required_compliance": "Benötigte Compliances fehlen",
            "lack_of_integrations": "Integrationen fehlen",
            "lacks_required_feature": "Benötigte Funktionen fehlen",
            "no_longer_needed": "Nicht mehr benötigt",
            "poor_account_support": "Schlechter Konto-Support (Vertrieb, Technik)",
            "prefer_competitive_product": "Bevorzuge Produkt der Konkurrenz",
            "security_concerns": "Sicherheitsbedenken",
            "technical_issues": "Technische Probleme",
            "too_difficult_to_use": "Verwendung zu schwierig",
            "too_expensive": "Zu teuer"
          },
          "comments_label": "Kommentare",
          "comments_placeholder": "Bitte teilen Sie uns mit, warum Sie Ihr Konto kündigen. Können wir etwas tun, um ShareFile für Sie zu verbessern?",
          "employees_desc": "{{employeeCount}} von {{employeeMax}} erworben",
          "employees_title": "Mitarbeiter",
          "forgot_your_password": "Kennwort vergessen?",
          "more_info": "Bitte nehmen Sie sich eine Minute Zeit, um uns zu sagen, warum Sie Ihr Konto kündigen.",
          "once_you_cancel": "Wenn Sie ShareFile kündigen, werden Ihre Dateien nach 30 Tagen gelöscht.",
          "password_label": "Kontokennwort eingeben",
          "password_missing": "Geben Sie das Kontokennwort ein",
          "password_placeholder": "Kennwort",
          "reason_missing": "Wählen Sie einen Grund aus",
          "required": "Erforderlich",
          "storage_usage_desc": "{{mbUsed}} von {{mbMax}} MB verwendet (zum {{dateFormatted}})",
          "storage_usage_title": "Speichernutzung",
          "title": "Ich kündige das ShareFile-Konto aus folgenden Gründen:",
          "to_authorize": "Wenn Sie mit der Kündigung fortfahren möchten, geben Sie Ihr Kontokennwort ein, um ShareFile zu autorisieren, Ihre Dateien nach 30 Tagen zu löschen."
        },
        "in_progress_banner": "Wir aktualisieren gerade Ihr Konto. Dies kann einige Zeit dauern – schauen Sie bald wieder vorbei!",
        "learn_more": "Weitere Informationen",
        "let_us_help_1": "Wir helfen Ihnen gerne, aus Ihrem ShareFile-Konto das Meiste zu machen.",
        "let_us_help_2": "Kontaktieren Sie unser Customer Care Team,",
        "let_us_help_3": "um mehr über diese und andere ShareFile-Funktionen zu erfahren.",
        "modal_confirm": "OK",
        "modal_message": "Ihr Konto wurde gekündigt, bleibt aber bis zum Ende des Abrechnungszeitraums aktiv. Sie können das Konto mit 'Konto reaktivieren' im Verwaltungsmenü reaktivieren.",
        "modal_message_trial": "Ihre Testversion wurde gekündigt. Danke, dass Sie ShareFile ausprobiert haben. Sie können Ihr Konto wieder aktivieren, indem Sie im Kontoverwaltungsmenü auf 'Konto reaktivieren' klicken.",
        "modal_title": "Konto gekündigt",
        "modal_title_trial": "Testversion gekündigt",
        "password_was_incorrect": "Kennwort war falsch",
        "resources_card": {
          "ask_the_community": "Fragen Sie die Community",
          "sharefile_knowledgebase": "ShareFile-Wissensdatenbank",
          "title": "Haben Sie diese Ressourcen ausprobiert?",
          "training_videos": "Schulungsvideos"
        },
        "sorry_to_go": "Schade, dass Sie Ihr Konto kündigen.",
        "sorry_to_go_desc": "ShareFile wurde für Sie entwickelt. Wir arbeiten ständig daran, unseren Service für Sie zu verbessern und Ihre Dateifreigabe- und Speicherbedürfnisse zu erfüllen."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "Ein Fehler ist aufgetreten",
        "live_chat": "Live-Chat",
        "sales_team": "Vertriebsteam"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Sparen Sie 10 %)",
          "choose_billing_cycle": "Abrechnungszyklus auswählen",
          "choose_billing_cycle_text": "Der Preis basiert auf der Gesamtanzahl der Mitarbeiter.",
          "online_only": "(Nur online)",
          "pay_annually": "Jährlich zahlen",
          "pay_monthly": "Monatlich zahlen"
        },
        "buttons": {
          "buy_now": "Jetzt kaufen",
          "cancel": "Abbrechen",
          "continue": "Weiter",
          "convert_now": "Jetzt umwandeln",
          "convert_now_tooltip": "Stellen Sie vor der Umwandlung sicher, dass die Adresse und die Kreditkarte verifiziert wurden."
        },
        "convert_modal": {
          "confirm_purchase": "Kauf bestätigen",
          "confirm_purchase_description": "Mit 'Jetzt umwandeln' wird Ihnen heute {<billingRate>} (zuzüglich anfallender Steuern) in Rechnung gestellt und Ihr Konto wird in ein kostenpflichtiges Konto umgewandelt."
        },
        "credit_card": {
          "add": "Hinzufügen",
          "confirmed": "Kreditkarte bestätigt",
          "confirmed_description": "Ihre Kreditkarteninformationen wurden verifiziert.",
          "declined": "Kreditkarte abgelehnt",
          "declined_description": "Die Karte konnte nicht verifiziert werden. Überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
          "edit": "Bearbeiten",
          "error_message": "Die Verifizierung der Kreditkarte ist fehlgeschlagen. Überprüfen Sie die Kreditkarteninformationen und versuchen Sie es noch einmal.",
          "information": "Kartendaten"
        },
        "current_licenses": "Mitarbeiterlizenzen: {{users}}",
        "current_storage": "Speicher: {{storage}} GB",
        "employee_accounts": "Mitarbeiterkonten",
        "employee_accounts_description": "Ihr Abonnement enthält {{users}} Mitarbeiterkonten. Sie können unten zusätzliche Konten zu Ihrem Abonnement hinzufügen.",
        "employee_accounts_description_vdr": "Ihr Abonnement enthält {{users}} Mitarbeiterlizenzen und {{storage}} GB Speicher. Sie können unten mehr hinzufügen.",
        "employee_licenses": "Mitarbeiterlizenzen",
        "employee_licenses_storage": "Mitarbeiterlizenzen und Speicher",
        "error_loading_plans": "Beim Laden der Abonnements ist ein Fehler aufgetreten. Versuchen Sie es noch einmal.",
        "left_nav_button_text": "Kostenlose Testversion umwandeln",
        "month": "pro Monat",
        "number_of_users_selection": {
          "title": "Benutzeranzahl",
          "user_limit_message": "Das ausgewählte Abo erlaubt mindestens {{min}} und maximal {{max}} Benutzer."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} Mitarbeiterkonten",
          "max_file_size": "100 GB",
          "max_storage": "1 TB/Lizenz",
          "max_storage_vdr": "1 GB/Lizenz",
          "storage": "{{storage}} Speicher"
        },
        "plan_chart": {
          "need_help": "Brauchen Sie Hilfe? Wir sind für Sie da. Weitere Abo-Optionen erhalten Sie beim Support unter sales@sharefile.com oder telefonisch unter +1 800 441 3453.",
          "upgrade_plan": "Abonnement upgraden",
          "view_detailed_comparison": "Detaillierten Vergleich anzeigen"
        },
        "plan_summary": {
          "annually": "Jährlich",
          "billing": "Abrechnung",
          "monthly": "Monatlich",
          "plan": "Abonnement {{name}}",
          "plus_applicable_taxes": "Ggf. anfallende Steuern werden in der Rechnung aufgeführt.",
          "storage_max_file_size": "Speicher/max. Dateigröße: {<storage_details>}",
          "users": "Benutzer",
          "your_total": "Insgesamt"
        },
        "purchase_confirmed": "Kauf bestätigt",
        "something_went_wrong": "Ein Fehler ist aufgetreten",
        "storage_distribution_description": "Der Speicher wird von allen lizenzierten Mitarbeitern gemeinsam genutzt, es gibt keine Begrenzung für einzelne Benutzer.",
        "storage_gb": "{{storage}} GB",
        "storage_only": "Speicher",
        "successful_conversion": "Das Konto wurde erfolgreich umgewandelt.",
        "title": "Kostenlose Testversion umwandeln",
        "try_again_or_contact_support": "Versuchen Sie es erneut oder wenden Sie sich für weitere Unterstützung an den Support.",
        "upgrade_failed": "Upgrade fehlgeschlagen"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Rechnungsadresse",
          "city": "Ort",
          "country": "Land",
          "state_province": "Bundesland/Kanton",
          "street": "Straße",
          "zip_postal_code": "Postleitzahl"
        },
        "cancel": "Abbrechen",
        "credit_card": {
          "card_details": "Kreditkartendetails",
          "card_exp_date": "Ablaufdatum",
          "card_first_name": "Vorname",
          "card_last_name": "Nachname",
          "card_number": "Kartennummer",
          "card_type": "Kartentyp",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "Kreditkartentyp wird nicht unterstützt. Bitte verwenden Sie Visa, Mastercard oder American Express",
          "card_type_unknown": "Unbekannt",
          "card_type_visa": "Visa",
          "title": "Kreditkarteninformationen"
        },
        "credit_card_notifications": {
          "add_successful": "Kreditkarteninformationen hinzugefügt.",
          "save_failure": "Fehler beim Speichern der Kreditkarteninformationen",
          "update_failure": "Aktualisierung der Kreditkarteninformationen fehlgeschlagen",
          "update_successful": "Kreditkarteninformationen aktualisiert."
        },
        "disable_trial_conversion_message": "Setzen Sie sich mit unserem Team in Verbindung, um den besten Tarif für Ihr Land zu finden. Kontaktieren Sie uns über den {<live_chat>}.",
        "edit": "Bearbeiten",
        "get_billing_info_failed": "Ein Fehler ist beim Abrufen Ihrer Abrechnungsinformationen aufgetreten. Versuchen Sie es noch einmal.",
        "info_banner": "Hinweis: Aktualisierungen von Abrechnungsinformationen sind u. U. nicht sofort sichtbar. Es kann bis zu 24 Stunden dauern, bis die Änderungen unten angezeigt werden.",
        "left_nav_button_text": "Bearbeiten von Abrechnungsinformationen",
        "name_on_card": "Name auf der Karte",
        "no_billing_info_banner": "Wir können diese Seite derzeit nicht laden. Kontaktieren Sie unseren Kundendienst, um Ihre Rechnungsinformationen zu bearbeiten.",
        "province": "Provinz",
        "save": "Speichern",
        "state": "Bundesland",
        "support": {
          "chat_with_us": "Chatten Sie mit uns",
          "contact_support": "Die Adresse konnte nicht verifiziert werden. Wenden Sie sich an den Support.",
          "contact_support_info": "wenden Sie sich an den Support"
        },
        "title": "Abrechnungsinformationen bearbeiten",
        "update": "Aktualisieren",
        "update_billing_type": {
          "info_message": "Die aktuelle Abrechnungsart ist {<invoice>}. Sie können zur Kreditkartenzahlung wechseln.",
          "invoice": "Rechnung",
          "switch_to_credit_card": "Zu Kreditkarte wechseln",
          "title": "Abrechnungsart aktualisieren"
        },
        "update_notifications": {
          "contact_support": "wenden Sie sich an den Support",
          "save_failed": "Speichern nicht möglich",
          "save_success": "Ihre Änderungen wurden gespeichert.",
          "something_went_wrong": "Ein Fehler ist aufgetreten",
          "try_again": "Die Adresse konnte nicht verifiziert werden. Versuchen Sie es erneut.",
          "try_again_or_contact_support": "Versuchen Sie es erneut oder {<contactSupport>}."
        },
        "vat_id": "Umsatzsteuer-ID",
        "verify_address": "Adresse verifizieren"
      },
      "expiration": {
        "account_canceled_first": "Wir stornieren Konten, wenn wir vom Administrator darum geben werden, wenn die Rechnung überfällig ist oder wenn unsere Nutzungsbedingungen verletzt wurden.",
        "account_canceled_second": "Dieses Konto und alle seine Daten werden am {{date}} (oder kurze Zeit später) dauerhaft gelöscht. Sie können Ihr Konto bis dahin weiterhin nutzen, um in ShareFile gespeicherte Daten zu sichern. Nach dem Löschen des Kontos können die Dateien und die mit dem Konto verknüpften Benutzer nicht wiederhergestellt werden.",
        "account_canceled_title": "Dieses Konto wurde storniert",
        "ask_to_purchase": "Kauf erbitten",
        "continue_to_sharefile": "Weiter zu ShareFile",
        "logo_alt_text": "ShareFile-Logo",
        "notification_error_message": "Fehler beim Senden der Benachrichtigung an den Administrator. Versuchen Sie es noch einmal.",
        "purchase": {
          "error_modal": {
            "close": "Schließen",
            "sub_title": "Rufen Sie uns unter +1 800 441 3453 an, um die Einrichtung Ihres Kontos abzuschließen. Nennen Sie den Fehlercode {<errorCode>}.",
            "title": "Wir benötigen ein paar weitere Informationen."
          },
          "loading_modal": {
            "sub_title": "Die Einrichtung läuft, bitte haben Sie etwas Geduld.",
            "title": "Upgrade für Ihr ShareFile-Konto wird implementiert."
          },
          "select_plan": "Tarif auswählen",
          "title": "ShareFile erwerben"
        },
        "purchase_account": "Konto erwerben",
        "reactivate_account": "Konto reaktivieren",
        "request_reactivation": "Reaktivierung anfordern",
        "request_sent": "Anforderung gesendet",
        "something_went_wrong": "Ein Fehler ist aufgetreten",
        "trial_ended_first": "Ihr Testzeitraum ist am {{date}} abgelaufen. Erwerben Sie das Konto, um ShareFile weiterhin nutzen zu können.",
        "trial_ended_second": "Beachten Sie, dass Testkonten in der Regel 60 Tage nach dem Ende des Tests gelöscht werden. Danach können alle Dateien und Benutzer, die mit diesem Konto verknüpft sind, nicht mehr wiederhergestellt werden.",
        "trial_ended_title": "Ihre Demoversion ist abgelaufen"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "1 Tag",
          "day_count_plural": "{{count}} Tage",
          "days_left_in_your_trial": "In der Testversion verbleiben noch {<dayCount>} Tage. ",
          "upgrade_to_a_plan": "Auf ein Abonnement umsteigen"
        }
      },
      "invalid_address_error": "Die eingegebene Adresse ist ungültig. Versuchen Sie es erneut.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "Wir konnten diese Anforderung nicht bearbeiten, während eine vorherige Anforderung verarbeitet wird.",
      "manage_plan": {
        "add_storage_btn": "Speicher hinzufügen",
        "add_users_btn": "Benutzer hinzufügen",
        "advanced": {
          "description": "Sicherer Dateiaustausch für Teams",
          "feature_access_control": "Detaillierte Zugriffssteuerung und grundlegende Berichte",
          "feature_encryption": "Verschlüsselter Dateispeicher und Dateiaustausch",
          "feature_secure_email": "Sichere E-Mail-Integrationen und gemeinsame Bearbeitung in Echtzeit",
          "features_header": "Die wichtigsten Leistungsmerkmale und Funktionen:",
          "title": "Advanced",
          "title_0gb": "Advanced 0 GB"
        },
        "connectors": {
          "title_0gb": "Connectors 0 GB"
        },
        "contact_support": "Weitere Abonnement-Optionen erfahren Sie vom Support",
        "current_plan": "Aktuelles Abonnement",
        "for_accounting": "Für die Buchhaltung",
        "get_usageplan_failed": "Ein Fehler ist beim Abrufen Ihrer Abonnementinformationen aufgetreten. Versuchen Sie es noch einmal.",
        "included": "Inklusive",
        "industry_advantage": {
          "description": "Vorkonfigurierte, buchhaltungsspezifische Automatisierung des Dokumenten-Workflows",
          "feature_bulk_client_onboarding": "Onboarding mehrerer Kunden gleichzeitig für Buchhaltungsaufträge",
          "feature_centralized_view": "Zentrale Ansicht aller Aufträge an einem Ort",
          "feature_tax_templates": "Vorkonfigurierte Vorlagen für Steueraufträge",
          "features_header": "Alle Premium-Funktionen, und zusätzlich:",
          "title": "Industry Advantage",
          "tooltip": "Maßgeschneiderte Workflows, mit denen durch vollständige, nahtlose Anwendungsszenarien für Buchhaltungs- und Steuerprozesse die Effizienz und Standardisierung erhöht werden kann"
        },
        "left_nav_button_text": "Abonnement verwalten",
        "manage_plan_title": "Abonnement verwalten",
        "message_after_update": "Wir aktualisieren gerade Ihr Abonnement. Dies kann einige Zeit dauern – schauen Sie bald wieder vorbei!",
        "modals": {
          "add_button": "Hinzufügen",
          "additional_users": "Zusätzliche Benutzer",
          "alert_message": "Wenn Sie {<boldText>} wählen, berechnen wir Ihnen einen anteiligen Betrag für die Differenz der Abonnementkosten.",
          "annual_billing_note": "Ihre erste jährliche Zahlung wird am {{date}} fällig.",
          "annual_billing_text": "Sie können 10 % bei Ihrem ShareFile-Abonnement sparen, indem Sie jährlich zahlen. Hier finden Sie eine Übersicht über die Kosten Ihres neuen Abonnements.",
          "annual_billing_title": "Jährliche Abrechnung",
          "cancel_button": "Abbrechen",
          "error_alert": "Ihr Abonnement konnte nicht aktualisiert werden. Versuchen Sie es erneut.",
          "extended_storage": "{{count}} TB erweiterter Speicher",
          "new_billing_amount": "Neuer Rechnungsbetrag",
          "new_monthly_total": "Neuer Monatsbetrag",
          "new_plan_total": "Neuer Abonnementbetrag",
          "new_storage_total": "Neuer Speicherbetrag",
          "new_user_total": "Neue Besucheranzahl",
          "per_month": "{{price}} pro Monat*",
          "per_quarter": "{{price}} pro Quartal*",
          "per_year": "{{price}} pro Jahr*",
          "plus_applicable_taxes": "* zuzüglich anfallender Steuern",
          "price_per_TB": "{{price}} pro 3 TB*",
          "price_per_user": "{{price}} pro Benutzer*",
          "storage_add": "Speicher hinzufügen",
          "storage_data_breakdown_message": "Sie verwenden derzeit {<usedValue>} TB Ihres Speicherplatzes von {<total>} TB.",
          "storage_modal_title": "Speicher hinzufügen",
          "storage_need_additional": "Benötigen Sie zusätzlichen Speicherplatz?",
          "success_alert": "Aktualisiertes Abonnement.",
          "switch_to_annual_button": "Zur jährlichen Abrechnung wechseln",
          "upgrade_button": "Upgrade",
          "upgrade_plan_modal_title": "Abonnement upgraden",
          "users_add": "Benutzer hinzufügen",
          "users_count": "{{count}} Benutzer",
          "users_data_breakdown_message": "Sie verwenden derzeit {<usedValue>} Ihrer {<total>} Benutzerlizenzen.",
          "users_modal_title": "Benutzer hinzufügen",
          "users_need_additional": "Benötigen Sie zusätzliche Benutzer?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "Am beliebtesten",
        "need_help": "Benötigen Sie Hilfe? Wir sind für Sie da. {<contact_support>}",
        "next_billing_date_pending": "an Ihrem nächsten Abrechnungsdatum",
        "per_month": "pro Monat",
        "per_quarter": "pro Quartal",
        "per_year": "pro Jahr",
        "plus_taxes": "* zuzüglich anfallender Steuern",
        "premium": {
          "description": "Umfassende Dokumenten-Workflows für Teams und Kunden",
          "feature_ai_powered": "KI-gestützte Dokumenten-Automatisierung und -Erstellung",
          "feature_client_portals": "Kundenportal mit individuellem Branding",
          "feature_hippa_finra_support": "Unterstützung für die Einhaltung gesetzlicher Auflagen (HIPAA, FINRA, SEC)",
          "feature_tools": "Zusammenarbeits-Tools für Kunden – elektronische Signaturen, Anforderungen, Aufgaben, Formulare, Workflow-Automatisierung",
          "features_header": "Alle Funktionen des Advanced-Abos, plus:",
          "title": "Premium"
        },
        "save_with_annual_btn": "Sparen Sie 10 % bei jährlicher Abrechnung",
        "standard": {
          "feature_all_storage": "Der gesamte Speicherplatz, den Sie benötigen",
          "feature_file_encryption": "Dateiverschlüsselung",
          "feature_sync_edit_share": "Synchronisieren, bearbeiten, teilen",
          "feature_unlimited_client": "Unbegrenzte Kundenbenutzer",
          "features_header": "Features sind:",
          "title": "Standard",
          "title_0gb": "Standard 0 GB"
        },
        "storage": "Speicher",
        "storage_per_user": "{{storage}} pro Benutzer*",
        "upgrade_btn": "Upgrade",
        "upgrade_plan": "Abonnement upgraden",
        "users": "Benutzer",
        "users_count": "{{count}} Benutzer",
        "users_count_one": "{{count}} Benutzer",
        "vdr": {
          "feature_click_trails": "Klickspuren",
          "feature_folder_qa": "Q&A zu Ordnern",
          "feature_visibility_analytics": "Sichtbarkeit, Analysen und mehr",
          "features_header": "Spezialisierter Schutz, einschließlich:",
          "title": "Virtual Data Room"
        }
      },
      "payment_gateway": {
        "authorization_error": "Die Karte konnte nicht verifiziert werden. Überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
        "authorization_error_title": "Kartenverifizierung fehlgeschlagen",
        "contact_details": "Kontaktdetails",
        "form": {
          "card_number": "Kartennummer",
          "cardholder_name": "Name des Karteninhabers",
          "date_validation": {
            "expired": "Karte ist abgelaufen",
            "invalid_date": "Ungültiges Datum",
            "invalid_month": "Ungültiger Monat",
            "no_date_provided": "Geben Sie ein Ablaufdatum ein"
          },
          "expiration_date": "Ablaufdatum",
          "payment_details": "Zahlungsdetails",
          "payment_details_description": "Mit {<asterisk>} gekennzeichnete Felder sind Pflichtfelder",
          "security_code": "Sicherheitscode",
          "security_code_description": "3 Ziffern auf der Kartenrückseite oder 4 Ziffern auf der Kartenvorderseite"
        },
        "iframe_description": "Klicken Sie auf 'Neu', um eine neue Zahlungskarte hinzuzufügen.",
        "iframe_load_error": "Beim Laden der Kreditkartendetails ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal oder wenden Sie sich an den Support.",
        "modal_title": "Zahlungsdetails eingeben",
        "modal_title_legacy": "Zahlungskarte hinzufügen/bearbeiten"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Kontoname:",
          "account_owner_label": "Kontobesitzer:",
          "allocated_licenses_label": "Zugeteilte Lizenzen:",
          "billing_cycle_month": "Monat",
          "billing_cycle_quarter": "Quartal",
          "billing_cycle_year": "Jahr",
          "cancel": "Abbrechen",
          "esig_licenses_out_of": "{{count}} von {{max}} E-Signatur-Lizenzen verwendet",
          "id_label": "ID:",
          "licenses_out_of": "{{count}} von {{max}} Mitarbeiterlizenzen verwendet",
          "next_billing_date_label": "Nächstes Abrechnungsdatum: ",
          "plan_label": "Abonnement:",
          "save": "Speichern",
          "title": "Kontoübersicht",
          "total_billing_cost_info_label": "Dies sind die Gesamtkosten für alle ShareFile-Produkte Ihrer Organisation.",
          "total_billing_cost_label": "Gesamtkosten der Abrechnung:",
          "view_receipts_label": "Belege anzeigen"
        },
        "cancel": "Abbrechen",
        "description": "Wenn Sie Ihr Konto reaktivieren, bleiben Ihre Dienste aktiv und die Abrechnung für Ihr Konto wird wieder aktiviert.",
        "left_nav_button_text": "Konto reaktivieren",
        "lock_error": "Wir konnten diese Anforderung nicht bearbeiten, während eine vorherige Anforderung verarbeitet wird.",
        "page_title": "Konto reaktivieren",
        "reactivate_button": "Reaktivieren",
        "reactivate_failed": "Ihr Konto kann nicht reaktiviert werden. Wenden Sie sich an das Supportteam unter sales@sharefile.com bzw. telefonisch unter +1 (800) 441 3453.",
        "reactivate_success": "Ihr Konto wurde reaktiviert."
      },
      "receipts": {
        "actions": {
          "download": "Download",
          "pay": "Zahlen",
          "title": "Aktionen"
        },
        "awaiting_payment_tooltip": "Es kann bis zu 24 Stunden dauern, bis Rechnungen auf dieser Seite als 'Gezahlt' angezeigt werden.",
        "billing_system_change": "Wir haben kürzlich Änderungen an unserem Abrechnungssystem vorgenommen, die sich darauf auswirken, wie Sie Ihre ShareFile-Rechnungen bezahlen. In allen Rechnungen, die nach dem {<migrationDate>} ausgestellt wurden, wird die Rechnungsdatei einen Zahlungslink enthalten. Rechnungen vor dem {<migrationDate>} enthalten diesen Link nicht. Bitte wenden Sie sich an den Support, um die Zahlung vorzunehmen.",
        "cancel": "Abbrechen",
        "credit_card_notifications": {
          "payment_approved": "Zahlung genehmigt. Vielen Dank!",
          "payment_failure": "Kreditkartenzahlung fehlgeschlagen. Bitte wenden Sie sich an den Support."
        },
        "date": "Datum hinzugefügt",
        "email": "E-Mail",
        "error_getting_logs": "Ein Fehler ist beim Abrufen Ihrer Abrechnungsbelege aufgetreten. Versuchen Sie es später noch einmal.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Belege und Abrechnungsbenachrichtigungen",
        "open_payment": "Für Ihr Konto steht eine Zahlung noch offen.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "Auf dieser Seite werden alle Ihre ShareFile-Abrechnungsbelege angezeigt. Es kann bis zu 24 Stunden dauern, bis Rechnungen auf dieser Seite als 'Gezahlt' angezeigt werden.",
        "page_title": "Belege und Abrechnungsbenachrichtigungen",
        "pay_now": "zahlen",
        "phone": "Telefon",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "Status",
        "status_approved": "Genehmigt",
        "status_awaiting_payment": "Zahlung ausstehend",
        "status_cleared": "Bezahlt",
        "status_failed": "Fehler",
        "status_invoice_payment_received": "Rechnungszahlung erhalten",
        "status_negated": "Negiert",
        "status_open": "Öffnen",
        "status_paid": "Bezahlt",
        "status_pending": "Ausstehend",
        "status_tax_credited": "Steuer gutgeschrieben",
        "status_tax_negated": "Steuer negiert",
        "status_transaction_credited": "Transaktion gutgeschrieben",
        "type": "Typ"
      }
    }
  },
  {
    "key": "en",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Account address",
        "address_information": "Address information",
        "billing_address_same_message": "Billing address is the same as account address.",
        "buy_canada_tax_free": "Buy Canada Tax Free?",
        "buy_canada_tax_free_description": "Using your GST/HST and QST numbers will exempt your purchase from taxes. If you do not fill in these numbers, tax will be applied to your purchase. For purchases in British Columbia, Manitoba, and Saskatchewan a certificate validation is required. Please send them back to {<contact_email>} prior to completing your purchase. We'll get back to you shortly.",
        "city": "City",
        "country": "Country",
        "country_not_supported_message": "To change your country, please contact our {<sales_team>} for assistance.",
        "disable_trial_conversion_message": "Connect with our team to explore the best plan for your country. Reach out via {<live_chat>}.",
        "enter_address_manually": "Enter address manually",
        "european_vat_id": "European VAT ID",
        "gst_hst_number": "GST/HST Registration Number",
        "postal_code": "Postal code",
        "province": "Province",
        "pst_number": "PST Registration Number",
        "qst_number": "QST Registration Number",
        "sfi_message": "Are you a selected financial institution (SLFI)?",
        "state": "State",
        "street": "Street address",
        "suggestions_attribution": "Suggestions powered by Google",
        "suggestions_not_found": "Address not found. Try again or you can enter your address manually instead.",
        "tax_tooltip": "Enter your business Tax ID here. It helps ensure proper tax handling on your invoices.",
        "title": "Billing address",
        "validation_message": {
          "city_required": "City is required.",
          "country_required": "Country is required.",
          "province_required": "Province is required.",
          "state_required": "State is required.",
          "street_required": "Please enter your street address.",
          "tax_invalid": "We couldn't validate your Tax ID. Please review and try again.",
          "zip_required": "Zip code is required."
        },
        "zip": "Zip code"
      },
      "call_to_action": {
        "cancel": "Cancel",
        "clear": "Clear",
        "submit": "Submit"
      },
      "cancel_account": {
        "cancel_account": "Cancel Account",
        "cancel_trial": "Cancel Trial",
        "contact_information": {
          "call_international": "International: +1 919.745.6111",
          "call_toll_free": "Call toll free: 1.800.441.3453",
          "call_uk": "UK: +44 (0800) 680.0621",
          "here_for_you": "We are here for you",
          "visit_support": "Visit support"
        },
        "contact_us": "Contact us",
        "continue_cancellation": "Continue Cancellation",
        "did_you_know": "Did you know?",
        "did_you_know_desc": "When you cancel your ShareFile account, you'll miss out on a lot of great features, including:",
        "download_now": "Download now",
        "error_banner": "Failed to cancel. Please try again or reach out to our support team",
        "features": {
          "customer_access": "Unlimited access for your customers",
          "customer_access_desc": "Let your customers access files for free and manage which files they can see.",
          "customer_support": "Customer Support",
          "customer_support_desc": "by email or phone; we're here to help!",
          "esignature": "E-Signature",
          "esignature_desc": "Send files for signature directly from your ShareFile account.",
          "sharefile_mobile": "ShareFile Mobile Apps",
          "sharefile_mobile_desc": "Access files and folders anytime from your smartphone or tablet.",
          "sharefile_plugin": "ShareFile Plugin for Microsoft Outlook",
          "sharefile_plugin_desc": "Send large files securely directly from Outlook.",
          "total_security": "Total Security",
          "total_security_desc": "Have confidence in your data protection."
        },
        "form": {
          "account_name": "Account Name",
          "back_to_admin": "Back to account administration",
          "cancel_my_account": "Cancel my Account",
          "cancel_my_trial": "Cancel my Trial",
          "cancellation_reason": {
            "Lacks_required_compliance": "Lacks required compliance(s)",
            "lack_of_integrations": "Lack of integrations",
            "lacks_required_feature": "Lacks required feature(s)",
            "no_longer_needed": "No longer needed",
            "poor_account_support": "Poor account support (Sales, Technical)",
            "prefer_competitive_product": "Prefer competitive product",
            "security_concerns": "Security concerns",
            "technical_issues": "Technical issues",
            "too_difficult_to_use": "Too difficult to use",
            "too_expensive": "Too expensive"
          },
          "comments_label": "Comments",
          "comments_placeholder": "Care to tell us more about why you are cancelling your account? If you'd like, we would also love to know more about what we could do to make ShareFile better for you.",
          "employees_desc": "{{employeeCount}} of {{employeeMax}} purchased",
          "employees_title": "Employees",
          "forgot_your_password": "Forgot your password?",
          "more_info": "Please take a minute to tell us a little more about why you are cancelling your account.",
          "once_you_cancel": "Once you cancel, ShareFile will delete your files after 30 days.",
          "password_label": "Enter account password",
          "password_missing": "Please enter account password",
          "password_placeholder": "Password",
          "reason_missing": "Please select a reason",
          "required": "Required",
          "storage_usage_desc": "{{mbUsed}} MB of {{mbMax}} used as of {{dateFormatted}}",
          "storage_usage_title": "Storage Usage",
          "title": "I'm cancelling my ShareFile account because:",
          "to_authorize": "To authorize ShareFile to delete your files after 30 days, please enter your account password to continue with your account cancellation."
        },
        "in_progress_banner": "We’re working to update your account. This may take some time—check back soon!",
        "learn_more": "Learn More",
        "let_us_help_1": "Let us help you get more from your ShareFile account.",
        "let_us_help_2": "Contact our customer care team",
        "let_us_help_3": "to learn more about these and other ShareFile features.",
        "modal_confirm": "OK",
        "modal_message": "Your account has been canceled, but will remain active through the end of the billing cycle. You may reactivate your account by clicking \"Reactivate Account\" in the administrator menu.",
        "modal_message_trial": "Your trial has been canceled.  Thank you for trying ShareFile! You may reactivate your account by clicking \"Reactivate Account\" in the account administration menu.",
        "modal_title": "Account Canceled",
        "modal_title_trial": "Trial Canceled",
        "password_was_incorrect": "Password was incorrect",
        "resources_card": {
          "ask_the_community": "Ask the community",
          "sharefile_knowledgebase": "ShareFile knowledge base",
          "title": "Have you tried these resources?",
          "training_videos": "Training videos"
        },
        "sorry_to_go": "We're sorry to see you go!",
        "sorry_to_go_desc": "ShareFile is designed with you in mind, and we’re always trying to find ways to improve our service and meet your file-sharing and storage needs."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "An error has occurred",
        "live_chat": "live chat",
        "sales_team": "sales team"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Save 10%)",
          "choose_billing_cycle": "Choose your billing cycle",
          "choose_billing_cycle_text": "Price is based on total number of employee users.",
          "online_only": "(Online Only)",
          "pay_annually": "Pay annually",
          "pay_monthly": "Pay monthly"
        },
        "buttons": {
          "buy_now": "Buy now",
          "cancel": "Cancel",
          "continue": "Continue",
          "convert_now": "Convert now",
          "convert_now_tooltip": "Ensure address and credit card have been verified before converting."
        },
        "convert_modal": {
          "confirm_purchase": "Confirm Purchase",
          "confirm_purchase_description": "Selecting \"Convert now\" will charge you {<billingRate>} (plus applicable taxes) today, and your account will convert to a paid account."
        },
        "credit_card": {
          "add": "Add",
          "confirmed": "Credit card confirmed",
          "confirmed_description": "Your credit card information has been verified.",
          "declined": "Credit card declined",
          "declined_description": "We couldn't verify your card. Check that what you've entered is correct and try again.",
          "edit": "Edit",
          "error_message": "Credit card verification failed. Check the credit card information and try again.",
          "information": "Card information"
        },
        "current_licenses": "Employee Licenses: {{users}}",
        "current_storage": "Storage: {{storage}} GB",
        "employee_accounts": "Employee Accounts",
        "employee_accounts_description": "Your plan includes {{users}} employee accounts, you can add additional accounts to your plan below.",
        "employee_accounts_description_vdr": "Your plan includes {{users}} employee licenses and {{storage}} GB of storage. You can add more below.",
        "employee_licenses": "Employee Licenses",
        "employee_licenses_storage": "Employee Licenses and Storage",
        "error_loading_plans": "There was an error trying to load plans. Please try again later.",
        "left_nav_button_text": "Convert Free Trial",
        "month": "per month",
        "number_of_users_selection": {
          "title": "Number of users",
          "user_limit_message": "The selected plan allows a minimum of {{min}} users and a maximum of {{max}} users."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} Employee Accounts",
          "max_file_size": "100GB",
          "max_storage": "1TB/license",
          "max_storage_vdr": "1GB/license",
          "storage": "{{storage}} Storage"
        },
        "plan_chart": {
          "need_help": "Need help? We're here for you. Contact support at sales@sharefile.com or call 1 (800)-441-3453 for more plan options.",
          "upgrade_plan": "Upgrade Plan",
          "view_detailed_comparison": "View detailed comparison"
        },
        "plan_summary": {
          "annually": "Annually",
          "billing": "Billing",
          "monthly": "Monthly",
          "plan": "{{name}} Plan",
          "plus_applicable_taxes": "Final tax, if applicable, will be included in the invoice.",
          "storage_max_file_size": "Storage/Max file size: {<storage_details>}",
          "users": "Users",
          "your_total": "Your total"
        },
        "purchase_confirmed": "Purchase Confirmed",
        "something_went_wrong": "Something went wrong",
        "storage_distribution_description": "Storage is shared between all licensed employees and is not limited per user.",
        "storage_gb": "{{storage}} GB",
        "storage_only": "Storage",
        "successful_conversion": "You have successfully converted your account.",
        "title": "Convert Free Trial",
        "try_again_or_contact_support": "Please try again or contact support for further assistance.",
        "upgrade_failed": "Upgrade Failed"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Billing Address",
          "city": "City",
          "country": "Country",
          "state_province": "State / Province",
          "street": "Street Address",
          "zip_postal_code": "Zip / Postal Code"
        },
        "cancel": "Cancel",
        "credit_card": {
          "card_details": "Credit Card Details",
          "card_exp_date": "Expiration Date",
          "card_first_name": "First Name",
          "card_last_name": "Last Name",
          "card_number": "Card Number",
          "card_type": "Card Type",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "Credit card type not supported. Please use Visa, Mastercard or American Express",
          "card_type_unknown": "Unknown",
          "card_type_visa": "Visa",
          "title": "Credit Card Information"
        },
        "credit_card_notifications": {
          "add_successful": "Credit Card Information Added!",
          "save_failure": "Failed to save Credit Card Information",
          "update_failure": "Credit Card Information update failed",
          "update_successful": "Credit Card Information updated!"
        },
        "disable_trial_conversion_message": "Connect with our team to explore the best plan for your country. Reach out via {<live_chat>}.",
        "edit": "Edit",
        "get_billing_info_failed": "There was an error retrieving your billing information. Please try again later.",
        "info_banner": "Please Note: Updates to billing information may not be reflected immediately. Please allow up to 24 hours for any changes to appear below.",
        "left_nav_button_text": "Edit Billing Info",
        "name_on_card": "Name on Card",
        "no_billing_info_banner": "We aren't able to load this page right now. Contact our customer service team to edit your billing information.",
        "province": "Province",
        "save": "Save",
        "state": "State",
        "support": {
          "chat_with_us": "Chat with us",
          "contact_support": "Unable to verify address, please contact support.",
          "contact_support_info": "contact support"
        },
        "title": "Edit Billing Information",
        "update": "Update",
        "update_billing_type": {
          "info_message": "The current billing type is {<invoice>}. You may switch to credit card payments.",
          "invoice": "invoice",
          "switch_to_credit_card": "Switch to Credit Card",
          "title": "Update Billing Type"
        },
        "update_notifications": {
          "contact_support": "contact support",
          "save_failed": "Unable to save",
          "save_success": "Your changes have been saved.",
          "something_went_wrong": "Something went wrong",
          "try_again": "Unable to verify address, please try again.",
          "try_again_or_contact_support": "Please try again or {<contactSupport>} for further assistance."
        },
        "vat_id": "VAT ID",
        "verify_address": "Verify Address"
      },
      "expiration": {
        "account_canceled_first": "We cancel accounts when administrators ask us to, when billing is overdue, or when our terms of service have been violated.",
        "account_canceled_second": "This account and all of its data will be permanently deleted on (or shortly after) {{date}}. You can continue using your account until then to retrieve anything you have stored in ShareFile. Once we delete your account, all of the files and users associated with it will be unrecoverable.",
        "account_canceled_title": "This account has been canceled",
        "ask_to_purchase": "Ask to purchase",
        "continue_to_sharefile": "Continue to ShareFile",
        "logo_alt_text": "ShareFile logo",
        "notification_error_message": "Failed to send the notification to the admin. Please try again.",
        "purchase": {
          "error_modal": {
            "close": "Close",
            "sub_title": "Call us at 1-800-441-3453 to finish setting up your account. Mention error code {<errorCode>}.",
            "title": "We need a little more information"
          },
          "loading_modal": {
            "sub_title": "Hang tight while we finish setting everything up.",
            "title": "We're upgrading your ShareFile account"
          },
          "select_plan": "Select plan",
          "title": "Purchase ShareFile"
        },
        "purchase_account": "Purchase account",
        "reactivate_account": "Reactivate account",
        "request_reactivation": "Request reactivation",
        "request_sent": "Request sent",
        "something_went_wrong": "Something went wrong",
        "trial_ended_first": "Your trial period ended on {{date}}. To continue using ShareFile, purchase your account.",
        "trial_ended_second": "Please note that trial accounts are normally deleted 60 days after the trial ends. Once this happens, all of the files and users associated with your account will be unrecoverable.",
        "trial_ended_title": "Your trial has ended"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "one day",
          "day_count_plural": "{{count}} days",
          "days_left_in_your_trial": "You have {<dayCount>} left in your trial. ",
          "upgrade_to_a_plan": "Upgrade to a plan"
        }
      },
      "invalid_address_error": "The address you entered is invalid. Please try again.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "We weren't able to handle this request while a previous request is processing.",
      "manage_plan": {
        "add_storage_btn": "Add storage",
        "add_users_btn": "Add users",
        "advanced": {
          "description": "Secure File Sharing for Teams",
          "feature_access_control": "Granular access controls and basic reporting",
          "feature_encryption": "Encrypted file storage and sharing",
          "feature_secure_email": "Secure email integrations and real time co-editing",
          "features_header": "Key features:",
          "title": "Advanced",
          "title_0gb": "Advanced 0GB"
        },
        "connectors": {
          "title_0gb": "Connectors 0GB"
        },
        "contact_support": "Contact support for more plan options",
        "current_plan": "Current plan",
        "for_accounting": "For Accounting",
        "get_usageplan_failed": "There was an error retrieving your plan information. Please try again later.",
        "included": "Included",
        "industry_advantage": {
          "description": "Pre-Built, Accounting-Specific Document Workflow Automation",
          "feature_bulk_client_onboarding": "Bulk onboard clients for accounting engagements",
          "feature_centralized_view": "Centralized view of all engagements in one place",
          "feature_tax_templates": "Pre-built templates for tax engagements",
          "features_header": "All Premium features, plus:",
          "title": "Industry Advantage",
          "tooltip": "Tailor made workflows designed to facilitate seamless end-to-end use cases for accounting tax processes that increase efficiency and standardization"
        },
        "left_nav_button_text": "Manage Plan",
        "manage_plan_title": "Manage plan",
        "message_after_update": "We're working to update your plan. This may take some time—check back soon!",
        "modals": {
          "add_button": "Add",
          "additional_users": "Additional users",
          "alert_message": "If you choose {<boldText>}, we'll charge you a prorated amount for the difference in plan cost.",
          "annual_billing_note": "Your first annual payment will be due on {{date}}.",
          "annual_billing_text": "You can save 10% on your ShareFile plan by paying annually. Here's a summary of what your new plan costs would be.",
          "annual_billing_title": "Annual billing",
          "cancel_button": "Cancel",
          "error_alert": "We weren't able to update your plan. Please try again.",
          "extended_storage": "{{count}} TB extended storage",
          "new_billing_amount": "New billing amount",
          "new_monthly_total": "New monthly total",
          "new_plan_total": "New plan total",
          "new_storage_total": "New storage total",
          "new_user_total": "New user total",
          "per_month": "{{price}} per month*",
          "per_quarter": "{{price}} per quarter*",
          "per_year": "{{price}} per year*",
          "plus_applicable_taxes": "*plus applicable taxes",
          "price_per_TB": "{{price}} per 3 TB",
          "price_per_user": "{{price}} per user",
          "storage_add": "Add storage",
          "storage_data_breakdown_message": "You're currently using {<usedValue>} TB of your {<total>} TB of storage.",
          "storage_modal_title": "Add storage",
          "storage_need_additional": "Need additional storage?",
          "success_alert": "Updated plan.",
          "switch_to_annual_button": "Switch to annual billing",
          "upgrade_button": "Upgrade",
          "upgrade_plan_modal_title": "Upgrade plan",
          "users_add": "Add users",
          "users_count": "{{count}} users",
          "users_data_breakdown_message": "You're currently using {<usedValue>} of your {<total>} user licenses.",
          "users_modal_title": "Add users",
          "users_need_additional": "Need additional users?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "Most popular",
        "need_help": "Need help? We're here for you. {<contact_support>}",
        "next_billing_date_pending": "on your next billing date",
        "per_month": "per month",
        "per_quarter": "per quarter",
        "per_year": "per year",
        "plus_taxes": "*plus applicable taxes",
        "premium": {
          "description": "End-to-End Document Workflows for Teams and Clients",
          "feature_ai_powered": "AI-powered document automation and generation",
          "feature_client_portals": "Custom-branded client portals",
          "feature_hippa_finra_support": "Support for HIPAA, FINRA and SEC regulatory compliance",
          "feature_tools": "Client collaboration tools - e-signature, requests, tasks, forms, workflow automation",
          "features_header": "All Advanced features, plus:",
          "title": "Premium"
        },
        "save_with_annual_btn": "Save 10% with annual billing",
        "standard": {
          "feature_all_storage": "All the storage you need",
          "feature_file_encryption": "File encryption",
          "feature_sync_edit_share": "Sync, edit, share",
          "feature_unlimited_client": "Unlimited client users",
          "features_header": "Features include:",
          "title": "Standard",
          "title_0gb": "Standard 0GB"
        },
        "storage": "Storage",
        "storage_per_user": "{{storage}} per user",
        "upgrade_btn": "Upgrade",
        "upgrade_plan": "Upgrade plan",
        "users": "Users",
        "users_count": "{{count}} users",
        "users_count_one": "{{count}} user",
        "vdr": {
          "feature_click_trails": "Click trails",
          "feature_folder_qa": "Folder Q&A",
          "feature_visibility_analytics": "Visibility, analytics, and more",
          "features_header": "Specialized protection, including:",
          "title": "Virtual data room"
        }
      },
      "payment_gateway": {
        "authorization_error": "We couldn’t verify your card. Check that what you’ve entered is correct and try again.",
        "authorization_error_title": "Card verification failed",
        "contact_details": "Contact details",
        "form": {
          "card_number": "Card number",
          "cardholder_name": "Cardholder name",
          "date_validation": {
            "expired": "Card is expired",
            "invalid_date": "Invalid date",
            "invalid_month": "Invalid month",
            "no_date_provided": "Please enter exp date"
          },
          "expiration_date": "Exp date",
          "payment_details": "Payment details",
          "payment_details_description": "{<asterisk>} indicates a required field",
          "security_code": "Security code",
          "security_code_description": "3 digits on the back of the card or 4 digits on the front of the card"
        },
        "iframe_description": "Click ”New” to add a new payment card.",
        "iframe_load_error": "There was an error loading your credit card details. Please try again later or contact support.",
        "modal_title": "Enter payment details",
        "modal_title_legacy": "Add / Edit payment card"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Account Name:",
          "account_owner_label": "Account Owner:",
          "allocated_licenses_label": "Allocated Licenses:",
          "billing_cycle_month": "Month",
          "billing_cycle_quarter": "Quarter",
          "billing_cycle_year": "Year",
          "cancel": "Cancel",
          "esig_licenses_out_of": "{{count}} out of {{max}} e-signature licenses used",
          "id_label": "ID:",
          "licenses_out_of": "{{count}} out of {{max}} employee licenses used",
          "next_billing_date_label": "Next Billing Date: ",
          "plan_label": "Plan:",
          "save": "Save",
          "title": "Account Summary",
          "total_billing_cost_info_label": "This is the total cost for all of your organization's ShareFile products.",
          "total_billing_cost_label": "Total Billing Cost:",
          "view_receipts_label": "View Receipts"
        },
        "cancel": "Cancel",
        "description": "Reactivating your account will keep your services active and re-enable billing on your account.",
        "left_nav_button_text": "Reactivate Account",
        "lock_error": "We weren't able to handle this request while a previous request is processing.",
        "page_title": "Reactivate Account",
        "reactivate_button": "Reactivate",
        "reactivate_failed": "Your account cannot be reactivated, please contact our support team at sales@sharefile.com or call 1 (800)-441-3453.",
        "reactivate_success": "Your account has been reactivated."
      },
      "receipts": {
        "actions": {
          "download": "Download",
          "pay": "Pay",
          "title": "Actions"
        },
        "awaiting_payment_tooltip": "Invoices might take up to 24 hours to show as paid on this page.",
        "billing_system_change": "We recently made changes to our billing systems that will affect how you pay your ShareFile invoices. For all invoices posted after {<migrationDate>} there is a direct payment link in the invoice file. Invoices posted before {<migrationDate>} will not contain this link; please contact support to make a payment.",
        "cancel": "Cancel",
        "credit_card_notifications": {
          "payment_approved": "Payment approved. Thank you!",
          "payment_failure": "Credit card payment failed. Please reach out to support."
        },
        "date": "Date added",
        "email": "Email",
        "error_getting_logs": "There was an error getting your billing receipts. Please try again later.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Receipts and Billing Notifications",
        "open_payment": "Your account has an open payment.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "This page has a list of all your ShareFile billing receipts. Invoices might take up to 24 hours to show as paid on this page.",
        "page_title": "Receipts and billing notifications",
        "pay_now": "pay",
        "phone": "Phone",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "Status",
        "status_approved": "Approved",
        "status_awaiting_payment": "Awaiting payment",
        "status_cleared": "Cleared",
        "status_failed": "Failed",
        "status_invoice_payment_received": "Invoice payment received",
        "status_negated": "Negated",
        "status_open": "Open",
        "status_paid": "Paid",
        "status_pending": "Pending",
        "status_tax_credited": "Tax credited",
        "status_tax_negated": "Tax negated",
        "status_transaction_credited": "Transaction credited",
        "type": "Type"
      }
    }
  },
  {
    "key": "es",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Dirección de la cuenta",
        "address_information": "Información sobre la dirección",
        "billing_address_same_message": "La dirección de facturación es la misma que la dirección de la cuenta.",
        "buy_canada_tax_free": "¿Comprar en Canadá sin impuestos?",
        "buy_canada_tax_free_description": "Los números GST/HST y QST eximirán su compra de impuestos. Si no rellena estos números, se aplicarán impuestos a su compra. Para compras en Columbia Británica, Manitoba y Saskatchewan, se requiere una validación del certificado. Por favor, envíelos a {<contact_email>} antes de completar su compra. Nos pondremos en contacto con usted lo antes posible.",
        "city": "Ciudad",
        "country": "País",
        "country_not_supported_message": "Para cambiar de país, póngase en contacto con nuestro {<sales_team>} para obtener ayuda.",
        "disable_trial_conversion_message": "Comuníquese con nuestro equipo para estudiar el mejor plan para su país. Póngase en contacto a través de {<live_chat>}.",
        "enter_address_manually": "Introduzca la dirección de forma manual.",
        "european_vat_id": "ID de IVA europeo",
        "gst_hst_number": "Número de registro GST/HST",
        "postal_code": "Código postal",
        "province": "Provincia",
        "pst_number": "Número de registro PST",
        "qst_number": "Número de registro QST",
        "sfi_message": "¿Es usted una institución financiera seleccionada (SLFI)?",
        "state": "Estado",
        "street": "Domicilio",
        "suggestions_attribution": "Sugerencias de Google",
        "suggestions_not_found": "No se ha encontrado la dirección. Vuelva a intentarlo o introduzca su dirección de forma manual.",
        "tax_tooltip": "Introduzca aquí el identificador fiscal de su empresa. Esto ayuda a garantizar el correcto tratamiento fiscal de sus facturas.",
        "title": "Dirección de facturación",
        "validation_message": {
          "city_required": "La Ciudad es obligatoria.",
          "country_required": "El País es obligatorio.",
          "province_required": "La Provincia es obligatoria.",
          "state_required": "El Estado es obligatorio.",
          "street_required": "Introduzca su domicilio.",
          "tax_invalid": "No hemos podido validar su identificador fiscal de su empresa. Revise y vuelva a intentarlo.",
          "zip_required": "El código postal es obligatorio."
        },
        "zip": "Código postal"
      },
      "call_to_action": {
        "cancel": "Cancelar",
        "clear": "Borrar",
        "submit": "Enviar"
      },
      "cancel_account": {
        "cancel_account": "Cancelar cuenta",
        "cancel_trial": "Cancelar evaluación",
        "contact_information": {
          "call_international": "Llamadas internacionales: +1 919.745.6111",
          "call_toll_free": "Llamada gratuita: 1.800.441.3453",
          "call_uk": "Reino Unido: +44 (0800) 680.0621",
          "here_for_you": "Estamos a su disposición",
          "visit_support": "Visitar la asistencia técnica"
        },
        "contact_us": "Contáctenos",
        "continue_cancellation": "Continuar con la cancelación",
        "did_you_know": "¿Lo sabía?",
        "did_you_know_desc": "Al cancelar la cuenta de ShareFile, ya no podrá usar sus excelentes funciones, como:",
        "download_now": "Descargar ahora",
        "error_banner": "No se pudo cancelar. Inténtelo de nuevo o comuníquese con nuestro equipo de asistencia técnica.",
        "features": {
          "customer_access": "Acceso ilimitado para sus clientes",
          "customer_access_desc": "Permita a sus clientes acceder a archivos gratis y controle qué archivos pueden ver.",
          "customer_support": "Atención al cliente",
          "customer_support_desc": "por correo electrónico o por teléfono: ¡estamos aquí para ayudarle!",
          "esignature": "Firma electrónica",
          "esignature_desc": "Enviar archivos para firmar directamente desde su cuenta de ShareFile.",
          "sharefile_mobile": "Aplicaciones móviles de ShareFile",
          "sharefile_mobile_desc": "Acceder a sus archivos y carpeta en cualquier momento desde su smartphone o tableta.",
          "sharefile_plugin": "ShareFile Plug-in para Microsoft Outlook",
          "sharefile_plugin_desc": "Enviar archivos grandes con total seguridad directamente desde Outlook.",
          "total_security": "Seguridad total",
          "total_security_desc": "Puede confiar en la protección de sus datos."
        },
        "form": {
          "account_name": "Nombre de cuenta",
          "back_to_admin": "Volver a Administración de cuentas",
          "cancel_my_account": "Cancelar mi cuenta",
          "cancel_my_trial": "Cancelar mi evaluación",
          "cancellation_reason": {
            "Lacks_required_compliance": "Falta de conformidad o conformidades necesarias",
            "lack_of_integrations": "Falta de integraciones",
            "lacks_required_feature": "Falta de función o funciones necesarias",
            "no_longer_needed": "Ya no se necesita",
            "poor_account_support": "Asistencia deficiente a las cuentas (Ventas, Técnica)",
            "prefer_competitive_product": "Preferencia por un producto de la competencia",
            "security_concerns": "Preocupación por la seguridad",
            "technical_issues": "Problemas técnicos",
            "too_difficult_to_use": "Demasiado difícil de usar",
            "too_expensive": "Demasiado costoso"
          },
          "comments_label": "Comentarios",
          "comments_placeholder": "¿Le importaría contarnos un poco por qué quiere cancelar la cuenta? Si quiere, cuéntenos también qué podemos hacer para mejorar ShareFile para usted.",
          "employees_desc": "{{employeeCount}} de {{employeeMax}} adquiridas",
          "employees_title": "Empleados",
          "forgot_your_password": "¿Olvidó la contraseña?",
          "more_info": "Nos gustaría pedirle que dedique un momento a contarnos por qué quiere cancelar su cuenta.",
          "once_you_cancel": "Una vez cancelada la cuenta, ShareFile eliminará sus archivos al cabo de 30 días.",
          "password_label": "Introducir la contraseña de la cuenta",
          "password_missing": "Introduzca una contraseña de la cuenta",
          "password_placeholder": "Contraseña",
          "reason_missing": "Seleccione un motivo",
          "required": "Requerido",
          "storage_usage_desc": "{{mbUsed}} MB de {{mbMax}} utilizados a partir de {{dateFormatted}}",
          "storage_usage_title": "Uso del almacenamiento",
          "title": "Cancelo mi cuenta de ShareFile porque:",
          "to_authorize": "Para autorizar a ShareFile a eliminar sus archivos al cabo de 30 días, introduzca la contraseña de su cuenta y continuar así con la cancelación de la misma."
        },
        "in_progress_banner": "Estamos trabajando para actualizar su cuenta. Esto podría tardar algún tiempo. Vuelva pronto.",
        "learn_more": "Más información",
        "let_us_help_1": "Permítanos ayudarle a sacar más partido de su cuenta de ShareFile.",
        "let_us_help_2": "Contacte con nuestro equipo de Atención al cliente",
        "let_us_help_3": "para obtener más información sobre éstas y otras características de ShareFile.",
        "modal_confirm": "Aceptar",
        "modal_message": "Su cuenta se canceló, pero permanecerá activa hasta el final del ciclo de facturación. Puede reactivar su cuenta haciendo clic en \"Reactivar cuenta\" en el menú del administrador.",
        "modal_message_trial": "La evaluación se ha cancelado.  ¡Gracias por probar ShareFile! Puede reactivar su cuenta haciendo clic en \"Reactivar cuenta\" en el menú de Administración de cuentas.",
        "modal_title": "Cuenta cancelada",
        "modal_title_trial": "Evaluación cancelada",
        "password_was_incorrect": "La contraseña era incorrecta",
        "resources_card": {
          "ask_the_community": "Preguntar a la comunidad",
          "sharefile_knowledgebase": "Base de conocimientos de ShareFile",
          "title": "¿Ha probado a usar estos recursos?",
          "training_videos": "Vídeos de formación"
        },
        "sorry_to_go": "¡Sentimos que se vaya!",
        "sorry_to_go_desc": "ShareFile está diseñado teniendo en cuenta las necesidades del usuario y estamos continuamente buscando maneras de mejorar nuestro servicio y de satisfacer las necesidades de uso compartido y almacenamiento de archivos."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "Ha ocurrido un error",
        "live_chat": "chat en directo",
        "sales_team": "equipo de ventas"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Ahorre un 10 %)",
          "choose_billing_cycle": "Seleccione su ciclo de facturación",
          "choose_billing_cycle_text": "El precio se basa en el número total de usuarios empleados.",
          "online_only": "(Solo con conexión)",
          "pay_annually": "Pago anual",
          "pay_monthly": "Pago mensual"
        },
        "buttons": {
          "buy_now": "Comprar ahora",
          "cancel": "Cancelar",
          "continue": "Continuar",
          "convert_now": "Convertir ahora",
          "convert_now_tooltip": "Asegúrese de que la dirección y la tarjeta de crédito se hayan verificado antes de la conversión."
        },
        "convert_modal": {
          "confirm_purchase": "Confirmar la compra",
          "confirm_purchase_description": "Si selecciona «Convertir ahora», se le cobrará {<billingRate>} (más impuestos aplicables) hoy mismo, y su cuenta se convertirá en una cuenta de pago."
        },
        "credit_card": {
          "add": "Agregar",
          "confirmed": "Tarjeta de crédito confirmada",
          "confirmed_description": "La información de su tarjeta de crédito ha sido verificada.",
          "declined": "Tarjeta de crédito rechazada",
          "declined_description": "No hemos podido verificar su tarjeta. Compruebe que los datos introducidos sean correctos y vuelva a intentarlo.",
          "edit": "Modificar",
          "error_message": "Error al verificar la tarjeta de crédito. Compruebe la información de la tarjeta de crédito e inténtelo de nuevo.",
          "information": "Información de la tarjeta"
        },
        "current_licenses": "Licencias de empleado: {{users}}",
        "current_storage": "Almacenamiento: {{storage}} GB",
        "employee_accounts": "Cuentas de empleado",
        "employee_accounts_description": "Su plan incluye {{users}} cuentas de empleado, puede agregar cuentas adicionales a su plan a continuación.",
        "employee_accounts_description_vdr": "Su plan incluye {{users}} licencias para empleados y {{storage}} GB de almacenamiento. Puede agregar más licencias a continuación.",
        "employee_licenses": "Licencias de empleado",
        "employee_licenses_storage": "Licencias de empleado y almacenamiento",
        "error_loading_plans": "Hubo un error al intentar cargar los planes. Inténtelo de nuevo más tarde.",
        "left_nav_button_text": "Convertir la evaluación gratuita",
        "month": "por mes",
        "number_of_users_selection": {
          "title": "Número de usuarios",
          "user_limit_message": "El plan seleccionado permite un mínimo de {{min}} usuarios y un máximo de {{max}} usuarios."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} Cuentas de empleado",
          "max_file_size": "100 GB",
          "max_storage": "1TB/licencia",
          "max_storage_vdr": "1TB/licencia",
          "storage": "Almacenamiento de {{storage}}"
        },
        "plan_chart": {
          "need_help": "¿Necesita ayuda? Estamos aquí para ayudarle. Póngase en contacto con la Asistencia técnica en sales@sharefile.com o llame al 1 (800)-441-3453 para conocer más opciones de planes.",
          "upgrade_plan": "Actualizar plan",
          "view_detailed_comparison": "Ver comparación detallada"
        },
        "plan_summary": {
          "annually": "Anual",
          "billing": "Facturación",
          "monthly": "Mensual",
          "plan": "Plan {{name}}",
          "plus_applicable_taxes": "Los impuestos finales, si corresponden, se incluirán en la factura.",
          "storage_max_file_size": "Tamaño de archivo máx./de almacenamiento: {<storage_details>}",
          "users": "Usuarios",
          "your_total": "Su total"
        },
        "purchase_confirmed": "Compra confirmada",
        "something_went_wrong": "Se ha producido un problema",
        "storage_distribution_description": "El almacenamiento se comparte entre todos los empleados con licencia y no está limitado por usuario.",
        "storage_gb": "{{storage}} GB",
        "storage_only": "Almacenamiento",
        "successful_conversion": "Ha convertido correctamente su cuenta.",
        "title": "Convertir la evaluación gratuita",
        "try_again_or_contact_support": "Inténtelo de nuevo o póngase en contacto con la Asistencia técnica para obtener más ayuda.",
        "upgrade_failed": "Falló la actualización"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Dirección de facturación",
          "city": "Ciudad",
          "country": "País",
          "state_province": "Estado/Provincia",
          "street": "Domicilio",
          "zip_postal_code": "Código postal/zip"
        },
        "cancel": "Cancelar",
        "credit_card": {
          "card_details": "Detalles de la tarjeta de crédito",
          "card_exp_date": "Fecha de caducidad",
          "card_first_name": "Nombre",
          "card_last_name": "Apellido",
          "card_number": "Número de tarjeta",
          "card_type": "Tipo de tarjeta",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "No se admite este tipo de tarjeta de crédito. Utilice Visa, Mastercard o American Express.",
          "card_type_unknown": "Desconocido",
          "card_type_visa": "Visa",
          "title": "Información de la tarjeta de crédito"
        },
        "credit_card_notifications": {
          "add_successful": "Se ha agregado la información de la tarjeta de crédito",
          "save_failure": "Error al guardar la información de la tarjeta de crédito",
          "update_failure": "Error al actualizar la información de la tarjeta de crédito",
          "update_successful": "Se ha actualizado la información de la tarjeta de crédito"
        },
        "disable_trial_conversion_message": "Comuníquese con nuestro equipo para estudiar el mejor plan para su país. Póngase en contacto a través de {<live_chat>}.",
        "edit": "Modificar",
        "get_billing_info_failed": "Hubo un error al obtener la información de facturación. Inténtelo de nuevo más tarde.",
        "info_banner": "Nota: Es posible que las actualizaciones de la información de facturación no se reflejen inmediatamente. Los cambios pueden tardar hasta 24 horas en aparecer aquí.",
        "left_nav_button_text": "Modificar información de facturación",
        "name_on_card": "Nombre en la tarjeta",
        "no_billing_info_banner": "No se puede cargar la página en este momento. Contacte con nuestro servicio de Atención al cliente para modificar los datos de facturación.",
        "province": "Provincia",
        "save": "Guardar",
        "state": "Estado",
        "support": {
          "chat_with_us": "Hable por chat con nosotros",
          "contact_support": "No se puede verificar la dirección. Póngase en contacto con la Asistencia técnica.",
          "contact_support_info": "póngase en contacto con la Asistencia técnica"
        },
        "title": "Modificar información de facturación",
        "update": "Actualizar",
        "update_billing_type": {
          "info_message": "El tipo de facturación actual es {<invoice>}. Puede cambiar a pagos con tarjeta de crédito.",
          "invoice": "factura",
          "switch_to_credit_card": "Cambiar a tarjeta de crédito",
          "title": "Actualizar tipo de facturación"
        },
        "update_notifications": {
          "contact_support": "póngase en contacto con la Asistencia técnica",
          "save_failed": "No se puede guardar",
          "save_success": "Sus cambios se han guardado.",
          "something_went_wrong": "Se ha producido un problema",
          "try_again": "No se puede verificar la dirección. Inténtelo de nuevo.",
          "try_again_or_contact_support": "Inténtelo de nuevo o contacte con {<contactSupport>} para obtener más ayuda."
        },
        "vat_id": "ID de IVA",
        "verify_address": "Verificar dirección"
      },
      "expiration": {
        "account_canceled_first": "Cancelamos las cuentas cuando los administradores nos lo piden, cuando la facturación está atrasada o cuando se han infringido nuestras condiciones de servicio.",
        "account_canceled_second": "Esta cuenta y todos sus datos se eliminarán permanentemente el (o inmediatamente después del) {{date}}. Puede seguir utilizando su cuenta hasta entonces para recuperar todo lo que haya almacenado en ShareFile. Una vez que eliminemos su cuenta, todos los archivos y usuarios asociados a ésta serán irrecuperables.",
        "account_canceled_title": "Esta cuenta ha sido cancelada",
        "ask_to_purchase": "Solicitar la compra",
        "continue_to_sharefile": "Continuar con ShareFile",
        "logo_alt_text": "Logotipo de ShareFile",
        "notification_error_message": "No se pudo enviar la notificación al administrador. Inténtelo de nuevo.",
        "purchase": {
          "error_modal": {
            "close": "Cerrar",
            "sub_title": "Llámenos al 1-800-441-3453 para terminar de configurar su cuenta. Mencione el código de error {<errorCode>}.",
            "title": "Necesitamos un poco más de información"
          },
          "loading_modal": {
            "sub_title": "Espere mientras terminamos de configurar todo.",
            "title": "Estamos actualizando su cuenta de ShareFile"
          },
          "select_plan": "Seleccionar plan",
          "title": "Comprar ShareFile"
        },
        "purchase_account": "Cuenta de compras",
        "reactivate_account": "Reactivar cuenta",
        "request_reactivation": "Solicitud de reactivación",
        "request_sent": "Solicitud enviada",
        "something_went_wrong": "Se ha producido un problema",
        "trial_ended_first": "Su periodo de prueba finalizó el {{date}}. Para seguir utilizando ShareFile, compre su cuenta.",
        "trial_ended_second": "Recuerde que las cuentas de prueba se eliminan normalmente 60 días después de que finaliza la prueba. Una vez que esto ocurra, todos los archivos y usuarios asociados a su cuenta serán irrecuperables.",
        "trial_ended_title": "Su prueba ha caducado"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "un día",
          "day_count_plural": "{{count}} d",
          "days_left_in_your_trial": "En su evaluación le queda {<dayCount>}. ",
          "upgrade_to_a_plan": "Actualizar a un plan"
        }
      },
      "invalid_address_error": "La dirección introducida no es válida. Inténtelo de nuevo.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "No pudimos gestionar esta solicitud mientras se procesaba una solicitud anterior.",
      "manage_plan": {
        "add_storage_btn": "Agregar almacenamiento",
        "add_users_btn": "Agregar usuarios",
        "advanced": {
          "description": "Transferencia segura de archivos para equipos",
          "feature_access_control": "Controles de acceso pormenorizados y generación de informes básicos",
          "feature_encryption": "Almacenamiento y uso compartido de archivos encriptados",
          "feature_secure_email": "Integraciones seguras de correo electrónico y coedición en tiempo real",
          "features_header": "Funciones principales:",
          "title": "Advanced",
          "title_0gb": "Advanced 0 GB"
        },
        "connectors": {
          "title_0gb": "Conectores 0 GB"
        },
        "contact_support": "Póngase en contacto con la asistencia técnica para conocer más opciones de planes",
        "current_plan": "Plan actual",
        "for_accounting": "Para contabilidad",
        "get_usageplan_failed": "Hubo un error al obtener la información sobre su plan. Inténtelo de nuevo más tarde.",
        "included": "Incluido",
        "industry_advantage": {
          "description": "Automatización de flujos de trabajo de documentos preconfigurados, específicos para contabilidad",
          "feature_bulk_client_onboarding": "Incorporación masiva de clientes para compromisos contables",
          "feature_centralized_view": "Vista centralizada de todos los compromisos en un solo lugar",
          "feature_tax_templates": "Plantillas preconfiguradas para compromisos fiscales",
          "features_header": "Todas las funciones Premium, y además:",
          "title": "Industry Advantage",
          "tooltip": "Flujos de trabajo personalizados, diseñados para facilitar casos de uso fluidos de extremo a extremo en procesos contables y fiscales que aumentan la eficiencia y la estandarización"
        },
        "left_nav_button_text": "Administrar plan",
        "manage_plan_title": "Administrar plan",
        "message_after_update": "Estamos trabajando para actualizar su plan. Esto podría tardar algún tiempo. Vuelva pronto.",
        "modals": {
          "add_button": "Agregar",
          "additional_users": "Usuarios adicionales",
          "alert_message": "Si elige {<boldText>}, le cobraremos una cantidad prorrateada por la diferencia en el costo del plan.",
          "annual_billing_note": "Su primer pago anual vencerá el {{date}}.",
          "annual_billing_text": "Puede ahorrar un 10 % en su plan de ShareFile con el pago anual. Aquí puede ver un resumen de lo que costaría el nuevo plan.",
          "annual_billing_title": "Facturación anual",
          "cancel_button": "Cancelar",
          "error_alert": "No pudimos actualizar su plan. Inténtelo de nuevo.",
          "extended_storage": "Almacenamiento ampliado de {{count}} TB",
          "new_billing_amount": "Nuevo importe de facturación",
          "new_monthly_total": "Nuevo total mensual",
          "new_plan_total": "Nuevo total del plan",
          "new_storage_total": "Nuevo total de almacenamiento",
          "new_user_total": "Nuevo total de usuarios",
          "per_month": "{{price}} al mes*",
          "per_quarter": "{{price}} por trimestre*",
          "per_year": "{{price}} al año*",
          "plus_applicable_taxes": "* más impuestos aplicables",
          "price_per_TB": "{{price}} por 3 TB",
          "price_per_user": "{{price}} por usuario",
          "storage_add": "Agregar almacenamiento",
          "storage_data_breakdown_message": "Actualmente está usando {<usedValue>} TB de su almacenamiento de {<total>} TB.",
          "storage_modal_title": "Agregar almacenamiento",
          "storage_need_additional": "¿Necesita almacenamiento adicional?",
          "success_alert": "Plan actualizado.",
          "switch_to_annual_button": "Cambiar a facturación anual",
          "upgrade_button": "Actualizar",
          "upgrade_plan_modal_title": "Actualizar plan",
          "users_add": "Agregar usuarios",
          "users_count": "Usuarios: {{count}}",
          "users_data_breakdown_message": "Está usando {<usedValue>} de sus {<total>} licencias de usuario.",
          "users_modal_title": "Agregar usuarios",
          "users_need_additional": "¿Necesita usuarios adicionales?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "Lo más popular",
        "need_help": "¿Necesita ayuda? Estamos a su disposición. {<contact_support>}",
        "next_billing_date_pending": "en su próxima fecha de facturación",
        "per_month": "por mes",
        "per_quarter": "por trimestre",
        "per_year": "por año",
        "plus_taxes": "* más impuestos aplicables",
        "premium": {
          "description": "Flujos de trabajo de documentos de extremo a extremo para equipos y clientes",
          "feature_ai_powered": "Automatización y generación de documentos impulsadas por IA",
          "feature_client_portals": "Portales de clientes personalizados",
          "feature_hippa_finra_support": "Conformidad con el cumplimiento de las normativas HIPAA, FINRA y SEC",
          "feature_tools": "Herramientas de colaboración con el cliente: firma electrónica, solicitudes, tareas, formularios, automatización de flujos de trabajo",
          "features_header": "Todas las funciones de Advanced, y además:",
          "title": "Premium"
        },
        "save_with_annual_btn": "Ahorre un 10 % con la facturación anual",
        "standard": {
          "feature_all_storage": "Todo el almacenamiento que necesita",
          "feature_file_encryption": "Cifrado de archivos",
          "feature_sync_edit_share": "Sincronizar, modificar, compartir",
          "feature_unlimited_client": "Usuarios clientes ilimitados",
          "features_header": "Las funciones incluyen:",
          "title": "Standard",
          "title_0gb": "Standard 0 GB"
        },
        "storage": "Almacenamiento",
        "storage_per_user": "{{storage}} por usuario",
        "upgrade_btn": "Actualizar",
        "upgrade_plan": "Actualizar plan",
        "users": "Usuarios",
        "users_count": "Usuarios: {{count}}",
        "users_count_one": "usuario {{count}}",
        "vdr": {
          "feature_click_trails": "Rastro de clics",
          "feature_folder_qa": "Carpeta Preguntas y respuestas",
          "feature_visibility_analytics": "Visibilidad, análisis y más",
          "features_header": "Protección especializada, que incluye:",
          "title": "Virtual data room"
        }
      },
      "payment_gateway": {
        "authorization_error": "No hemos podido verificar su tarjeta. Compruebe que los datos introducidos sean correctos y vuelva a intentarlo.",
        "authorization_error_title": "Falló la verificación de la tarjeta",
        "contact_details": "Detalles del contacto",
        "form": {
          "card_number": "Número de tarjeta",
          "cardholder_name": "Nombre del titular de la tarjeta",
          "date_validation": {
            "expired": "La tarjeta ha caducado",
            "invalid_date": "Fecha no válida",
            "invalid_month": "Mes no válido",
            "no_date_provided": "Introduzca la fecha de caducidad"
          },
          "expiration_date": "Fecha de caducidad",
          "payment_details": "Detalles del pago",
          "payment_details_description": "{<asterisk>} indica un campo obligatorio",
          "security_code": "Código de seguridad",
          "security_code_description": "3 dígitos en el reverso de la tarjeta o 4 dígitos en el anverso de la tarjeta"
        },
        "iframe_description": "Haga clic en «Nueva» para agregar una nueva tarjeta de pago.",
        "iframe_load_error": "Se produjo un error al cargar los datos de su tarjeta de crédito. Inténtelo de nuevo más tarde o póngase en contacto con la Asistencia técnica.",
        "modal_title": "Introduzca los detalles del pago",
        "modal_title_legacy": "Agregar/ Modificar tarjeta de pago"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Nombre de la cuenta:",
          "account_owner_label": "Propietario de la cuenta:",
          "allocated_licenses_label": "Licencias asignadas:",
          "billing_cycle_month": "Mes",
          "billing_cycle_quarter": "Trimestre",
          "billing_cycle_year": "Año",
          "cancel": "Cancelar",
          "esig_licenses_out_of": "{{count}} de {{max}} licencias de firma electrónica utilizadas",
          "id_label": "ID:",
          "licenses_out_of": "{{count}} de {{max}} licencias de empleado utilizadas",
          "next_billing_date_label": "Siguiente fecha de facturación: ",
          "plan_label": "Plan:",
          "save": "Guardar",
          "title": "Resumen de cuenta",
          "total_billing_cost_info_label": "Este es el coste total de todos los productos ShareFile de su organización.",
          "total_billing_cost_label": "Coste total de facturación:",
          "view_receipts_label": "Ver recibos"
        },
        "cancel": "Cancelar",
        "description": "La reactivación de su cuenta mantendrá sus servicios activos y volverá a habilitar la facturación.",
        "left_nav_button_text": "Reactivar cuenta",
        "lock_error": "No pudimos gestionar esta solicitud mientras se procesaba una solicitud anterior.",
        "page_title": "Reactivar cuenta",
        "reactivate_button": "Reactivar",
        "reactivate_failed": "No se puede reactivar su cuenta, póngase en contacto con nuestro equipo de asistencia en sales@sharefile.com o llame al 1 (800)-441-3453.",
        "reactivate_success": "Su cuenta se ha reactivado."
      },
      "receipts": {
        "actions": {
          "download": "Descargar",
          "pay": "Pagar",
          "title": "Acciones"
        },
        "awaiting_payment_tooltip": "Las facturas pueden tardar hasta 24 horas en aparecer como ya pagadas en esta página.",
        "billing_system_change": "Recientemente hemos realizado cambios en nuestros sistemas de facturación que afectarán la forma de pagar las facturas de ShareFile. Para todas las facturas publicadas después del {<migrationDate>} hay un enlace de pago directo en el archivo de la factura. Las facturas enviadas antes del {<migrationDate>} no contendrán este enlace; póngase en contacto con la Asistencia técnica para realizar un pago.",
        "cancel": "Cancelar",
        "credit_card_notifications": {
          "payment_approved": "Pago aprobado. Gracias.",
          "payment_failure": "Error en el pago con tarjeta de crédito. Contacte con la asistencia técnica."
        },
        "date": "Fecha agregada",
        "email": "Correo electrónico",
        "error_getting_logs": "Hubo un error al recibir los recibos de facturación. Inténtelo de nuevo más tarde.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Recibos y notificaciones de facturación",
        "open_payment": "Su cuenta tiene un pago abierto.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "Esta página contiene una lista de todos sus recibos de facturación de ShareFile. Las facturas pueden tardar hasta 24 horas en aparecer como ya pagadas en esta página.",
        "page_title": "Recibos y notificaciones de facturación",
        "pay_now": "pagar",
        "phone": "Teléfono",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "Estado",
        "status_approved": "Aprobado",
        "status_awaiting_payment": "Pendiente de pago",
        "status_cleared": "Pagado",
        "status_failed": "Falló",
        "status_invoice_payment_received": "Pago de factura recibido",
        "status_negated": "Anulado",
        "status_open": "Abierto",
        "status_paid": "Pagado",
        "status_pending": "Pendiente",
        "status_tax_credited": "Impuesto abonado",
        "status_tax_negated": "Impuesto anulado",
        "status_transaction_credited": "Transacción abonada",
        "type": "Tipo"
      }
    }
  },
  {
    "key": "fr",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Adresse du compte",
        "address_information": "Coordonnées",
        "billing_address_same_message": "L’adresse de facturation est la même que l’adresse du compte.",
        "buy_canada_tax_free": "Acheter sans taxe au Canada ?",
        "buy_canada_tax_free_description": "En indiquant vos numéros de GST/HST et de QST, vous pourrez bénéficier d’une exonération de taxes sur votre achat. Si vous ne remplissez pas ces numéros, la taxe sera appliquée à votre achat. Pour les achats effectués en Colombie-Britannique, au Manitoba et en Saskatchewan, une validation du certificat est requise. Veuillez nous les renvoyer à l’adresse {<contact_email>} avant de finaliser votre achat. Nous vous répondrons dans les plus brefs délais.",
        "city": "Ville",
        "country": "Pays",
        "country_not_supported_message": "Pour choisir un autre pays, veuillez contacter notre {<sales_team>}.",
        "disable_trial_conversion_message": "Contactez notre équipe pour étudier le meilleur forfait pour votre pays. Contactez-nous via {<live_chat>}.",
        "enter_address_manually": "Entrez l’adresse manuellement",
        "european_vat_id": "N° de TVA européen",
        "gst_hst_number": "Numéro d’enregistrement aux fins de la GST/HST",
        "postal_code": "Code postal",
        "province": "Province",
        "pst_number": "Numéro d’enregistrement PST",
        "qst_number": "Numéro d’enregistrement QST",
        "sfi_message": "Êtes-vous une institution financière désignée (SLFI) ?",
        "state": "État",
        "street": "Rue",
        "suggestions_attribution": "Suggestions fournies par Google",
        "suggestions_not_found": "Adresse introuvable. Veuillez réessayer ou saisir votre adresse manuellement.",
        "tax_tooltip": "Entrez ici le numéro d’identification fiscale de votre entreprise. Cela permet de garantir le traitement fiscal adéquat de vos factures.",
        "title": "Adresse de facturation",
        "validation_message": {
          "city_required": "La ville est requise.",
          "country_required": "Le pays est requis.",
          "province_required": "La province est requise.",
          "state_required": "L’État est requis.",
          "street_required": "Veuillez saisir votre adresse postale.",
          "tax_invalid": "Nous n’avons pas pu valider votre numéro d’identification fiscale. Veuillez vérifier et réessayer.",
          "zip_required": "Le code postal est requis."
        },
        "zip": "Code postal"
      },
      "call_to_action": {
        "cancel": "Annuler",
        "clear": "Effacer",
        "submit": "Envoyer"
      },
      "cancel_account": {
        "cancel_account": "Annuler le compte",
        "cancel_trial": "Annuler l’évaluation",
        "contact_information": {
          "call_international": "International : + 1 919.745.6111",
          "call_toll_free": "Appel gratuit : 1.800.441.3453",
          "call_uk": "Royaume-Uni : +44 (0800) 680.0621",
          "here_for_you": "Nous sommes à votre service",
          "visit_support": "Consulter l'assistance"
        },
        "contact_us": "Contactez-nous",
        "continue_cancellation": "Continuer l’annulation",
        "did_you_know": "Le saviez-vous ?",
        "did_you_know_desc": "Si vous annulez votre compte ShareFile, vous passerez à côté d’un grand nombre de fonctionnalités, parmi lesquelles :",
        "download_now": "Télécharger maintenant",
        "error_banner": "Échec de l’annulation. Veuillez réessayer ou contacter notre équipe d’assistance",
        "features": {
          "customer_access": "Accès illimité pour vos clients",
          "customer_access_desc": "Autorisez vos clients à accéder à des fichiers gratuitement et gérez les fichiers auxquels ils ont accès.",
          "customer_support": "Support client",
          "customer_support_desc": "par e-mail ou par téléphone ; nous sommes là pour vous aider !",
          "esignature": "Signature électronique",
          "esignature_desc": "Envoyez des fichiers pour signature directement depuis votre compte ShareFile.",
          "sharefile_mobile": "Applications mobiles ShareFile",
          "sharefile_mobile_desc": "Accédez aux fichiers et dossiers à tout moment à partir de votre smartphone ou tablette.",
          "sharefile_plugin": "Plug-in ShareFile pour Microsoft Outlook",
          "sharefile_plugin_desc": "Envoyez des fichiers volumineux de façon sécurisée directement à partir d’Outlook.",
          "total_security": "Sécurité complète",
          "total_security_desc": "Soyez rassuré quant à la protection de vos données."
        },
        "form": {
          "account_name": "Nom de compte",
          "back_to_admin": "Retour à l’administration du compte",
          "cancel_my_account": "Annuler mon compte",
          "cancel_my_trial": "Annuler mon évaluation",
          "cancellation_reason": {
            "Lacks_required_compliance": "Absence de conformité(s) requise(s)",
            "lack_of_integrations": "Manque d’intégrations",
            "lacks_required_feature": "Absence de fonctionnalité(s) requise(s)",
            "no_longer_needed": "N’est plus nécessaire",
            "poor_account_support": "Mauvaise Assistance médiocre pour les comptes (ventes, technique)",
            "prefer_competitive_product": "Préfère un produit compétitif",
            "security_concerns": "Préoccupations en matière de sécurité",
            "technical_issues": "Problèmes techniques",
            "too_difficult_to_use": "Trop difficile à utiliser",
            "too_expensive": "Trop cher"
          },
          "comments_label": "Commentaires",
          "comments_placeholder": "Vous souhaitez nous en dire plus sur la raison pour laquelle vous voulez annuler votre compte ? Nous aimerions également savoir ce que nous pouvons faire pour améliorer ShareFile.",
          "employees_desc": "{{employeeCount}} acheté(s) sur {{employeeMax}}",
          "employees_title": "Employés",
          "forgot_your_password": "Avez-vous oublié votre mot de passe ?",
          "more_info": "Veuillez nous consacrer une minute pour nous expliquer la raison pour laquelle vous souhaitez annuler votre compte.",
          "once_you_cancel": "Si vous annulez, ShareFile supprimera vos fichiers après 30 jours.",
          "password_label": "Entrez le mot de passe du compte :",
          "password_missing": "Entrez le mot de passe du compte",
          "password_placeholder": "Mot de passe",
          "reason_missing": "Veuillez sélectionner une raison",
          "required": "Requis",
          "storage_usage_desc": "{{mbUsed}} Mo sur {{mbMax}} Mo utilisés (à compter du {{dateFormatted}})",
          "storage_usage_title": "Utilisation du stockage",
          "title": "J’annule mon compte ShareFile car :",
          "to_authorize": "Pour autoriser ShareFile à supprimer vos fichiers après 30 jours, entrez le mot de passe de votre compte pour poursuivre l’annulation de votre compte."
        },
        "in_progress_banner": "Nous travaillons à la mise à jour de votre compte. Cela peut prendre un certain temps – revenez ultérieurement !",
        "learn_more": "En savoir plus",
        "let_us_help_1": "Nous pouvons vous aider à profiter au maximum de votre compte ShareFile.",
        "let_us_help_2": "Contactez notre équipe d’assistance à la clientèle",
        "let_us_help_3": "pour en savoir plus sur ces fonctionnalités et d’autres fonctionnalités ShareFile.",
        "modal_confirm": "OK",
        "modal_message": "Votre compte a été annulé, mais restera actif jusqu’à la fin du cycle de facturation. Vous pouvez réactiver votre compte en cliquant sur « Réactiver le compte » dans le menu administrateur.",
        "modal_message_trial": "Votre évaluation a été annulée. Merci d’avoir essayé ShareFile ! Vous pouvez réactiver votre compte en cliquant sur « Réactiver le compte » dans le menu d’administration du compte.",
        "modal_title": "Compte annulé",
        "modal_title_trial": "Version d’évaluation annulée",
        "password_was_incorrect": "Le mot de passe est incorrect",
        "resources_card": {
          "ask_the_community": "Demander à la communauté",
          "sharefile_knowledgebase": "Base de connaissances ShareFile",
          "title": "Avez-vous essayé ces ressources ?",
          "training_videos": "Vidéos de formation"
        },
        "sorry_to_go": "Nous sommes désolés de vous voir partir !",
        "sorry_to_go_desc": "ShareFile a été conçu pour vous, et nous nous efforçons constamment d’améliorer notre service et de répondre à vos besoins en matière de partage et de stockage de fichiers."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "Une erreur s’est produite",
        "live_chat": "chat en direct",
        "sales_team": "équipe de vente"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Économisez 10 %)",
          "choose_billing_cycle": "Choisissez votre cycle de facturation",
          "choose_billing_cycle_text": "Le prix est basé sur le nombre total d’employés utilisateurs.",
          "online_only": "(en ligne seulement)",
          "pay_annually": "Paiement annuel",
          "pay_monthly": "Paiement mensuel"
        },
        "buttons": {
          "buy_now": "Achetez dès maintenant",
          "cancel": "Annuler",
          "continue": "Continuer",
          "convert_now": "Convertir maintenant",
          "convert_now_tooltip": "Assurez-vous que l’adresse et la carte de crédit ont été vérifiées avant de procéder à la conversion."
        },
        "convert_modal": {
          "confirm_purchase": "Confirmer l’achat",
          "confirm_purchase_description": "En sélectionnant « Convertir maintenant », vous serez facturé de {<billingRate>} (plus les taxes applicables) aujourd’hui et votre compte sera converti en compte payant."
        },
        "credit_card": {
          "add": "Ajouter",
          "confirmed": "Carte de crédit confirmée",
          "confirmed_description": "Les informations relatives à votre carte de crédit ont été vérifiées.",
          "declined": "Carte de crédit refusée",
          "declined_description": "Nous n’avons pas pu vérifier votre carte. Vérifiez que ce que vous avez saisi est correct et réessayez.",
          "edit": "Modifier",
          "error_message": "La vérification de la carte de crédit a échoué. Vérifiez les informations de la carte de crédit et réessayez.",
          "information": "Informations de la carte"
        },
        "current_licenses": "Licences des employés : {{users}}",
        "current_storage": "Stockage : {{storage}} Go",
        "employee_accounts": "Comptes d’employés",
        "employee_accounts_description": "Votre forfait comprend {{users}} comptes d’employés ; vous pouvez ajouter des comptes supplémentaires à votre forfait ci-dessous.",
        "employee_accounts_description_vdr": "Votre forfait comprend {{users}} licences d’employés et {{storage}} Go de stockage. Vous pouvez en ajouter plus ci-dessous.",
        "employee_licenses": "Licences des employés",
        "employee_licenses_storage": "Licences des employés et stockage",
        "error_loading_plans": "Une erreur s’est produite lors du chargement des forfaits. Veuillez réessayer plus tard.",
        "left_nav_button_text": "Convertir l’évaluation gratuite",
        "month": "par mois",
        "number_of_users_selection": {
          "title": "Nombre d’utilisateurs",
          "user_limit_message": "Le forfait sélectionné permet un minimum de {{min}} utilisateurs et {{max}} au maximum."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} comptes d’employés",
          "max_file_size": "100 Go",
          "max_storage": "1 To/license",
          "max_storage_vdr": "1 Go/license",
          "storage": "{{storage}} de stockage"
        },
        "plan_chart": {
          "need_help": "Avez-vous besoin d’aide ? Nous sommes là pour vous aider. Contactez le service d’assistance à l’adresse sales@sharefile.com ou appelez le 1 (800)-441-3453 pour plus d’options.",
          "upgrade_plan": "Passer à un forfait supérieur",
          "view_detailed_comparison": "Afficher une comparaison détaillée"
        },
        "plan_summary": {
          "annually": "Annuel",
          "billing": "Facturation",
          "monthly": "Mensuel",
          "plan": "Forfait {{name}}",
          "plus_applicable_taxes": "La taxe finale, le cas échéant, sera incluse dans la facture.",
          "storage_max_file_size": "Stockage/taille maximale des fichiers : {<storage_details>}",
          "users": "Utilisateurs",
          "your_total": "Votre total"
        },
        "purchase_confirmed": "Achat confirmé",
        "something_went_wrong": "Une erreur s’est produite",
        "storage_distribution_description": "Le stockage est partagé entre tous les employés disposant d’une licence et n’est pas limité par utilisateur.",
        "storage_gb": "{{storage}} Go",
        "storage_only": "Stockage",
        "successful_conversion": "Vous avez converti votre compte avec succès.",
        "title": "Convertir l’évaluation gratuite",
        "try_again_or_contact_support": "Veuillez réessayer ou contacter le service d’assistance pour obtenir de l’aide.",
        "upgrade_failed": "Échec de la mise à niveau"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Adresse de facturation",
          "city": "Ville",
          "country": "Pays",
          "state_province": "Département/région",
          "street": "Rue",
          "zip_postal_code": "Code postal"
        },
        "cancel": "Annuler",
        "credit_card": {
          "card_details": "Détails de la carte de crédit",
          "card_exp_date": "Date d’expiration",
          "card_first_name": "Prénom",
          "card_last_name": "Nom",
          "card_number": "Numéro de carte",
          "card_type": "Type de carte",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "Type de carte de crédit non pris en charge. Veuillez utiliser une carte Visa, Mastercard ou American Express",
          "card_type_unknown": "Inconnu",
          "card_type_visa": "Visa",
          "title": "Informations de carte de crédit"
        },
        "credit_card_notifications": {
          "add_successful": "Informations relatives à la carte de crédit ajoutées !",
          "save_failure": "Échec de l’enregistrement des informations relatives à la carte de crédit",
          "update_failure": "La mise à jour des informations sur la carte de crédit a échoué",
          "update_successful": "Informations sur la carte de crédit mises à jour !"
        },
        "disable_trial_conversion_message": "Contactez notre équipe pour étudier le meilleur forfait pour votre pays. Contactez-nous via {<live_chat>}.",
        "edit": "Modifier",
        "get_billing_info_failed": "Une erreur s’est produite lors de l’obtention de vos informations de facturation. Veuillez réessayer plus tard.",
        "info_banner": "Remarque : la mise à jour des informations de facturation peut ne pas être reflétée immédiatement. Veuillez prévoir un délai de 24 heures avant que les modifications ne s’affichent ci-dessous.",
        "left_nav_button_text": "Modifier les informations de facturation",
        "name_on_card": "Nom du détenteur de la carte",
        "no_billing_info_banner": "Nous ne pouvons pas charger cette page pour le moment. Contactez notre service client pour modifier vos informations de facturation.",
        "province": "Province",
        "save": "Enregistrer",
        "state": "État",
        "support": {
          "chat_with_us": "Chattez avec nous",
          "contact_support": "Impossible de vérifier l’adresse, veuillez contacter le support.",
          "contact_support_info": "contactez le support"
        },
        "title": "Modifier les informations de facturation",
        "update": "Mettre à jour",
        "update_billing_type": {
          "info_message": "Le type de facturation actuel est {<invoice>}. Vous pouvez passer à des paiements par carte de crédit.",
          "invoice": "facture",
          "switch_to_credit_card": "Passer à carte de crédit",
          "title": "Mettre à jour type de facturation"
        },
        "update_notifications": {
          "contact_support": "contactez le support",
          "save_failed": "Impossible d’enregistrer",
          "save_success": "Vos modifications ont été enregistrées.",
          "something_went_wrong": "Une erreur s’est produite",
          "try_again": "Impossible de vérifier l’adresse, veuillez réessayer.",
          "try_again_or_contact_support": "Veuillez réessayer ou {<contactSupport>} pour obtenir de l’aide."
        },
        "vat_id": "N° de TVA",
        "verify_address": "Vérifier l’adresse"
      },
      "expiration": {
        "account_canceled_first": "Nous annulons les comptes lorsque les administrateurs nous le demandent, lorsque la facturation est en retard ou lorsque nos conditions de service n'ont pas été respectées.",
        "account_canceled_second": "Ce compte et toutes ses données seront définitivement supprimés le {{date}} (ou peu après). Vous pouvez continuer à utiliser votre compte jusqu'à cette date pour récupérer tout ce que vous avez stocké dans ShareFile. Une fois votre compte supprimé, tous les fichiers et utilisateurs qui y sont associés seront irrécupérables.",
        "account_canceled_title": "Ce compte a été annulé",
        "ask_to_purchase": "Demander à acheter",
        "continue_to_sharefile": "Continuer vers ShareFile",
        "logo_alt_text": "Logo ShareFile",
        "notification_error_message": "L'envoi de la notification à l'administrateur a échoué. Veuillez réessayer.",
        "purchase": {
          "error_modal": {
            "close": "Fermer",
            "sub_title": "Appelez-nous au 1-800-441-3453 pour terminer la création de votre compte. Indiquez le code d'erreur {<errorCode>}.",
            "title": "Nous avons besoin de quelques précisions"
          },
          "loading_modal": {
            "sub_title": "Veuillez patienter pendant que nous finissons de tout mettre en place.",
            "title": "Nous procédons à la mise à jour de votre compte ShareFile"
          },
          "select_plan": "Sélectionner un forfait",
          "title": "Acheter ShareFile"
        },
        "purchase_account": "Acheter le compte",
        "reactivate_account": "Réactiver le compte",
        "request_reactivation": "Demander la réactivation",
        "request_sent": "Demande envoyée",
        "something_went_wrong": "Une erreur s’est produite",
        "trial_ended_first": "Votre période d'évaluation a pris fin le {{date}} Pour continuer à utiliser ShareFile, achetez votre compte.",
        "trial_ended_second": "Veuillez noter que les comptes d'essai sont normalement supprimés 60 jours après la fin de l'essai. Les fichiers et les utilisateurs associés à votre compte sont alors irrécupérables.",
        "trial_ended_title": "Votre évaluation est terminée"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "un jour",
          "day_count_plural": "{{count}} jours",
          "days_left_in_your_trial": "Il vous reste {<dayCount>} d’évaluation. ",
          "upgrade_to_a_plan": "Mettre à niveau vers un forfait"
        }
      },
      "invalid_address_error": "L’adresse que vous avez saisie n’est pas valide. Veuillez réessayer.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "Nous n’avons pas pu traiter cette demande, car une demande précédente est déjà en cours de traitement.",
      "manage_plan": {
        "add_storage_btn": "Ajouter du stockage",
        "add_users_btn": "Ajouter des utilisateurs",
        "advanced": {
          "description": "Partage sécurisé de fichiers pour les équipes",
          "feature_access_control": "Contrôles d'accès granulaires et rapports de base",
          "feature_encryption": "Stockage et partage de fichiers cryptés",
          "feature_secure_email": "Intégrations sécurisées des adresses e-mail et co-édition en temps réel",
          "features_header": "Principales fonctionnalités :",
          "title": "Advanced",
          "title_0gb": "Advanced 0 Go"
        },
        "connectors": {
          "title_0gb": "Connecteurs 0 Go"
        },
        "contact_support": "Contactez l'assistance pour plus d'options de plan",
        "current_plan": "Forfait actuel",
        "for_accounting": "Pour la comptabilité",
        "get_usageplan_failed": "Une erreur s’est produite lors de l’obtention de vos informations de forfait. Veuillez réessayer plus tard.",
        "included": "Inclus",
        "industry_advantage": {
          "description": "Automatisation préconfigurée de la procédure des documents comptables",
          "feature_bulk_client_onboarding": "Intégrer en masse les clients dans les missions comptables",
          "feature_centralized_view": "Vue centralisée de tous les engagements en un seul endroit",
          "feature_tax_templates": "Modèles prédéfinis pour les missions fiscales",
          "features_header": "Toutes les fonctionnalités Premium, plus :",
          "title": "Industry Advantage",
          "tooltip": "Des flux de travail sur mesure conçus pour faciliter les cas d'utilisation de bout en bout pour les processus comptables et fiscaux, qui améliorent l'efficacité et la normalisation"
        },
        "left_nav_button_text": "Gérer le forfait",
        "manage_plan_title": "Gérer le forfait",
        "message_after_update": "Nous travaillons à la mise à jour de votre forfait. Cela peut prendre un certain temps, vérifiez ultérieurement.",
        "modals": {
          "add_button": "Ajouter",
          "additional_users": "Utilisateurs supplémentaires",
          "alert_message": "Si vous choisissez {<boldText>}, nous vous facturerons un montant calculé au prorata de la différence de coût du forfait.",
          "annual_billing_note": "Votre premier versement annuel sera dû le {{date}}.",
          "annual_billing_text": "Vous pouvez économiser 10 % sur votre forfait ShareFile en payant annuellement. Voici un résumé des coûts de votre nouveau forfait.",
          "annual_billing_title": "Facturation annuelle",
          "cancel_button": "Annuler",
          "error_alert": "Nous n’avons pas pu mettre à jour votre forfait. Veuillez réessayer.",
          "extended_storage": "{{count}} To de stockage étendu",
          "new_billing_amount": "Nouveau montant de facturation",
          "new_monthly_total": "Nouveau total mensuel",
          "new_plan_total": "Total du nouveau forfait",
          "new_storage_total": "Nouveau total de stockage",
          "new_user_total": "Total des nouveaux utilisateurs",
          "per_month": "{{price}} par mois*",
          "per_quarter": "{{price}} par trimestre*",
          "per_year": "{{price}} par an*",
          "plus_applicable_taxes": "*plus les taxes applicables",
          "price_per_TB": "{{price}} par 3 To",
          "price_per_user": "{{price}} par utilisateur",
          "storage_add": "Ajouter du stockage",
          "storage_data_breakdown_message": "Vous utilisez actuellement {<usedValue>} To de stockage sur un total de {<total>} To.",
          "storage_modal_title": "Ajouter du stockage",
          "storage_need_additional": "Besoin de stockage supplémentaire ?",
          "success_alert": "Forfait mis à jour.",
          "switch_to_annual_button": "Passer à la facturation annuelle",
          "upgrade_button": "Mettre à niveau",
          "upgrade_plan_modal_title": "Passer à un forfait supérieur",
          "users_add": "Ajouter des utilisateurs",
          "users_count": "{{count}} utilisateurs",
          "users_data_breakdown_message": "Vous utilisez actuellement {<usedValue>} licences utilisateur sur {<total>}.",
          "users_modal_title": "Ajouter des utilisateurs",
          "users_need_additional": "Besoin d’utilisateurs supplémentaires ?",
          "value_gb": "{{value}} Go",
          "value_tb": "{{value}} To"
        },
        "most_popular": "Les plus populaires",
        "need_help": "Avez-vous besoin d'aide ? Nous sommes à votre disposition. {<contact_support>}",
        "next_billing_date_pending": "à la date de facturation suivante",
        "per_month": "par mois",
        "per_quarter": "par trimestre",
        "per_year": "par an",
        "plus_taxes": "*plus les taxes applicables",
        "premium": {
          "description": "Workflows documentaires de bout en bout pour les équipes et les clients",
          "feature_ai_powered": "Automatisation et génération de documents grâce à l'IA",
          "feature_client_portals": "Portails clients personnalisés",
          "feature_hippa_finra_support": "Prise en charge de la conformité réglementaire HIPAA, FINRA et SEC",
          "feature_tools": "Outils de collaboration client - Signature électronique, demandes, tâches, formulaires, automatisation des flux de travail",
          "features_header": "Toutes les fonctionnalités Advanced, plus :",
          "title": "Premium"
        },
        "save_with_annual_btn": "Économisez 10 % avec la facturation annuelle",
        "standard": {
          "feature_all_storage": "Tout le stockage dont vous avez besoin",
          "feature_file_encryption": "Chiffrement des fichiers",
          "feature_sync_edit_share": "Synchroniser, modifier, partager",
          "feature_unlimited_client": "Utilisateurs clients illimités",
          "features_header": "Les fonctionnalités incluent :",
          "title": "Standard",
          "title_0gb": "Standard 0 Go"
        },
        "storage": "Stockage",
        "storage_per_user": "{{storage}} par utilisateur",
        "upgrade_btn": "Mettre à niveau",
        "upgrade_plan": "Passer à un forfait supérieur",
        "users": "Utilisateurs",
        "users_count": "{{count}} utilisateurs",
        "users_count_one": "{{count}} utilisateur",
        "vdr": {
          "feature_click_trails": "Suivi des clics",
          "feature_folder_qa": "Questions-réponses sur le dossier",
          "feature_visibility_analytics": "Visibilité, analyses, etc.",
          "features_header": "Protection spécialisée, comprenant :",
          "title": "Virtual data room"
        }
      },
      "payment_gateway": {
        "authorization_error": "Nous n’avons pas pu vérifier votre carte. Vérifiez que ce que vous avez saisi est correct et réessayez.",
        "authorization_error_title": "Échec de la vérification de la carte",
        "contact_details": "Coordonnées de la personne à contacter",
        "form": {
          "card_number": "Numéro de carte",
          "cardholder_name": "Nom du titulaire de la carte",
          "date_validation": {
            "expired": "La carte est périmée",
            "invalid_date": "Date non valide",
            "invalid_month": "Mois non valide",
            "no_date_provided": "Veuillez saisir la date d'expiration"
          },
          "expiration_date": "Date d'expiration",
          "payment_details": "Modalités de paiement",
          "payment_details_description": "{<asterisk>} indique un champ obligatoire",
          "security_code": "Code de sécurité",
          "security_code_description": "3 chiffres au dos de la carte ou 4 chiffres au recto de la carte"
        },
        "iframe_description": "Cliquez sur « Nouveau » pour ajouter une nouvelle carte de paiement.",
        "iframe_load_error": "Une erreur s’est produite lors du chargement des données de votre carte de crédit. Veuillez réessayer plus tard ou contacter le service d’assistance.",
        "modal_title": "Saisir les détails du paiement",
        "modal_title_legacy": "Ajouter / modifier une carte de paiement"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Nom de compte :",
          "account_owner_label": "Titulaire du compte :",
          "allocated_licenses_label": "Licences allouées :",
          "billing_cycle_month": "Mois",
          "billing_cycle_quarter": "Trimestre",
          "billing_cycle_year": "Année",
          "cancel": "Annuler",
          "esig_licenses_out_of": "{{count}} licences de signature électronique sur {{max}} utilisées",
          "id_label": "ID :",
          "licenses_out_of": "{{count}} licences employé sur {{max}} utilisées",
          "next_billing_date_label": "Prochaine date de facturation : ",
          "plan_label": "Plan :",
          "save": "Enregistrer",
          "title": "Résumé du compte",
          "total_billing_cost_info_label": "Il s'agit du coût total de tous les produits ShareFile de votre organisation.",
          "total_billing_cost_label": "Coût total de facturation :",
          "view_receipts_label": "Voir les reçus"
        },
        "cancel": "Annuler",
        "description": "La réactivation de votre compte permettra de maintenir vos services actifs et de réactiver la facturation sur votre compte.",
        "left_nav_button_text": "Réactiver le compte",
        "lock_error": "Nous n'avons pas pu traiter cette demande, car une demande précédente est déjà en cours de traitement.",
        "page_title": "Réactiver le compte",
        "reactivate_button": "Réactiver",
        "reactivate_failed": "Votre compte ne peut pas être réactivé. Veuillez contacter notre équipe d'assistance à sales@sharefile.com ou appelez le 1 (800)-441-3453.",
        "reactivate_success": "Votre compte a été réactivé."
      },
      "receipts": {
        "actions": {
          "download": "Télécharger",
          "pay": "Payer",
          "title": "Actions"
        },
        "awaiting_payment_tooltip": "L’affichage du paiement des factures sur cette page peut prendre jusqu’à 24 heures.",
        "billing_system_change": "Nous avons récemment modifié nos systèmes de facturation, ce qui aura une incidence sur la manière dont vous payez vos factures ShareFile. Pour toutes les factures émises après le {<migrationDate>}, un lien de paiement direct se trouve dans le fichier de la facture. Les factures prises en charge avant le {<migrationDate>} ne comporteront pas ce lien ; veuillez contacter l’assistance pour effectuer un paiement.",
        "cancel": "Annuler",
        "credit_card_notifications": {
          "payment_approved": "Paiement approuvé. Nous vous remercions !",
          "payment_failure": "Le paiement par carte de crédit a échoué. Veuillez contacter l’assistance."
        },
        "date": "Date d’ajout",
        "email": "E-mail",
        "error_getting_logs": "Une erreur s’est produite lors de la réception de vos reçus de facturation. Veuillez réessayer plus tard.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Reçus et notifications de facturation",
        "open_payment": "Votre compte a un paiement en cours.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "Cette page contient une liste de tous vos reçus de facturation ShareFile. Les factures peuvent prendre jusqu’à 24 heures pour apparaître comme payées sur cette page.",
        "page_title": "Reçus et notifications de facturation",
        "pay_now": "payer",
        "phone": "Téléphone",
        "phone_and_email": "{<phone>} : {{number}} | {<email>} : {{address}}",
        "status": "État",
        "status_approved": "Approuvé",
        "status_awaiting_payment": "En attente de paiement",
        "status_cleared": "Effacé",
        "status_failed": "Échec",
        "status_invoice_payment_received": "Paiement de la facture reçu",
        "status_negated": "Invalidé",
        "status_open": "Ouvrir",
        "status_paid": "Payé",
        "status_pending": "En attente",
        "status_tax_credited": "Taxe créditée",
        "status_tax_negated": "Taxe rejetée",
        "status_transaction_credited": "Transaction créditée",
        "type": "Type"
      }
    }
  },
  {
    "key": "it",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Indirizzo account",
        "address_information": "Informazioni indirizzo",
        "billing_address_same_message": "L'indirizzo di fatturazione coincide con l'indirizzo dell'account.",
        "buy_canada_tax_free": "Acquisti in Canada senza tasse?",
        "buy_canada_tax_free_description": "Utilizzando i numeri GST/HST e QST, sarà possibile usufruire dell'esenzione fiscale sull'acquisto. In assenza di tali numeri, all'acquisto verranno applicate le imposte. Per gli acquisti effettuati in British Columbia, Manitoba e Saskatchewan è necessaria la convalida di un certificato. I certificati devono essere inviati a {<contact_email>} prima del completamento dell'acquisto. Seguirà una risposta a breve.",
        "city": "Città",
        "country": "Paese",
        "country_not_supported_message": "Per modificare il paese, contattare il nostro {<sales_team>} per assistenza.",
        "disable_trial_conversion_message": "Rivolgiti al nostro team per trovare il miglior piano per il tuo paese. Contattaci tramite {<live_chat>}.",
        "enter_address_manually": "Immettere l'indirizzo manualmente",
        "european_vat_id": "Partita IVA europea",
        "gst_hst_number": "Numero di registrazione GST/HST",
        "postal_code": "CAP",
        "province": "Provincia",
        "pst_number": "Numero di registrazione PST",
        "qst_number": "Numero di registrazione QST",
        "sfi_message": "Rappresenti un ente finanziario selezionato (SLFI)?",
        "state": "Stato",
        "street": "Indirizzo civico",
        "suggestions_attribution": "Suggerimenti forniti da Google",
        "suggestions_not_found": "Indirizzo non trovato. Riprovare oppure immettere l'indirizzo manualmente.",
        "tax_tooltip": "Immettere qui il codice fiscale aziendale per garantire una corretta gestione fiscale delle fatture.",
        "title": "Indirizzo di fatturazione",
        "validation_message": {
          "city_required": "La Città è obbligatoria.",
          "country_required": "Il Paese è obbligatorio.",
          "province_required": "La Provincia è obbligatoria.",
          "state_required": "Lo Stato è obbligatorio.",
          "street_required": "Immettere l'indirizzo civico.",
          "tax_invalid": "Impossibile convalidare il codice fiscale. Verificare i dati e riprovare.",
          "zip_required": "Il CAP è obbligatorio."
        },
        "zip": "CAP"
      },
      "call_to_action": {
        "cancel": "Annulla",
        "clear": "Cancella",
        "submit": "Invia"
      },
      "cancel_account": {
        "cancel_account": "Annulla account",
        "cancel_trial": "Annulla prova",
        "contact_information": {
          "call_international": "Internazionale: +1 919.745.6111",
          "call_toll_free": "Numero verde: 1.800.441.3453",
          "call_uk": "Regno Unito: +44 (0800) 680.0621",
          "here_for_you": "Siamo a disposizione",
          "visit_support": "Visita il sito dell’assistenza"
        },
        "contact_us": "Contattaci",
        "continue_cancellation": "Continua annullamento",
        "did_you_know": "Informazioni utili",
        "did_you_know_desc": "Una volta annullato l'account ShareFile non sarà più possibile utilizzare tutta una serie di funzionalità utili, tra cui:",
        "download_now": "Scarica ora",
        "error_banner": "Impossibile annullare. Riprovare o contattare il nostro team di supporto",
        "features": {
          "customer_access": "Accesso illimitato per i clienti",
          "customer_access_desc": "È possibile consentire ai clienti di accedere ai file gratuitamente e gestire quelli che possono visualizzare.",
          "customer_support": "Supporto clienti",
          "customer_support_desc": "via e-mail o telefonicamente. Saremo lieti di offrire la nostra assistenza.",
          "esignature": "Firma elettronica",
          "esignature_desc": "Inviare file per la firma direttamente dall'account ShareFile.",
          "sharefile_mobile": "App per dispositivi mobili ShareFile",
          "sharefile_mobile_desc": "Accedere a file e cartelle in qualsiasi momento da smartphone o tablet.",
          "sharefile_plugin": "ShareFile Plug-in per Microsoft Outlook",
          "sharefile_plugin_desc": "Inviare file di grandi dimensioni in tutta sicurezza direttamente da Outlook.",
          "total_security": "Sicurezza totale",
          "total_security_desc": "I dati sono sempre protetti."
        },
        "form": {
          "account_name": "Nome account",
          "back_to_admin": "Torna ad amministrazione account",
          "cancel_my_account": "Annulla l'account",
          "cancel_my_trial": "Annulla la prova",
          "cancellation_reason": {
            "Lacks_required_compliance": "Mancanza di conformità richiesta",
            "lack_of_integrations": "Mancanza di integrazioni",
            "lacks_required_feature": "Mancanza di funzionalità richieste",
            "no_longer_needed": "Non più necessario",
            "poor_account_support": "Supporto per l’account (commerciale, tecnico) insoddisfacente",
            "prefer_competitive_product": "Preferisco prodotto di un’altra marca",
            "security_concerns": "Dubbi sulla sicurezza",
            "technical_issues": "Problemi tecnici",
            "too_difficult_to_use": "Troppo difficile da usare",
            "too_expensive": "Troppo costoso"
          },
          "comments_label": "Commenti",
          "comments_placeholder": "Vorremmo chiederti di condividere con noi i motivi dell’annullamento dell’account. Inoltre, saremmo lieti di ricevere i tuoi eventuali commenti o suggerimenti su come possiamo migliorare ShareFile.",
          "employees_desc": "{{employeeCount}} di {{employeeMax}} acquistati",
          "employees_title": "Dipendenti",
          "forgot_your_password": "Password dimenticata?",
          "more_info": "Spiegare i motivi per cui si intende annullare l'account.",
          "once_you_cancel": "Una volta completato l’annullamento, ShareFile eliminerà i file dopo 30 giorni.",
          "password_label": "Immetti password account",
          "password_missing": "Immettere la password dell'account",
          "password_placeholder": "Password",
          "reason_missing": "Selezionare un motivo",
          "required": "Obbligatorio",
          "storage_usage_desc": "{{mbUsed}} MB di {{mbMax}} usati al {{dateFormatted}}",
          "storage_usage_title": "Uso dello spazio di archiviazione",
          "title": "Motivi dell'annullamento dell'account ShareFile:",
          "to_authorize": "Per autorizzare ShareFile a eliminare i file dopo 30 giorni, immettere la password dell'account per continuare con l'annullamento."
        },
        "in_progress_banner": "Stiamo lavorando per aggiornare il tuo account. L'operazione potrebbe richiedere alcuni minuti. Controlla più tardi.",
        "learn_more": "Ulteriori informazioni",
        "let_us_help_1": "Possiamo aiutarti a sfruttare ancora meglio l'account ShareFile.",
        "let_us_help_2": "Contattare il nostro team del servizio clienti",
        "let_us_help_3": "per ricevere ulteriori informazioni su queste e altre funzionalità di ShareFile.",
        "modal_confirm": "OK",
        "modal_message": "L'account è stato annullato, ma rimarrà attivo fino alla fine del ciclo di fatturazione. È possibile riattivare l’account facendo clic su “Riattiva account” nel menu amministratore.",
        "modal_message_trial": "La versione di prova è stata annullata. Grazie per aver provato ShareFile. Per riattivare l'account, fare clic su \"Riattiva account” nel menu di amministrazione dell'account.",
        "modal_title": "Account annullato",
        "modal_title_trial": "Versione di prova annullata",
        "password_was_incorrect": "Password errata",
        "resources_card": {
          "ask_the_community": "Chiedi alla community",
          "sharefile_knowledgebase": "Knowledge base di ShareFile",
          "title": "È possibile provare le seguenti risorse.",
          "training_videos": "Video di formazione"
        },
        "sorry_to_go": "Ci spiace che il servizio stia per essere annullato.",
        "sorry_to_go_desc": "ShareFile è stato progettato appositamente per gli utenti aziendali e siamo sempre alla ricerca di nuovi modi per migliorare il nostro servizio e soddisfare le esigenze di archiviazione e condivisione dei file dei clienti."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "Si è verificato un errore",
        "live_chat": "live chat",
        "sales_team": "team commerciale"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Risparmia il 10%)",
          "choose_billing_cycle": "Scegliere il ciclo di fatturazione",
          "choose_billing_cycle_text": "Il prezzo si basa sul numero totale di utenti dipendenti.",
          "online_only": "(Solo online)",
          "pay_annually": "Canone annuale",
          "pay_monthly": "Canone mensile"
        },
        "buttons": {
          "buy_now": "Acquista ora",
          "cancel": "Annulla",
          "continue": "Continua",
          "convert_now": "Converti ora",
          "convert_now_tooltip": "Assicurarsi che l’indirizzo e i dati della carta di credito siano stati verificati prima della conversione."
        },
        "convert_modal": {
          "confirm_purchase": "Conferma acquisto",
          "confirm_purchase_description": "Selezionando “Converti ora”, l'addebito di {<billingRate>} (più le imposte applicabili) verrà registrato in data odierna e l'account verrà convertito in un account a pagamento."
        },
        "credit_card": {
          "add": "Aggiungi",
          "confirmed": "Carta di credito confermata",
          "confirmed_description": "I dati della carta di credito sono stati verificati.",
          "declined": "Carta di credito rifiutata",
          "declined_description": "Impossibile verificare la carta. Accertarsi di aver immesso i dati correttamente e riprovare.",
          "edit": "Modifica",
          "error_message": "Verifica della carta di credito non riuscita. Controllare i dati della carta di credito e riprovare.",
          "information": "Informazioni carta"
        },
        "current_licenses": "Licenze dipendenti: {{users}}",
        "current_storage": "Archiviazione: {{storage}} GB",
        "employee_accounts": "Account dipendenti",
        "employee_accounts_description": "Il piano include {{users}} account dipendenti, è possibile aggiungere ulteriori account al proprio piano di seguito.",
        "employee_accounts_description_vdr": "Il piano include {{users}} licenze dipendenti e {{storage}} GB di archiviazione. È possibile aggiungere altro di seguito.",
        "employee_licenses": "Licenze dipendenti",
        "employee_licenses_storage": "Licenze dipendenti e archiviazione",
        "error_loading_plans": "Errore durante il tentativo di caricamento dei piani. Riprovare più tardi.",
        "left_nav_button_text": "Converti versione di prova",
        "month": "al mese",
        "number_of_users_selection": {
          "title": "Numero di utenti",
          "user_limit_message": "Il piano selezionato consente un minimo di {{min}} utenti e un massimo di {{max}} utenti."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} account dipendenti",
          "max_file_size": "100 GB",
          "max_storage": "1 TB/licenza",
          "max_storage_vdr": "1 GB/licenza",
          "storage": "{{storage}} di archiviazione"
        },
        "plan_chart": {
          "need_help": "Serve assistenza? Siamo a disposizione. Contattare il supporto all’indirizzo sales@sharefile.com o chiamare il numero 1 (800)-441-3453 per ulteriori opzioni sui piani offerti.",
          "upgrade_plan": "Aggiorna il piano",
          "view_detailed_comparison": "Visualizza confronto dettagliato"
        },
        "plan_summary": {
          "annually": "Annuale",
          "billing": "Fatturazione",
          "monthly": "Mensile",
          "plan": "Piano {{name}}",
          "plus_applicable_taxes": "L'imposta finale, se applicabile, sarà inclusa nella fattura.",
          "storage_max_file_size": "Spazio di archiviazione/dimensioni file max: {<storage_details>}",
          "users": "Utenti",
          "your_total": "Totale"
        },
        "purchase_confirmed": "Acquisto confermato",
        "something_went_wrong": "Si è verificato un problema",
        "storage_distribution_description": "Lo spazio di archiviazione è condiviso tra tutti i dipendenti con licenza e non è limitato per utente.",
        "storage_gb": "{{storage}} GB",
        "storage_only": "Archiviazione",
        "successful_conversion": "L’account è stato convertito correttamente.",
        "title": "Converti versione di prova",
        "try_again_or_contact_support": "Riprovare o contattare il supporto per ulteriore assistenza.",
        "upgrade_failed": "Aggiornamento non riuscito"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Indirizzo di fatturazione",
          "city": "Città",
          "country": "Paese",
          "state_province": "Stato/provincia",
          "street": "Indirizzo civico",
          "zip_postal_code": "CAP"
        },
        "cancel": "Annulla",
        "credit_card": {
          "card_details": "Dettagli della carta di credito",
          "card_exp_date": "Data di scadenza",
          "card_first_name": "Nome",
          "card_last_name": "Cognome",
          "card_number": "Numero carta",
          "card_type": "Tipo di carta",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "Tipo di carta di credito non supportato. Utilizzare una carta Visa, Mastercard o American Express",
          "card_type_unknown": "Sconosciuto",
          "card_type_visa": "Visa",
          "title": "Dati carta di credito"
        },
        "credit_card_notifications": {
          "add_successful": "Dati carta di credito aggiunti.",
          "save_failure": "Impossibile salvare i dati della carta di credito",
          "update_failure": "Impossibile aggiornare i dati della carta di credito",
          "update_successful": "Dati carta di credito aggiornati."
        },
        "disable_trial_conversion_message": "Rivolgiti al nostro team per trovare il miglior piano per il tuo paese. Contattaci tramite {<live_chat>}.",
        "edit": "Modifica",
        "get_billing_info_failed": "Errore durante il recupero dei dati di fatturazione. Riprovare più tardi.",
        "info_banner": "Nota: è possibile che gli aggiornamenti ai dati di fatturazione non vengano visualizzati immediatamente. La visualizzazione delle modifiche qui sotto potrebbe richiedere fino a 24 ore.",
        "left_nav_button_text": "Modifica dati di fatturazione",
        "name_on_card": "Nome sulla carta",
        "no_billing_info_banner": "Al momento non è possibile caricare questa pagina. Contattare il nostro servizio clienti per modificare i dati di fatturazione.",
        "province": "Provincia",
        "save": "Salva",
        "state": "Stato",
        "support": {
          "chat_with_us": "Chatta con noi",
          "contact_support": "Impossibile verificare l'indirizzo. Contattare il supporto.",
          "contact_support_info": "contattare il supporto"
        },
        "title": "Modifica dati di fatturazione",
        "update": "Aggiorna",
        "update_billing_type": {
          "info_message": "Il tipo di fatturazione corrente è {<invoice>}. È possibile passare ai pagamenti con carta di credito.",
          "invoice": "fattura",
          "switch_to_credit_card": "Passare alla carta di credito",
          "title": "Aggiornare il tipo di fatturazione"
        },
        "update_notifications": {
          "contact_support": "contattare il supporto",
          "save_failed": "Impossibile salvare",
          "save_success": "Le modifiche sono state salvate.",
          "something_went_wrong": "Si è verificato un problema",
          "try_again": "Impossibile verificare l'indirizzo. Riprovare.",
          "try_again_or_contact_support": "Riprovare o {<contactSupport>} per ulteriore assistenza."
        },
        "vat_id": "Partita IVA",
        "verify_address": "Verifica indirizzo"
      },
      "expiration": {
        "account_canceled_first": "Annulliamo gli account quando ce lo richiedono gli amministratori, quando i pagamenti sono scaduti o quando vengono violati i nostri termini di servizio.",
        "account_canceled_second": "Questo account e tutti i relativi dati associati verranno eliminati in modo definitivo in data {{date}} (o poco dopo). È possibile continuare a utilizzare il proprio account fino a quel momento per recuperare gli eventuali dati archiviati in ShareFile. Una volta eliminato l’account, l’eliminazione di tutti i file e degli utenti associati all’account diventerà irreversibile.",
        "account_canceled_title": "Questo account è stato annullato",
        "ask_to_purchase": "Richiedi acquisto",
        "continue_to_sharefile": "Continua su ShareFile",
        "logo_alt_text": "Logo di ShareFile",
        "notification_error_message": "Impossibile inviare la notifica all’amministratore. Riprovare.",
        "purchase": {
          "error_modal": {
            "close": "Chiudi",
            "sub_title": "Chiamare il numero 1-800-441-3453 per finire la configurazione dell’account. Indicare il codice di errore {<errorCode>}.",
            "title": "È necessaria qualche altra informazione"
          },
          "loading_modal": {
            "sub_title": "Attendere mentre si conclude la configurazione.",
            "title": "Stiamo aggiornando l’account ShareFile"
          },
          "select_plan": "Seleziona piano",
          "title": "Acquista ShareFile"
        },
        "purchase_account": "Acquista account",
        "reactivate_account": "Riattiva account",
        "request_reactivation": "Richiedi riattivazione",
        "request_sent": "Richiesta inviata",
        "something_went_wrong": "Si è verificato un problema",
        "trial_ended_first": "Il periodo di prova si è concluso in data {{date}}. Per continuare a utilizzare ShareFile, acquistare l’account.",
        "trial_ended_second": "Si ricorda che gli account di prova di norma vengono eliminati 60 giorni dopo la fine del periodo di prova. Successivamente, l’eliminazione di tutti i file e degli utenti associati all’account diventerà irreversibile.",
        "trial_ended_title": "Il periodo di prova è scaduto"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "un giorno",
          "day_count_plural": "{{count}} giorni",
          "days_left_in_your_trial": "Restano {<dayCount>} del periodo di prova. ",
          "upgrade_to_a_plan": "Aggiorna a un piano"
        }
      },
      "invalid_address_error": "L’indirizzo immesso non è valido. Riprovare.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "Non è stato possibile gestire questa richiesta: è in corso l'elaborazione di una richiesta precedente.",
      "manage_plan": {
        "add_storage_btn": "Aggiungi spazio di archiviazione",
        "add_users_btn": "Aggiungi utenti",
        "advanced": {
          "description": "Condivisione di file sicura per team",
          "feature_access_control": "Controlli di accesso granulare e reporting di base",
          "feature_encryption": "Archiviazione e condivisione di file crittografati",
          "feature_secure_email": "Integrazioni di e-mail sicure e co-editing in tempo reale",
          "features_header": "Funzioni principali:",
          "title": "Advanced",
          "title_0gb": "Advanced 0 GB"
        },
        "connectors": {
          "title_0gb": "Connettori 0 GB"
        },
        "contact_support": "Contattare il supporto per ulteriori opzioni sul piano",
        "current_plan": "Piano corrente",
        "for_accounting": "Per contabilità",
        "get_usageplan_failed": "Errore durante il recupero dei dati del piano. Riprovare più tardi.",
        "included": "Incluso",
        "industry_advantage": {
          "description": "Automazione dei flussi di lavoro documentali specifici per la contabilità, preconfigurati",
          "feature_bulk_client_onboarding": "Onboarding in blocco di clienti per incarichi di contabilità",
          "feature_centralized_view": "Vista centralizzata di tutti gli incarichi in un unico punto",
          "feature_tax_templates": "Modelli preconfigurati per incarichi fiscali",
          "features_header": "Tutte le funzionalità Premium, più:",
          "title": "Industry Advantage",
          "tooltip": "Flussi di lavoro personalizzati progettati per agevolare casi d’uso end-to-end semplificati per i processi tributari di contabilità che migliorano l’efficienza e la standardizzazione"
        },
        "left_nav_button_text": "Gestisci piano",
        "manage_plan_title": "Gestisci piano",
        "message_after_update": "Stiamo lavorando per aggiornare il tuo piano. L'operazione potrebbe richiedere alcuni minuti. Controlla più tardi.",
        "modals": {
          "add_button": "Aggiungi",
          "additional_users": "Utenti aggiuntivi",
          "alert_message": "Se si sceglie {<boldText>}, sarà addebitato un importo proporzionale per la differenza di costo del piano.",
          "annual_billing_note": "Il primo pagamento annuale scadrà in data {{date}}.",
          "annual_billing_text": "È possibile risparmiare il 10% sul proprio piano ShareFile pagando annualmente. Ecco un riepilogo di quanto costerebbe il nuovo piano.",
          "annual_billing_title": "Fatturazione annuale",
          "cancel_button": "Annulla",
          "error_alert": "Non è stato possibile aggiornare il piano. Riprovare.",
          "extended_storage": "{{count}} TB di spazio di archiviazione esteso",
          "new_billing_amount": "Nuovo importo di fatturazione",
          "new_monthly_total": "Nuovo totale mensile",
          "new_plan_total": "Totale nuovo piano",
          "new_storage_total": "Nuovo spazio di archiviazione totale",
          "new_user_total": "Totale nuovi utenti",
          "per_month": "{{price}} al mese*",
          "per_quarter": "{{price}} al trimestre*",
          "per_year": "{{price}} all'anno*",
          "plus_applicable_taxes": "*più imposte applicabili",
          "price_per_TB": "{{price}} ogni 3 TB",
          "price_per_user": "{{price}} per utente",
          "storage_add": "Aggiungi spazio di archiviazione",
          "storage_data_breakdown_message": "Attualmente sono in uso {<usedValue>} TB sui {<total>} TB di spazio di archiviazione disponibile.",
          "storage_modal_title": "Aggiungi spazio di archiviazione",
          "storage_need_additional": "Serve ulteriore spazio di archiviazione?",
          "success_alert": "Piano aggiornato.",
          "switch_to_annual_button": "Passare alla fatturazione annuale",
          "upgrade_button": "Aggiornamento",
          "upgrade_plan_modal_title": "Aggiorna il piano",
          "users_add": "Aggiungi utenti",
          "users_count": "{{count}} utenti",
          "users_data_breakdown_message": "Attualmente sono in uso {<usedValue>} su {<total>} licenze utente.",
          "users_modal_title": "Aggiungi utenti",
          "users_need_additional": "Occorre aggiungere altri utenti?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "Più popolare",
        "need_help": "Serve assistenza? Siamo a disposizione. {<contact_support>}",
        "next_billing_date_pending": "alla prossima data di fatturazione",
        "per_month": "al mese",
        "per_quarter": "al trimestre",
        "per_year": "all'anno",
        "plus_taxes": "*più imposte applicabili",
        "premium": {
          "description": "Flussi di lavoro documentali end-to-end per team e clienti",
          "feature_ai_powered": "Automazione e generazione di documenti basati sull'intelligenza artificiale",
          "feature_client_portals": "Portali dei clienti personalizzati",
          "feature_hippa_finra_support": "Supporto per conformità normativa HIPAA, FINRA e SEC",
          "feature_tools": "Strumenti collaborativi per i clienti: firma elettronica, richieste, attività, moduli, automazione dei flussi di lavoro",
          "features_header": "Tutte le funzionalità Advanced, più:",
          "title": "Premium"
        },
        "save_with_annual_btn": "Risparmia il 10% con la fatturazione annuale",
        "standard": {
          "feature_all_storage": "Tutto lo spazio di archiviazione di cui hai bisogno",
          "feature_file_encryption": "Crittografia file",
          "feature_sync_edit_share": "Sincronizzare, modificare, condividere",
          "feature_unlimited_client": "Utenti cliente illimitati",
          "features_header": "Le caratteristiche includono:",
          "title": "Standard",
          "title_0gb": "Standard 0 GB"
        },
        "storage": "Archiviazione",
        "storage_per_user": "{{storage}} per utente",
        "upgrade_btn": "Aggiornamento",
        "upgrade_plan": "Aggiorna il piano",
        "users": "Utenti",
        "users_count": "{{count}} utenti",
        "users_count_one": "{{count}} utente",
        "vdr": {
          "feature_click_trails": "Percorsi di clic",
          "feature_folder_qa": "Domande e risposte sulle cartelle",
          "feature_visibility_analytics": "Visibilità, analisi e altro ancora",
          "features_header": "Protezione specializzata che comprende:",
          "title": "Virtual Data Room"
        }
      },
      "payment_gateway": {
        "authorization_error": "Impossibile verificare la carta. Accertarsi di aver immesso i dati correttamente e riprovare.",
        "authorization_error_title": "Verifica della carta non riuscita",
        "contact_details": "Dati di contatto",
        "form": {
          "card_number": "Numero della carta",
          "cardholder_name": "Titolare della carta",
          "date_validation": {
            "expired": "La carta è scaduta",
            "invalid_date": "Data non valida",
            "invalid_month": "Mese non valido",
            "no_date_provided": "Immettere data di scadenza"
          },
          "expiration_date": "Data di scadenza",
          "payment_details": "Dati di pagamento",
          "payment_details_description": "{<asterisk>} indica un campo obbligatorio",
          "security_code": "Codice di sicurezza",
          "security_code_description": "3 cifre sul retro della carta o 4 cifre sul fronte della carta"
        },
        "iframe_description": "Fare clic su ”Nuovo” per aggiungere una nuova carta di pagamento.",
        "iframe_load_error": "Errore durante il caricamento dei dati della carta di credito. Riprovare più tardi o contattare il supporto.",
        "modal_title": "Immettere i dati di pagamento",
        "modal_title_legacy": "Aggiungi/Modifica carta di pagamento"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Nome account:",
          "account_owner_label": "Proprietario account:",
          "allocated_licenses_label": "Licenze allocate:",
          "billing_cycle_month": "Mese",
          "billing_cycle_quarter": "Trimestre",
          "billing_cycle_year": "Anno",
          "cancel": "Annulla",
          "esig_licenses_out_of": "{{count}} di {{max}} licenze di firme elettroniche usate",
          "id_label": "ID:",
          "licenses_out_of": "{{count}} di {{max}} licenze di dipendenti usate",
          "next_billing_date_label": "Prossima data di fatturazione: ",
          "plan_label": "Piano:",
          "save": "Salva",
          "title": "Riepilogo account",
          "total_billing_cost_info_label": "Questo è il costo totale di tutti i prodotti ShareFile dell'organizzazione.",
          "total_billing_cost_label": "Costo totale di fatturazione:",
          "view_receipts_label": "Visualizza ricevute"
        },
        "cancel": "Annulla",
        "description": "La riattivazione dell'account manterrà attivi i servizi e riattiverà la fatturazione nell'account.",
        "left_nav_button_text": "Riattiva account",
        "lock_error": "Non è stato possibile gestire questa richiesta: è in corso l'elaborazione di una richiesta precedente.",
        "page_title": "Riattiva account",
        "reactivate_button": "Riattiva",
        "reactivate_failed": "Impossibile riattivare l'account. Contattare il nostro team di supporto all’indirizzo sales@sharefile.com o chiamare il numero 1 (800)-441-3453.",
        "reactivate_success": "L'account è stato riattivato."
      },
      "receipts": {
        "actions": {
          "download": "Scarica",
          "pay": "Paga",
          "title": "Azioni"
        },
        "awaiting_payment_tooltip": "La visualizzazione dell’avvenuto pagamento delle fatture in questa pagina potrebbe richiedere fino a 24 ore.",
        "billing_system_change": "Recentemente abbiamo apportato modifiche ai nostri sistemi di fatturazione che influiranno sulle modalità di pagamento delle fatture emesse da ShareFile. Per tutte le fatture emesse dopo il {<migrationDate>} il file della fattura riporta un collegamento per il pagamento diretto. Le fatture emesse prima del {<migrationDate>} non riporteranno questo collegamento; contattare il supporto per effettuare il pagamento.",
        "cancel": "Annulla",
        "credit_card_notifications": {
          "payment_approved": "Pagamento approvato. Grazie!",
          "payment_failure": "Pagamento con carta di credito non riuscito. Contattare il supporto."
        },
        "date": "Data aggiunta",
        "email": "E-mail",
        "error_getting_logs": "Errore durante il recupero delle ricevute di pagamento delle fatture. Riprovare più tardi.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Ricevute e notifiche di fatturazione",
        "open_payment": "L’account ha un pagamento in sospeso.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "Questa pagina comprende un elenco di tutte le ricevute di pagamento delle fatture emesse da ShareFile. La visualizzazione dell’avvenuto pagamento delle fatture in questa pagina potrebbe richiedere fino a 24 ore.",
        "page_title": "Ricevute e notifiche di fatturazione",
        "pay_now": "paga",
        "phone": "Telefono",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "Stato",
        "status_approved": "Approvato",
        "status_awaiting_payment": "In attesa di pagamento",
        "status_cleared": "Pagato",
        "status_failed": "Operazione non riuscita",
        "status_invoice_payment_received": "Pagamento della fattura ricevuto",
        "status_negated": "Negato",
        "status_open": "Apri",
        "status_paid": "Pagato",
        "status_pending": "In sospeso",
        "status_tax_credited": "Imposte accreditate",
        "status_tax_negated": "Imposte negate",
        "status_transaction_credited": "Transazione accreditata",
        "type": "Tipo"
      }
    }
  },
  {
    "key": "ja",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "アカウントの住所",
        "address_information": "住所の情報",
        "billing_address_same_message": "請求先住所はアカウントの住所と同じです。",
        "buy_canada_tax_free": "カナダの免税品を購入する場合",
        "buy_canada_tax_free_description": "GST/HST および QST 番号を使用すると、購入品の税金が免除されます。これらの番号が記入されていない場合、購入品に税金が適用されます。ブリティッシュ コロンビア州、マニトバ州、およびサスカチュワン州での購入品には、証明書の検証が必要です。購入を完了する前に、証明書を {<contact_email>} まで送信してください。こちらからすぐに改めてご連絡させていただきます。",
        "city": "市区町村",
        "country": "国",
        "country_not_supported_message": "所属する国を変更するには、弊社の {<sales_team>} に支援を要請してください。",
        "disable_trial_conversion_message": "所属する国の最適なプランを見つけるには、弊社のチームにお問い合わせください。{<live_chat>} を通じてお問い合わせください。",
        "enter_address_manually": "住所を手動で入力する",
        "european_vat_id": "ヨーロッパの VAT ID",
        "gst_hst_number": "GST/HST 登録番号",
        "postal_code": "郵便番号",
        "province": "州",
        "pst_number": "PST 登録番号",
        "qst_number": "QST 登録番号",
        "sfi_message": "指定金融機関である場合",
        "state": "都道府県",
        "street": "番地",
        "suggestions_attribution": "Google による提案",
        "suggestions_not_found": "住所が見つかりません。もう一度試すか、代わりに住所を手動で入力できます。",
        "tax_tooltip": "ここに企業の税金 ID を入力します。そうすることで、インボイスに対して適切な税金処理が行われます。",
        "title": "請求先住所",
        "validation_message": {
          "city_required": "市区町村は必須です。",
          "country_required": "国は必須です。",
          "province_required": "州は必須です。",
          "state_required": "都道府県は必須です。",
          "street_required": "番地を入力してください。",
          "tax_invalid": "企業の税金 ID を検証できませんでした。情報を確認して再試行してください。",
          "zip_required": "郵便番号は必須です。"
        },
        "zip": "郵便番号"
      },
      "call_to_action": {
        "cancel": "キャンセル",
        "clear": "消去",
        "submit": "送信"
      },
      "cancel_account": {
        "cancel_account": "アカウントのキャンセル",
        "cancel_trial": "トライアルのキャンセル",
        "contact_information": {
          "call_international": "そのほかの国：+1 919.745.6111",
          "call_toll_free": "フリーダイヤル：1.800.441.3453",
          "call_uk": "英国: +44 (0800) 680.0621",
          "here_for_you": "ここからご連絡いただけます",
          "visit_support": "サポートにアクセスする"
        },
        "contact_us": "弊社への問合せ",
        "continue_cancellation": "キャンセルの続行",
        "did_you_know": "ご存知でしたか?",
        "did_you_know_desc": "ShareFile アカウントをキャンセルすると、次のようなさまざまな有用な機能を利用できなくなります。",
        "download_now": "すぐにダウンロードする",
        "error_banner": "キャンセルできませんでした。もう一度試すか、サポート チームに連絡してください",
        "features": {
          "customer_access": "カスタマー用の無制限のアクセス",
          "customer_access_desc": "御社のカスタマーにファイルへの無料アクセスを提供し、カスタマーがどのファイルを表示できるのかを管理します。",
          "customer_support": "カスタマー サポート",
          "customer_support_desc": "(メールまたは電話)。サポートを提供します。",
          "esignature": "電子署名",
          "esignature_desc": "署名のためファイルを ShareFile アカウントから直接送信します。",
          "sharefile_mobile": "ShareFile モバイル アプリケーション",
          "sharefile_mobile_desc": "スマートフォンやタブレットを使ってファイルやフォルダーにいつでもアクセスします。",
          "sharefile_plugin": "ShareFile Plugin for Microsoft Outlook",
          "sharefile_plugin_desc": "サイズの大きなファイルを Outlook から直接セキュリティで保護して送信。",
          "total_security": "全体的なセキュリティ",
          "total_security_desc": "データ保護を信頼する。"
        },
        "form": {
          "account_name": "アカウント名",
          "back_to_admin": "アカウント管理に戻る",
          "cancel_my_account": "マイアカウントのキャンセル",
          "cancel_my_trial": "マイトライアルのキャンセル",
          "cancellation_reason": {
            "Lacks_required_compliance": "必要な準拠が不足しています",
            "lack_of_integrations": "統合が不足しています",
            "lacks_required_feature": "必要な機能が不足しています",
            "no_longer_needed": "もう必要ありません",
            "poor_account_support": "アカウント サポートが不十分です (セールス、テクニカル)",
            "prefer_competitive_product": "優位性のある製品を希望する",
            "security_concerns": "セキュリティー上の懸念",
            "technical_issues": "技術的な問題",
            "too_difficult_to_use": "使用が困難",
            "too_expensive": "高すぎる"
          },
          "comments_label": "コメント",
          "comments_placeholder": "アカウントをキャンセルする理由について、もう少しお聞かせください。よろしければ、ShareFile をより良いものにするためのご意見をお聞かせいただけると嬉しく思います。",
          "employees_desc": "購入した {{employeeMax}} のうち {{employeeCount}} を使用",
          "employees_title": "従業員",
          "forgot_your_password": "パスワードを忘れた場合",
          "more_info": "アカウントをキャンセルする理由について、もう少しお聞かせください。",
          "once_you_cancel": "キャンセルすると、ShareFile は 30 日後にファイルを削除いたします。",
          "password_label": "アカウント パスワードを入力",
          "password_missing": "アカウント パスワードを入力してください",
          "password_placeholder": "パスワード",
          "reason_missing": "理由を選択してください",
          "required": "必須",
          "storage_usage_desc": "{{mbMax}} のうち {{mbUsed}} MB を使用 ({{dateFormatted}} 現在)",
          "storage_usage_title": "ストレージ使用量",
          "title": "次の理由により、ShareFile アカウントをキャンセルしようとしています:",
          "to_authorize": "ShareFile による 30 日後のファイル削除を認証するため、アカウント パスワードを入力してアカウントのキャンセルを続行してください。"
        },
        "in_progress_banner": "アカウントの更新中です。これには時間がかかる場合があるため、後から確認してください。",
        "learn_more": "詳細情報を表示する",
        "let_us_help_1": "ShareFile アカウントのさまざまな機能についてご案内いたします。",
        "let_us_help_2": "カスタマー ケア チームに連絡して、",
        "let_us_help_3": "ShareFile のさまざまな機能についてご確認ください。",
        "modal_confirm": "OK",
        "modal_message": "アカウントはキャンセルされましたが、請求サイクルが終了するまで有効です。管理者メニューの [アカウントの再アクティブ化] をクリックすると、アカウントを再アクティブ化することができます。",
        "modal_message_trial": "トライアルがキャンセルされました。ShareFile をお試しいただきありがとうございました。アカウント管理メニューの [アカウントの再アクティブ化] をクリックすると、アカウントを再アクティブ化することができます。",
        "modal_title": "アカウントがキャンセルされました",
        "modal_title_trial": "トライアルがキャンセルされました",
        "password_was_incorrect": "パスワードが違います",
        "resources_card": {
          "ask_the_community": "コミュニティへの問い合わせ",
          "sharefile_knowledgebase": "ShareFile ナレッジベース",
          "title": "これらのリソースをお試しになりましたか?",
          "training_videos": "トレーニング ビデオ"
        },
        "sorry_to_go": "ご利用いただきありがとうございました。",
        "sorry_to_go_desc": "ShareFile はお客様のことを念頭に置いて設計されており、弊社は常にサービスの向上ならびにお客様のファイル共有やストレージに対するニーズを満たすよう心がけています。"
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "エラーが発生しました",
        "live_chat": "ライブ チャット",
        "sales_team": "セールス チーム"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(10% 割引)",
          "choose_billing_cycle": "請求サイクルの選択",
          "choose_billing_cycle_text": "価格は、従業員ユーザーの総数に基づいています。",
          "online_only": "(オンラインのみ)",
          "pay_annually": "年払い",
          "pay_monthly": "月払い"
        },
        "buttons": {
          "buy_now": "すぐに購入する",
          "cancel": "キャンセル",
          "continue": "続行",
          "convert_now": "すぐに変更する",
          "convert_now_tooltip": "変更する前に、住所とクレジット カードを確認する必要があります。"
        },
        "convert_modal": {
          "confirm_purchase": "購入の確認",
          "confirm_purchase_description": "[すぐに変更する] を選択すると、今日 {<billingRate>} (適用される税金が加算されます) が請求され、アカウントが有料アカウントに変更されます。"
        },
        "credit_card": {
          "add": "追加",
          "confirmed": "クレジット カードが確認されました",
          "confirmed_description": "クレジット カード情報が認証されました。",
          "declined": "クレジット カードが拒否されました",
          "declined_description": "カードを認証できませんでした。入力した内容が正しいことを確認して、もう一度試してください。",
          "edit": "編集",
          "error_message": "クレジット カードの認証に失敗しました。クレジット カード情報を確認して、もう一度試してください。",
          "information": "カード情報"
        },
        "current_licenses": "従業員ライセンス: {{users}}",
        "current_storage": "ストレージ: {{storage}} GB",
        "employee_accounts": "従業員アカウント",
        "employee_accounts_description": "プランには、{{users}} 従業員アカウントが含まれ、以下のプランに追加のアカウントを追加できます。",
        "employee_accounts_description_vdr": "プランには、{{users}} 従業員ライセンスと {{storage}} GB のストレージが含まれます。以下を追加できます。",
        "employee_licenses": "従業員ライセンス",
        "employee_licenses_storage": "従業員ライセンスとストレージ",
        "error_loading_plans": "プランの読み込み中にエラーが発生しました。後でもう一度試してください。",
        "left_nav_button_text": "無料トライアルを変更",
        "month": "月額",
        "number_of_users_selection": {
          "title": "ユーザーの数",
          "user_limit_message": "選択したプランで許可されるのは、最小 {{min}} ユーザーと最大 {{max}} ユーザーです。"
        },
        "plan": {
          "base_employee_accounts": "{{employee}} 従業員アカウント",
          "max_file_size": "100GB",
          "max_storage": "1TB/ライセンス",
          "max_storage_vdr": "1GB/ライセンス",
          "storage": "{{storage}} ストレージ"
        },
        "plan_chart": {
          "need_help": "必要なサポートを提供いたします。その他のプラン オプションについては、メール (sales@sharefile.com) または電話 (1 (800)-441-3453) でサポートにお問い合わせください。",
          "upgrade_plan": "プランのアップグレード",
          "view_detailed_comparison": "比較の詳細を表示する"
        },
        "plan_summary": {
          "annually": "年単位の",
          "billing": "請求",
          "monthly": "月単位",
          "plan": "{{name}} プラン",
          "plus_applicable_taxes": "最終的な税金 (該当する場合) がインボイスに含まれます。",
          "storage_max_file_size": "ストレージ/最大ファイル サイズ: {<storage_details>}",
          "users": "ユーザー",
          "your_total": "合計"
        },
        "purchase_confirmed": "購入が確認されました",
        "something_went_wrong": "何かしらの問題が発生しました",
        "storage_distribution_description": "ストレージはライセンス供与されたすべての従業員の間で共有され、ユーザーごとに制限されていません。",
        "storage_gb": "{{storage}} GB",
        "storage_only": "ストレージ",
        "successful_conversion": "アカウントの変更に成功しました。",
        "title": "無料トライアルを変更",
        "try_again_or_contact_support": "もう一度試すか、支援が必要な場合は、サポートに連絡してください。",
        "upgrade_failed": "アップグレードできません"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "請求先住所",
          "city": "市区町村",
          "country": "国",
          "state_province": "都道府県/州",
          "street": "住所 1",
          "zip_postal_code": "郵便番号"
        },
        "cancel": "キャンセル",
        "credit_card": {
          "card_details": "クレジット カードの詳細",
          "card_exp_date": "有効期限日",
          "card_first_name": "名",
          "card_last_name": "姓",
          "card_number": "カード番号",
          "card_type": "カード種類",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "クレジット カードの種類がサポートされていません。Visa、Mastercard、または American Express を使用してください",
          "card_type_unknown": "不明",
          "card_type_visa": "Visa",
          "title": "クレジット カード情報"
        },
        "credit_card_notifications": {
          "add_successful": "クレジット カード情報が追加されました。",
          "save_failure": "クレジット カード情報を保存できませんでした",
          "update_failure": "クレジット カード情報の更新に失敗しました",
          "update_successful": "クレジット カード情報が更新されました。"
        },
        "disable_trial_conversion_message": "所属する国の最適なプランを見つけるには、弊社のチームにお問い合わせください。{<live_chat>} を通じてお問い合わせください。",
        "edit": "編集",
        "get_billing_info_failed": "請求情報を取得中にエラーが発生しました。後でもう一度試してください。",
        "info_banner": "注: 請求情報の更新はすぐに反映されない場合があります。以下に変更内容が表示されるまで最大 24 時間かかります。",
        "left_nav_button_text": "請求情報の編集",
        "name_on_card": "カードに記載されている名前",
        "no_billing_info_banner": "現在このページを読み込むことができません。請求情報を編集するには、カスタマー サービス チームにお問い合わせください。",
        "province": "州",
        "save": "保存",
        "state": "都道府県",
        "support": {
          "chat_with_us": "担当者とチャットする",
          "contact_support": "アドレスを確認できません。サポートに連絡してください。",
          "contact_support_info": "サポートに連絡"
        },
        "title": "請求情報の編集",
        "update": "更新",
        "update_billing_type": {
          "info_message": "現在の請求の種類は {<invoice>} です。クレジット カード支払いに切り替えることができます。",
          "invoice": "インボイス",
          "switch_to_credit_card": "クレジット カードに切り替える",
          "title": "請求の種類を更新"
        },
        "update_notifications": {
          "contact_support": "サポートに連絡",
          "save_failed": "保存できません",
          "save_success": "変更が保存されました。",
          "something_went_wrong": "何かしらの問題が発生しました",
          "try_again": "アドレスを確認できません。もう一度試してください。",
          "try_again_or_contact_support": "もう一度試すか、支援が必要な場合は、{<contactSupport>}。"
        },
        "vat_id": "VAT ID",
        "verify_address": "アドレスの検証"
      },
      "expiration": {
        "account_canceled_first": "管理者から依頼があった場合、請求の支払い期限が過ぎた場合、またはサービス利用契約に違反があった場合、アカウントはキャンセルされます。",
        "account_canceled_second": "このアカウントとそのすべてのデータは、{{date}} 日 (またはその数日以内) に完全に削除されます。その日までアカウントを引き続き使用して、ShareFile に保存したすべてのものを取得できます。アカウントが削除されると、ファイルとアカウントに関連付けられているユーザーはすべて取り戻すことはできません。",
        "account_canceled_title": "このアカウントはキャンセルされました",
        "ask_to_purchase": "購入を依頼する",
        "continue_to_sharefile": "ShareFile に移動",
        "logo_alt_text": "ShareFile ロゴ",
        "notification_error_message": "管理者への通知の送信に失敗しました。再試行してください。",
        "purchase": {
          "error_modal": {
            "close": "閉じる",
            "sub_title": "アカウントの設定を終了するには、1-800-441-3453 までお電話ください。エラー コード {<errorCode>} をお知らせください。",
            "title": "追加の情報が必要です"
          },
          "loading_modal": {
            "sub_title": "すべての設定が終了するまでしばらくお待ちください。",
            "title": "ShareFile アカウントをアップグレードしています"
          },
          "select_plan": "プランの選択",
          "title": "ShareFile の購入"
        },
        "purchase_account": "アカウントの購入",
        "reactivate_account": "アカウントの再アクティブ化",
        "request_reactivation": "再アクティブ化の要求",
        "request_sent": "送信の要求",
        "something_went_wrong": "何かしらの問題が発生しました",
        "trial_ended_first": "トライアル期間は {{date}} 日に終了しました。引き続き ShareFile を使用するには、アカウントを購入してください。",
        "trial_ended_second": "トライアル アカウントは、通常、トライアル終了 60 日後に削除されることに注意してください。アカウントが削除されると、ファイルとアカウントに関連付けられているユーザーはすべて取り戻すことはできません。",
        "trial_ended_title": "トライアルが終了しました"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "1 日",
          "days_left_in_your_trial": "トライアルは残り {<dayCount>} 日です。 ",
          "upgrade_to_a_plan": "プランへのアップグレード"
        }
      },
      "invalid_address_error": "入力したアドレスは無効です。もう一度試してください。",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "以前のリクエストが処理中であるため、このリクエストを処理できませんでした。",
      "manage_plan": {
        "add_storage_btn": "ストレージを追加",
        "add_users_btn": "ユーザーを追加",
        "advanced": {
          "description": "チーム向けのセキュアなファイル共有",
          "feature_access_control": "詳細なアクセス制御と基本的なレポート作成",
          "feature_encryption": "暗号化ファイルのストレージと共有",
          "feature_secure_email": "セキュアな E メール統合とリアルタイムの共同編集",
          "features_header": "主な機能:",
          "title": "Advanced",
          "title_0gb": "Advanced 0GB"
        },
        "connectors": {
          "title_0gb": "コネクタ 0GB"
        },
        "contact_support": "その他のプラン オプションについては、サポートにお問い合わせください",
        "current_plan": "現在のプラン",
        "for_accounting": "For Accounting",
        "get_usageplan_failed": "プラン情報を取得中にエラーが発生しました。後でもう一度試してください。",
        "included": "含まれる",
        "industry_advantage": {
          "description": "事前構築済みの会計固有のドキュメント ワークフローの自動化",
          "feature_bulk_client_onboarding": "クライアントの一括オンボード (会計案件用)",
          "feature_centralized_view": "すべての案件を 1 か所にまとめて表示",
          "feature_tax_templates": "税金案件用の事前構築済みテンプレート",
          "features_header": "すべての Premium 機能および次の機能:",
          "title": "Industry Advantage",
          "tooltip": "会計の税金プロセス用のシームレスなエンドツーエンドのユースケースを促進するために設計された最適なワークフローにより、効率と標準化の向上を図る"
        },
        "left_nav_button_text": "プランの管理",
        "manage_plan_title": "プランの管理",
        "message_after_update": "プランの更新中です。これには時間がかかる場合があるため、後から確認してください。",
        "modals": {
          "add_button": "追加",
          "additional_users": "追加のユーザー",
          "alert_message": "{<boldText>} を選択された場合、プランのコストの差額は日割り計算で請求させていただきます。",
          "annual_billing_note": "年払いの初回の期限は {{date}} になります。",
          "annual_billing_text": "年払いで ShareFile プランが 10% お得になります。新しいプランのコストの概要は次のとおりです。",
          "annual_billing_title": "年単位の請求",
          "cancel_button": "キャンセル",
          "error_alert": "プランを更新できませんでした。もう一度試してください。",
          "extended_storage": "{{count}} TB の拡張ストレージ",
          "new_billing_amount": "新しい請求額",
          "new_monthly_total": "月払いの新しい合計額",
          "new_plan_total": "プランの新しい合計額",
          "new_storage_total": "ストレージの新しい合計数",
          "new_user_total": "ユーザーの新しい合計数",
          "per_month": "{{price}}/月*",
          "per_quarter": "{{price}}/四半期*",
          "per_year": "{{price}}/年*",
          "plus_applicable_taxes": "* 適用される税金が加算されます",
          "price_per_TB": "{{price}}/3 TB",
          "price_per_user": "{{price}}/ユーザー",
          "storage_add": "ストレージを追加",
          "storage_data_breakdown_message": "現在、{<usedValue>} TB/{<total>} TB のストレージを使用しています。",
          "storage_modal_title": "ストレージを追加",
          "storage_need_additional": "ストレージの追加が必要ですか?",
          "success_alert": "更新されたプラン",
          "switch_to_annual_button": "年単位の請求に切り替える",
          "upgrade_button": "アップグレード",
          "upgrade_plan_modal_title": "プランのアップグレード",
          "users_add": "ユーザーを追加",
          "users_count": "{{count}} ユーザー",
          "users_data_breakdown_message": "現在、{<usedValue>} ユーザー/{<total>} ユーザーを使用しています。",
          "users_modal_title": "ユーザーを追加",
          "users_need_additional": "ユーザーの追加が必要ですか?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "よく使われている",
        "need_help": "サポートへのご連絡はこちらから。{<contact_support>}",
        "next_billing_date_pending": "次回請求日",
        "per_month": "月額",
        "per_quarter": "四半期額",
        "per_year": "年額",
        "plus_taxes": "* 適用される税金が加算されます",
        "premium": {
          "description": "チームおよびクライアント向けのエンドツーエンドのドキュメント ワークフロー",
          "feature_ai_powered": "AI によるドキュメントの自動化および生成",
          "feature_client_portals": "カスタム ブランドのクライアントポータル",
          "feature_hippa_finra_support": "HIPAA、FINRA および SEC のコンプライアンス遵守のサポート",
          "feature_tools": "クライアントコラボレーションツール - 電子署名、リクエスト、タスク、フォーム、ワークフローの自動化",
          "features_header": "すべての Advanced 機能および次の機能:",
          "title": "Premium"
        },
        "save_with_annual_btn": "年単位の請求で 10% 割引",
        "standard": {
          "feature_all_storage": "必要なすべてのストレージ",
          "feature_file_encryption": "ファイルの暗号化",
          "feature_sync_edit_share": "同期、編集、共有",
          "feature_unlimited_client": "無制限のクライアント ユーザー",
          "features_header": "次の機能が含まれる:",
          "title": "Standard",
          "title_0gb": "Standard 0GB"
        },
        "storage": "ストレージ",
        "storage_per_user": "{{storage}}/ユーザー",
        "upgrade_btn": "アップグレード",
        "upgrade_plan": "プランのアップグレード",
        "users": "ユーザー",
        "users_count": "{{count}} ユーザー",
        "users_count_one": "{{count}} ユーザー",
        "vdr": {
          "feature_click_trails": "クリック証跡",
          "feature_folder_qa": "質問と回答 - フォルダー",
          "feature_visibility_analytics": "可視性、分析機能など",
          "features_header": "次を含む特殊な保護機能:",
          "title": "Virtual Data Room"
        }
      },
      "payment_gateway": {
        "authorization_error": "カードを認証できませんでした。入力した内容が正しいことを確認して、もう一度試してください。",
        "authorization_error_title": "カードの認証に失敗しました",
        "contact_details": "連絡先の詳細",
        "form": {
          "card_number": "カード番号",
          "cardholder_name": "カード名義人氏名",
          "date_validation": {
            "expired": "カードの有効期限が切れています",
            "invalid_date": "無効な日付",
            "invalid_month": "無効な月",
            "no_date_provided": "有効期限を入力してください"
          },
          "expiration_date": "有効期限",
          "payment_details": "支払いの詳細",
          "payment_details_description": "{<asterisk>} は必須フィールドを示しています",
          "security_code": "セキュリティ コード",
          "security_code_description": "カードの裏にある 3 桁またはカードの表にある 4 桁"
        },
        "iframe_description": "[新規] をクリックして、新しい支払いカードを追加します。",
        "iframe_load_error": "クレジット カードの詳細の読み込み中にエラーが発生しました。後でもう一度試すか、サポートまで連絡してください。",
        "modal_title": "支払いの詳細を入力",
        "modal_title_legacy": "支払いカードの追加/編集"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "アカウント名：",
          "account_owner_label": "アカウント所有者：",
          "allocated_licenses_label": "割り当てられたライセンス:",
          "billing_cycle_month": "月",
          "billing_cycle_quarter": "四半期",
          "billing_cycle_year": "年",
          "cancel": "キャンセル",
          "esig_licenses_out_of": "{{max}}の電子署名ライセンスのうち{{count}}が使用されています",
          "id_label": "ID:",
          "licenses_out_of": "{{max}}の従業員ライセンスのうち{{count}}が使用されています",
          "next_billing_date_label": "次回請求日： ",
          "plan_label": "プラン:",
          "save": "保存",
          "title": "アカウントの概要",
          "total_billing_cost_info_label": "これは、組織のすべての ShareFile 製品に関する合計コストです。",
          "total_billing_cost_label": "合計請求コスト:",
          "view_receipts_label": "受領書を表示する"
        },
        "cancel": "キャンセル",
        "description": "アカウントを再アクティブ化すると継続してサービスを使用でき、アカウントでの課金を再度有効にできます。",
        "left_nav_button_text": "アカウントの再アクティブ化",
        "lock_error": "以前のリクエストが処理中であるため、このリクエストを処理できませんでした。",
        "page_title": "アカウントの再アクティブ化",
        "reactivate_button": "再アクティブ化",
        "reactivate_failed": "アカウントを再アクティブ化できません。メール (sales@sharefile.com) または電話 (1 (800)-441-3453) で弊社のサポート チームにお問い合わせください。",
        "reactivate_success": "アカウントは再アクティブ化されました。"
      },
      "receipts": {
        "actions": {
          "download": "ダウンロード",
          "pay": "支払い",
          "title": "操作"
        },
        "awaiting_payment_tooltip": "このページでインボイスが支払い済みとして表示されるまで最大 24 時間かかる場合があります。",
        "billing_system_change": "最近、弊社の請求システムに、ShareFile のインボイスへの支払い方法に影響を与える変更を行いました。{<migrationDate>} より後に送信されたすべてのインボイスについては、インボイス ファイルに直接支払いを行えるリンクがあります。{<migrationDate>} より前に送信されたインボイスについては、このリンクが含まれていませんので、支払いを行うにはサポートに連絡してください。",
        "cancel": "キャンセル",
        "credit_card_notifications": {
          "payment_approved": "支払いが承認されました。ありがとうございます。",
          "payment_failure": "クレジット カードの支払いに失敗しました。サポートに連絡してください。"
        },
        "date": "追加された日付",
        "email": "メール",
        "error_getting_logs": "請求書の受領書を取得中にエラーが発生しました。後でもう一度試してください。",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "受領書および請求書の通知",
        "open_payment": "アカウントに未払いの支払いがあります。",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "このページには、ShareFile の請求書のすべての受領書の一覧があります。このページでインボイスが支払い済みとして表示されるまで最大 24 時間かかる場合があります。",
        "page_title": "受領書および請求書の通知",
        "pay_now": "支払い",
        "phone": "電話",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "状態",
        "status_approved": "承認済み",
        "status_awaiting_payment": "支払い待機中",
        "status_cleared": "削除済み",
        "status_failed": "失敗",
        "status_invoice_payment_received": "インボイスの支払いは受領されました",
        "status_negated": "拒否されました",
        "status_open": "未払い",
        "status_paid": "支払い済み",
        "status_pending": "保留",
        "status_tax_credited": "税金が計上されました",
        "status_tax_negated": "税金が拒否されました",
        "status_transaction_credited": "トランザクションが計上されました",
        "type": "種類"
      }
    }
  },
  {
    "key": "nl",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Accountadres",
        "address_information": "Adresinformatie",
        "billing_address_same_message": "Factuuradres is hetzelfde als accountadres.",
        "buy_canada_tax_free": "Canada Tax Free kopen?",
        "buy_canada_tax_free_description": "Als u uw GST/HST- en QST-nummers gebruikt, is uw aankoop vrijgesteld van belasting. Als u deze nummers niet invult, wordt er belasting geheven op uw aankoop. Voor aankopen in British Columbia, Manitoba en Saskatchewan is een certificaatvalidatie vereist. Stuur deze terug naar {<contact_email>} voordat u uw aankoop afrondt. We nemen zo spoedig mogelijk contact met u op.",
        "city": "Plaats",
        "country": "Land",
        "country_not_supported_message": "Neem contact op met onze {<sales_team>} fvoor hulp als u uw land wilt wijzigen.",
        "disable_trial_conversion_message": "Neem contact op met ons team om het beste abonnement voor uw land te vinden. Neem contact op via {<live_chat>}.",
        "enter_address_manually": "Adres handmatig invullen",
        "european_vat_id": "Europees BTW-nummer",
        "gst_hst_number": "GST/HST-registratienummer",
        "postal_code": "Postcode",
        "province": "Provincie",
        "pst_number": "PST-registratienummer",
        "qst_number": "QST-registratienummer",
        "sfi_message": "Bent u een geselecteerde financiële instelling (SLFI)?",
        "state": "Staat",
        "street": "Adres",
        "suggestions_attribution": "Suggesties van Google",
        "suggestions_not_found": "Adres niet gevonden. Probeer het opnieuw of voer het adres handmatig in.",
        "tax_tooltip": "Voer hier het btw-nummer van uw bedrijf in. Dit helpt bij het correct verwerken van de belasting op uw facturen.",
        "title": "Factuuradres",
        "validation_message": {
          "city_required": "Plaats is verplicht.",
          "country_required": "Land is verplicht.",
          "province_required": "Provincie is verplicht.",
          "state_required": "Staat is verplicht.",
          "street_required": "Voer uw straatnaam en huisnummer in.",
          "tax_invalid": "We konden uw belastingnummer niet valideren. Controleer en probeer het opnieuw.",
          "zip_required": "Postcode is verplicht."
        },
        "zip": "Postcode"
      },
      "call_to_action": {
        "cancel": "Annuleren",
        "clear": "Wissen",
        "submit": "Verzenden"
      },
      "cancel_account": {
        "cancel_account": "Account annuleren",
        "cancel_trial": "Proefperiode annuleren",
        "contact_information": {
          "call_international": "Internationaal: +1 919.745.6111",
          "call_toll_free": "Bel gratis: 1.800.441.3453",
          "call_uk": "VK: + 44 (0800) 680.0621",
          "here_for_you": "Wij zijn er om u te helpen",
          "visit_support": "Bezoek support"
        },
        "contact_us": "Neem contact met ons op",
        "continue_cancellation": "Doorgaan met annuleren",
        "did_you_know": "Wist u dat?",
        "did_you_know_desc": "Wanneer u uw ShareFile-account opzegt, mist u een hoop fantastische functies, waaronder:",
        "download_now": "Nu downloaden",
        "error_banner": "Kan niet annuleren. Probeer het opnieuw of neem contact op met ons ondersteuningsteam",
        "features": {
          "customer_access": "Onbeperkte toegang voor uw klanten",
          "customer_access_desc": "Biedt uw klanten gratis toegang tot bestanden en beheer welke bestanden ze kunnen zien.",
          "customer_support": "Klantenondersteuning",
          "customer_support_desc": "via e-mail of telefoon; wij zijn hier om u te helpen!",
          "esignature": "Digitale handtekening",
          "esignature_desc": "Verzend bestanden voor ondertekening rechtstreeks vanaf uw ShareFile-account.",
          "sharefile_mobile": "ShareFile Mobile Apps",
          "sharefile_mobile_desc": "Altijd toegang hebben tot bestanden en mappen vanaf uw smartphone of tablet.",
          "sharefile_plugin": "ShareFile plug-in voor Microsoft Outlook",
          "sharefile_plugin_desc": "Verzend grote bestanden veilig rechtstreeks uit Outlook.",
          "total_security": "Totale beveiliging",
          "total_security_desc": "Vertrouwen hebben in de beveiliging van uw gegevens."
        },
        "form": {
          "account_name": "Accountnaam",
          "back_to_admin": "Terug naar accountbeheer",
          "cancel_my_account": "Mijn account annuleren",
          "cancel_my_trial": "Mijn proefperiode annuleren",
          "cancellation_reason": {
            "Lacks_required_compliance": "Mist de vereiste conformiteit(en)",
            "lack_of_integrations": "Mist integraties",
            "lacks_required_feature": "Mist vereiste functie(s)",
            "no_longer_needed": "Niet langer nodig",
            "poor_account_support": "Slechte accountondersteuning (Sales, Techniek)",
            "prefer_competitive_product": "Geeft voorkeur aan competitief product",
            "security_concerns": "Bezorgdheid over veiligheid",
            "technical_issues": "Technische problemen",
            "too_difficult_to_use": "Te moeilijk te gebruiken",
            "too_expensive": "Te duur"
          },
          "comments_label": "Opmerkingen",
          "comments_placeholder": "Zou u ons kunnen toelichten waarom u uw account annuleert? Als u akkoord gaat, zouden wij ook graag horen wat wij kunnen doen om ShareFile voor u te verbeteren.",
          "employees_desc": "{{employeeCount}} van {{employeeMax}} gekocht",
          "employees_title": "Medewerkers",
          "forgot_your_password": "Wachtwoord vergeten?",
          "more_info": "Hebt u een moment om ons iets meer te vertellen waarom u uw account annuleert?",
          "once_you_cancel": "Als u annuleert, verwijdert ShareFile uw bestanden na 30 dagen.",
          "password_label": "Voer accountwachtwoord in",
          "password_missing": "Voer accountwachtwoord in",
          "password_placeholder": "Wachtwoord",
          "reason_missing": "Selecteer een reden",
          "required": "Vereist",
          "storage_usage_desc": "{{mbUsed}} van {{mbMax}} MB gebruikt vanaf {{dateFormatted}}",
          "storage_usage_title": "Opslaggebruik",
          "title": "Ik annuleer mijn ShareFile-account omdat:",
          "to_authorize": "Om ShareFile te machtigen uw bestanden na 30 dagen te verwijderen, voert u het wachtwoord voor uw account in om door te gaan met de annulering van uw account."
        },
        "in_progress_banner": "We zijn bezig met het bijwerken van uw account. Dit kan enige tijd duren, kom later nog eens terug!",
        "learn_more": "Meer informatie",
        "let_us_help_1": "Wij helpen u graag om meer uit uw ShareFile-account te halen.",
        "let_us_help_2": "Neem contact op met ons klantenondersteuningsteam",
        "let_us_help_3": "als u meer informatie wilt over deze en andere ShareFile-functies.",
        "modal_confirm": "OK",
        "modal_message": "Uw account is geannuleerd, maar blijft actief tot het einde van de factureringscyclus. U kunt uw account reactiveren door op \"Account reactiveren\" in het beheerdersmenu te klikken.",
        "modal_message_trial": "Uw proefabonnement is geannuleerd. Bedankt voor het proberen van ShareFile! U kunt uw account opnieuw activeren door op \"Account opnieuw activeren\" te klikken in het accountbeheermenu.",
        "modal_title": "Account geannuleerd",
        "modal_title_trial": "Proefabonnement geannuleerd",
        "password_was_incorrect": "Wachtwoord was onjuist",
        "resources_card": {
          "ask_the_community": "Vraag het de community",
          "sharefile_knowledgebase": "ShareFile Knowledge Base",
          "title": "Hebt u deze bronnen al geprobeerd?",
          "training_videos": "Trainingsvideo's"
        },
        "sorry_to_go": "Het spijt ons dat u weggaat!",
        "sorry_to_go_desc": "ShareFile is ontworpen met de gebruiker in gedachten. Wij zoeken altijd manieren om onze service te verbeteren en om te voldoen aan uw behoeften voor het delen en opslaan van bestanden."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "Er is een fout opgetreden",
        "live_chat": "live chat",
        "sales_team": "salesteam"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Bespaar 10%)",
          "choose_billing_cycle": "Kies uw facturatiecyclus",
          "choose_billing_cycle_text": "De prijs is gebaseerd op het totale aantal medewerkers.",
          "online_only": "(Alleen online)",
          "pay_annually": "Jaarlijks betalen",
          "pay_monthly": "Maandelijks betalen"
        },
        "buttons": {
          "buy_now": "Nu kopen",
          "cancel": "Annuleren",
          "continue": "Doorgaan",
          "convert_now": "Nu converteren",
          "convert_now_tooltip": "Controleer het adres en de creditcard voordat u converteert..."
        },
        "convert_modal": {
          "confirm_purchase": "Aankoop bevestigen",
          "confirm_purchase_description": "Als u \"Nu converteren\" selecteert, wordt er {<billingRate>} in rekening gebracht (plus toepasselijke belastingen) en wordt uw account omgezet naar een betaalde account."
        },
        "credit_card": {
          "add": "Toevoegen",
          "confirmed": "Creditcard bevestigd",
          "confirmed_description": "Uw creditcardgegevens zijn geverifieerd.",
          "declined": "Creditcard afgewezen",
          "declined_description": "We konden uw kaart niet verifiëren. Controleer of wat u hebt ingevoerd correct is en probeer het opnieuw.",
          "edit": "Bewerken",
          "error_message": "Verificatie van creditcard is mislukt. Controleer de creditcardinformatie en probeer het opnieuw.",
          "information": "Kaartgegevens"
        },
        "current_licenses": "Medewerkerslicenties: {{users}}",
        "current_storage": "Opslag: {{storage}} GB",
        "employee_accounts": "Medewerkersaccounts",
        "employee_accounts_description": "Uw abonnement bevat {{users}} medewerkersaccounts, u kunt hieronder extra rekeningen aan uw abonnement toevoegen.",
        "employee_accounts_description_vdr": "Uw plan bevat {{users}} medewerkerslicenties en {{storage}} GB opslagruimte. U kunt hieronder meer toevoegen.",
        "employee_licenses": "Medewerkerslicenties",
        "employee_licenses_storage": "Medewerkerslicenties en opslag",
        "error_loading_plans": "Er is een fout opgetreden bij het laden van uw abonnement. Probeer het later nog eens.",
        "left_nav_button_text": "Proefabonnement omzetten",
        "month": "per maand",
        "number_of_users_selection": {
          "title": "Aantal gebruikers",
          "user_limit_message": "Het geselecteerde abonnement staat minimaal {{min}} gebruikers toe en een maximum van {{max}} gebruikers."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} medewerkersaccounts",
          "max_file_size": "100 GB",
          "max_storage": "1TB/licentie",
          "max_storage_vdr": "1GB/licentie",
          "storage": "{{storage}} opslag"
        },
        "plan_chart": {
          "need_help": "Hulp nodig? Wij zijn er voor u. Neem contact op met support via sales@sharefile.com of bel +1 (800)-441-3453 voor meer opties.",
          "upgrade_plan": "Abonnement upgraden",
          "view_detailed_comparison": "Gedetailleerde vergelijking weergeven"
        },
        "plan_summary": {
          "annually": "Jaarlijks",
          "billing": "Facturering",
          "monthly": "Maandelijks",
          "plan": "{{name}}-abonnement",
          "plus_applicable_taxes": "Het uiteindelijke belastingbedrag wordt, indiien van toepassing, vermeld op de factuur.",
          "storage_max_file_size": "Opslag/Max. bestandsgrootte: {<storage_details>}",
          "users": "Gebruikers",
          "your_total": "Uw totaal"
        },
        "purchase_confirmed": "Aankoop bevestigd",
        "something_went_wrong": "Er is iets fout gegaan",
        "storage_distribution_description": "De opslagruimte wordt gedeeld door alle medewerkers met een licentie en is niet beperkt per gebruiker.",
        "storage_gb": "{{storage}} GB",
        "storage_only": "Opslag",
        "successful_conversion": "U hebt uw account met succes omgezet.",
        "title": "Proefabonnement omzetten",
        "try_again_or_contact_support": "Probeer het opnieuw of neem contact op met de ondersteuning voor verdere hulp.",
        "upgrade_failed": "Upgraden mislukt"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Factureringsadres",
          "city": "Plaats",
          "country": "Land",
          "state_province": "Provincie",
          "street": "Adres",
          "zip_postal_code": "Postcode"
        },
        "cancel": "Annuleren",
        "credit_card": {
          "card_details": "Creditcardgegevens",
          "card_exp_date": "Vervaldatum",
          "card_first_name": "Voornaam",
          "card_last_name": "Achternaam",
          "card_number": "Kaartnummer",
          "card_type": "Kaarttype",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "Type creditcard wordt niet ondersteund. Gebruik Visa, Mastercard of American Express",
          "card_type_unknown": "Onbekend",
          "card_type_visa": "Visa",
          "title": "Creditcardgegevens"
        },
        "credit_card_notifications": {
          "add_successful": "Creditcardgegevens toegevoegd!",
          "save_failure": "Kredietkaartgegevens zijn niet opgeslagen",
          "update_failure": "Bijwerken van creditcardgegevens mislukt",
          "update_successful": "Creditcardgegevens bijgewerkt!"
        },
        "disable_trial_conversion_message": "Neem contact op met ons team om het beste abonnement voor uw land te vinden. Neem contact op via {<live_chat>}.",
        "edit": "Bewerken",
        "get_billing_info_failed": "Er is een fout opgetreden bij het ophalen van uw facturatiegegevens. Probeer het later nog eens.",
        "info_banner": "Let op: updates in de factureringsinformatie worden mogelijk niet onmiddellijk weergegeven. Het kan 24 uur duren voordat de wijzigingen hieronder worden weergegeven.",
        "left_nav_button_text": "Factureringsinformatie bewerken",
        "name_on_card": "Naam op de kaart",
        "no_billing_info_banner": "We kunnen deze pagina momenteel niet laden. Neem contact op met ons klantenserviceteam om uw factureringsgegevens te bewerken.",
        "province": "Provincie",
        "save": "Opslaan",
        "state": "Staat",
        "support": {
          "chat_with_us": "Chat met ons",
          "contact_support": "Kan het adres niet verifiëren; neem contact op met Support.",
          "contact_support_info": "neem contact op met support"
        },
        "title": "Factureringsinformatie bewerken",
        "update": "Bijwerken",
        "update_billing_type": {
          "info_message": "Het huidige factuurtype is {<invoice>}. U kunt overschakelen op creditcardbetalingen.",
          "invoice": "factuur",
          "switch_to_credit_card": "Overschakelen op creditcard",
          "title": "Factureringstype bijwerken"
        },
        "update_notifications": {
          "contact_support": "neem contact op met support",
          "save_failed": "Kan niet opslaan",
          "save_success": "Uw wijzigingen zijn opgeslagen.",
          "something_went_wrong": "Er is iets fout gegaan",
          "try_again": "Kan adres niet verifiëren, probeer het opnieuw.",
          "try_again_or_contact_support": "Probeer het opnieuw of {<contactSupport>} voor verdere hulp."
        },
        "vat_id": "BTW-nummer",
        "verify_address": "Adres verifiëren"
      },
      "expiration": {
        "account_canceled_first": "Wij annuleren accounts wanneer beheerders ons hierom verzoeken, wanneer betalingen achterstallig zijn of wanneer onze servicevoorwaarden zijn geschonden.",
        "account_canceled_second": "Dit account en alle gegevens ervan worden definitief verwijderd op (of kort na) {{date}}. U kunt uw account tot die tijd blijven gebruiken om alles wat u in ShareFile hebt opgeslagen, op te halen. Zodra wij uw account verwijderen, kunnen alle bestanden en gebruikers die aan het account zijn gekoppeld, niet meer worden hersteld.",
        "account_canceled_title": "Dit account is geannuleerd",
        "ask_to_purchase": "Vraag om het aan te schaffen",
        "continue_to_sharefile": "Ga door naar ShareFile",
        "logo_alt_text": "ShareFile-logo",
        "notification_error_message": "Het verzenden van de melding naar de beheerder is mislukt. Probeer het opnieuw.",
        "purchase": {
          "error_modal": {
            "close": "Sluiten",
            "sub_title": "Bel ons op 1-800-441-3453 om de instelling van uw account te voltooien. Vermeld de foutcode: {<errorCode>}.",
            "title": "We hebben wat meer informatie nodig"
          },
          "loading_modal": {
            "sub_title": "Even geduld terwijl wij alles instellen.",
            "title": "We upgraden uw ShareFile-account."
          },
          "select_plan": "Selecteer abonnement",
          "title": "Koop ShareFile"
        },
        "purchase_account": "Koop account",
        "reactivate_account": "Reactieve account",
        "request_reactivation": "Vraag om heractivering",
        "request_sent": "Aanvraag verzonden",
        "something_went_wrong": "Er is iets fout gegaan",
        "trial_ended_first": "Uw proefperiode is op geëindigd op {{date}}. Om ShareFile te blijven gebruiken, moet u een account aanschaffen.",
        "trial_ended_second": "Houd er rekening mee dat proefaccounts normaal gesproken 60 dagen na afloop van de proefperiode worden verwijderd. Zodra dit gebeurt, kunnen alle bestanden en gebruikers die aan uw account zijn gekoppeld, niet meer worden hersteld.",
        "trial_ended_title": "Uw proefperiode is geëindigd"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "één dag",
          "day_count_plural": "{{count}} dagen",
          "days_left_in_your_trial": "U hebt nog {<dayCount>} over in uw proefperiode. ",
          "upgrade_to_a_plan": "Upgraden tot abonnement"
        }
      },
      "invalid_address_error": "Het ingevoerde adres is ongeldig. Probeer het opnieuw.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "We konden deze aanvraag niet verwerken terwijl een eerdere aanvraag wordt verwerkt.",
      "manage_plan": {
        "add_storage_btn": "Opslag toevoegen",
        "add_users_btn": "Gebruikers toevoegen",
        "advanced": {
          "description": "Veilig bestanden delen voor Teams",
          "feature_access_control": "Fijnmazige toegangscontrole en basisrapportages",
          "feature_encryption": "Versleutelde bestandsopslag en delen van bestanden",
          "feature_secure_email": "Veilige e-mailintegragtie en echt gelijktijdige bewerking van bestanden",
          "features_header": "Belangrijkste kenmerken:",
          "title": "Advanced",
          "title_0gb": "Advanced 0 GB"
        },
        "connectors": {
          "title_0gb": "Connectors 0 GB"
        },
        "contact_support": "Neem contact op met support voor meer abonnementsopties",
        "current_plan": "Huidig abonnement",
        "for_accounting": "Voor accounting",
        "get_usageplan_failed": "Er is een fout opgetreden bij het ophalen van uw abonnementsinformatie. Probeer het later nog eens.",
        "included": "Inbegrepen",
        "industry_advantage": {
          "description": "Kant-en-klare automatisering van de workfkow van documenten specifiek voor accounting",
          "feature_bulk_client_onboarding": "Importeer klanten in bulk voor accountingopdrachten",
          "feature_centralized_view": "Centraliseer en bekijk alle opdrachten op één plek",
          "feature_tax_templates": "Kant-en-klare sjabloons voor belastinggerelateerde opdrachten",
          "features_header": "Alle functies canb Premium, plus:",
          "title": "Industry Advantage",
          "tooltip": "Op maat gemaakte werkstromen die zijn ontworpen voor naadloze praktijkoplossingen voor belastingprocessen te faciliteren binnen accounting, waardoor de efficiëntie en standaardisatie worden verhoogd."
        },
        "left_nav_button_text": "Abonnement beheren",
        "manage_plan_title": "Abonnement beheren",
        "message_after_update": "We zijn bezig met het bijwerken van uw abonnement. Dit kan enige tijd duren, kom later nog eens terug!",
        "modals": {
          "add_button": "Toevoegen",
          "additional_users": "Extra gebruikers",
          "alert_message": "Als u {<boldText>} kiest, brengen we u een bedrag naar rato in rekening voor het verschil in abonnementskosten.",
          "annual_billing_note": "Uw eerste jaarlijkse betaling is verschuldigd op {{date}}.",
          "annual_billing_text": "U kunt 10% besparen op uw ShareFile-abonnement door jaarlijks te betalen. Hier is een overzicht van de kosten van uw nieuwe abonnement.",
          "annual_billing_title": "Jaarlijkse facturering",
          "cancel_button": "Annuleren",
          "error_alert": "We konden uw abonnement niet bijwerken. Probeer het opnieuw.",
          "extended_storage": "{{count}} TB extra opslag",
          "new_billing_amount": "Nieuw factuurbedrag",
          "new_monthly_total": "Nieuw maandtotaal",
          "new_plan_total": "Totaalbedrag nieuw abonnement",
          "new_storage_total": "Totaal nieuwe opslagruimte",
          "new_user_total": "Totaal aantal nieuwe gebruikers",
          "per_month": "{{price}} per maand*",
          "per_quarter": "{{price}} per kwartaal*",
          "per_year": "{{price}} per jaar*",
          "plus_applicable_taxes": "*plus toepasselijke belastingen",
          "price_per_TB": "{{price}} per 3 TB",
          "price_per_user": "{{price}} per gebruiker",
          "storage_add": "Opslag toevoegen",
          "storage_data_breakdown_message": "U gebruikt momenteel {<usedValue>} TB van uw {<total>} TB opslagruimte.",
          "storage_modal_title": "Opslag toevoegen",
          "storage_need_additional": "Extra opslagruimte nodig?",
          "success_alert": "Bijgewerkt abonnement.",
          "switch_to_annual_button": "Overschakelen naar jaarlijkse facturering",
          "upgrade_button": "Upgraden",
          "upgrade_plan_modal_title": "Abonnement upgraden",
          "users_add": "Gebruikers toevoegen",
          "users_count": "{{count}} gebruikers",
          "users_data_breakdown_message": "U gebruikt momenteel {<usedValue>} van uw {<total>} gebruikerslicenties.",
          "users_modal_title": "Gebruikers toevoegen",
          "users_need_additional": "Extra gebruikers nodig?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "Populairst",
        "need_help": "Hulp nodig? Wij zijn er voor u. {<contact_support>}",
        "next_billing_date_pending": "uw volgende factureringsdatum is",
        "per_month": "per maand",
        "per_quarter": "per kwartaal",
        "per_year": "per jaar",
        "plus_taxes": "*plus toepasselijke belastingen",
        "premium": {
          "description": "Complete werkstromen voor documenten voor Teams en klanten",
          "feature_ai_powered": "Door AI-gestuurde automatisering en generatie van documenten",
          "feature_client_portals": "Gepersonalseerde klantportalen met eigen merk",
          "feature_hippa_finra_support": "Ondersteuning voor naleving van HIPAA-, FINRA- en SEC-regelgeving",
          "feature_tools": "Hulpmiddelen voor samenwerking met klanten - elektronische handtekening, verzoeken, taken, formulieren, werkstroomautomatisering",
          "features_header": "Alle functies van Advanced, plus:",
          "title": "Premium"
        },
        "save_with_annual_btn": "Bespaar 10% met jaarlijkse facturering",
        "standard": {
          "feature_all_storage": "Alle opslagruimte die u nodig heeft",
          "feature_file_encryption": "Bestandsversleuteling",
          "feature_sync_edit_share": "Synchroniseren, bewerken, delen",
          "feature_unlimited_client": "Onbeperkte klantgebruikers",
          "features_header": "Functies zijn onder andere:",
          "title": "Standaard",
          "title_0gb": "Standaard 0 GB"
        },
        "storage": "Opslag",
        "storage_per_user": "{{storage}} per gebruiker",
        "upgrade_btn": "Upgraden",
        "upgrade_plan": "Abonnement upgraden",
        "users": "Gebruikers",
        "users_count": "{{count}} gebruikers",
        "users_count_one": "{{count}} gebruiker",
        "vdr": {
          "feature_click_trails": "Kliktrails",
          "feature_folder_qa": "Vragen/antwoorden over mappen",
          "feature_visibility_analytics": "Zichtbaarheid, analyse en meer",
          "features_header": "Gespecialiseerde beveiliging, waaronder:",
          "title": "Virtual Data Room"
        }
      },
      "payment_gateway": {
        "authorization_error": "We konden uw kaart niet verifiëren. Controleer of wat u hebt ingevoerd correct is en probeer het opnieuw.",
        "authorization_error_title": "Kaartverificatie mislukt",
        "contact_details": "Contactgegevens",
        "form": {
          "card_number": "Kaartnummer",
          "cardholder_name": "Naam kaarthouder",
          "date_validation": {
            "expired": "Kaar is verlopen",
            "invalid_date": "Ongeldige datum",
            "invalid_month": "Ongeldige maand",
            "no_date_provided": "Voer een expiratiedatum in"
          },
          "expiration_date": "Expiratiedatum",
          "payment_details": "Betalingsgegevens",
          "payment_details_description": "{<asterisk>} geeft een verplicht veld aan",
          "security_code": "Beveiligingscode",
          "security_code_description": "3 cijfers op de achterkant van de kaart of 4 cijfers op de voorkant"
        },
        "iframe_description": "Klik op \"Nieuw\" om een nieuwe betaalkaart toe te voegen.",
        "iframe_load_error": "Er is een fout opgetreden bij het laden van uw creditcardgegevens. Probeer het later nog eens of neem contact op met de klantenservice.",
        "modal_title": "Voer de betalingsgegevens in",
        "modal_title_legacy": "Betaalkaart toevoegen/bewerken"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Accountnaam:",
          "account_owner_label": "Accounteigenaar:",
          "allocated_licenses_label": "Toegewezen licenties:",
          "billing_cycle_month": "Maand",
          "billing_cycle_quarter": "Kwartaal",
          "billing_cycle_year": "Jaar",
          "cancel": "Annuleren",
          "esig_licenses_out_of": "{{count}} van {{max}} digitale handtekeninglicenties gebruikt",
          "id_label": "ID:",
          "licenses_out_of": "{{count}} van {{max}} werknemerslicenties gebruikt",
          "next_billing_date_label": "Volgende factureringsdatum: ",
          "plan_label": "Abonnement:",
          "save": "Opslaan",
          "title": "Accoubtoverzicht",
          "total_billing_cost_info_label": "Dit zijn de totale kosten voor alle ShareFile-producten van uw organisatie.",
          "total_billing_cost_label": "Totale factureringskosten:",
          "view_receipts_label": "Ontvangstbewijzen weergeven"
        },
        "cancel": "Annuleren",
        "description": "Als u uw account opnieuw activeert, blijven uw services actief en wordt facturering opnieuw ingeschakeld voor uw account.",
        "left_nav_button_text": "Account opnieuw activeren",
        "lock_error": "We konden deze aanvraag niet verwerken terwijl een eerdere aanvraag wordt verwerkt.",
        "page_title": "Account opnieuw activeren",
        "reactivate_button": "Opnieuw activeren",
        "reactivate_failed": "Uw account kan niet opnieuw worden geactiveerd. Neem contact op met ons ondersteuningsteam via sales@sharefile.com of bel 1 (800)-441-3453.",
        "reactivate_success": "Uw account is opnieuw geactiveerd."
      },
      "receipts": {
        "actions": {
          "download": "Downloaden",
          "pay": "Betalen",
          "title": "Acties"
        },
        "awaiting_payment_tooltip": "Het kan tot 24 uur duren voordat facturen op deze pagina als betaald worden weergegeven.",
        "billing_system_change": "We hebben onlangs wijzigingen aangebracht in onze factureringssystemen die van invloed zullen zijn op de manier waarop u uw ShareFile-facturen betaalt. Voor alle facturen die na {<migrationDate>} zijn gepost, staat er een link voor directe betaling in het factuurbestand. Facturen die vóór {<migrationDate>} gepost zijn, bevatten deze link niet; neem contact op met support om een betaling uit te voeren.",
        "cancel": "Annuleren",
        "credit_card_notifications": {
          "payment_approved": "Betaling goedgekeurd. Dank u!",
          "payment_failure": "Betaling met creditcard mislukt. Neem contact op met support."
        },
        "date": "Datum toegevoegd",
        "email": "E-mail",
        "error_getting_logs": "Er is een fout opgetreden bij het ontvangen van uw ontvangstbewijzen van de facturen. Probeer het later nog eens.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Ontvangstbewijzen en factureringsberichten",
        "open_payment": "Er staat een betaling open op uw rekening.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "Deze pagina bevat een lijst met al uw ontvangstbewijzen van uw facturen voor ShareFile. Het kan tot 24 uur duren voordat facturen op deze pagina als betaald worden weergegeven.",
        "page_title": "Ontvangstbewijzen en factureringsberichten",
        "pay_now": "betalen",
        "phone": "Telefoon",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "Status",
        "status_approved": "Goedgekeurd",
        "status_awaiting_payment": "Wacht op betaling",
        "status_cleared": "Verwerkt",
        "status_failed": "Mislukt",
        "status_invoice_payment_received": "Betaling factuur ontvangen",
        "status_negated": "Verrekend",
        "status_open": "Openstaand",
        "status_paid": "Betaald",
        "status_pending": "In behandeling",
        "status_tax_credited": "Bijgeschreven belasting",
        "status_tax_negated": "Verrekende belasting",
        "status_transaction_credited": "Transactie gecrediteerd",
        "type": "Type"
      }
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "billing_address": {
        "abn_number": "ABN",
        "account_address": "Endereço da conta",
        "address_information": "Informações de endereço",
        "billing_address_same_message": "O endereço de faturamento é igual a endereço da conta.",
        "buy_canada_tax_free": "A compra no Canadá não inclui impostos?",
        "buy_canada_tax_free_description": "O uso de seus números GST/HST e QST isentará sua compra de impostos. Se você não preencher esses números, o imposto será aplicado à sua compra. Para compras na Colúmbia Britânica, Manitoba e Saskatchewan, é necessária uma validação por certificado. Envie para {<contact_email>} antes de concluir a compra. Entraremos em contato em breve.",
        "city": "Cidade",
        "country": "País",
        "country_not_supported_message": "Para alterar o país, contate o {<sales_team>} para obter ajuda.",
        "disable_trial_conversion_message": "Conecte-se com sua equipe para explorar o melhor plano para o seu país. Entre em contato via {<live_chat>}.",
        "enter_address_manually": "Inserir endereço manualmente",
        "european_vat_id": "ID de IVA europeu",
        "gst_hst_number": "Número de registro GST/HST",
        "postal_code": "Código postal",
        "province": "Província",
        "pst_number": "Número de registro PST",
        "qst_number": "Número de registro QST",
        "sfi_message": "Você selecionou uma instituição financeira (SLFI)?",
        "state": "Estado",
        "street": "Endereço postal",
        "suggestions_attribution": "Sugestões desenvolvidas pelo Google",
        "suggestions_not_found": "Endereço não encontrado. Tente novamente ou insira o endereço de forma manual.",
        "tax_tooltip": "Insira sua ID fiscal aqui. Ajuda a garantir que os impostos corretos sejam adicionados às suas faturas.",
        "title": "Endereço de faturamento",
        "validation_message": {
          "city_required": "A cidade é obrigatória.",
          "country_required": "O país é obrigatório.",
          "province_required": "O município é obrigatório.",
          "state_required": "O estado é obrigatório.",
          "street_required": "Insira seu endereço postal.",
          "tax_invalid": "Não foi possível validar o ID fiscal. Revise e tente novamente.",
          "zip_required": "O código postal é obrigatório."
        },
        "zip": "Código postal"
      },
      "call_to_action": {
        "cancel": "Cancelar",
        "clear": "Apagar",
        "submit": "Enviar"
      },
      "cancel_account": {
        "cancel_account": "Cancelar conta",
        "cancel_trial": "Cancelar avaliação",
        "contact_information": {
          "call_international": "Internacional: +1 919.745.6111",
          "call_toll_free": "Ligação gratuita: 1.800.441.3453",
          "call_uk": "Reino Unido: +44 (0800) 680.0621",
          "here_for_you": "Estamos à sua disposição",
          "visit_support": "Acessar suporte"
        },
        "contact_us": "Contate-nos",
        "continue_cancellation": "Continuar cancelamento",
        "did_you_know": "Você sabia?",
        "did_you_know_desc": "Quando você cancela a sua conta do ShareFile, você perde inúmeros excelentes recursos, entre eles:",
        "download_now": "Baixar agora",
        "error_banner": "Falha ao cancelar. Tente novamente ou entre em contato com nossa equipe de suporte",
        "features": {
          "customer_access": "Acesso ilimitado para seus clientes",
          "customer_access_desc": "Permita que seus clientes tenham acesso a arquivos gratuitamente e determine quais arquivos eles podem ver.",
          "customer_support": "Suporte ao cliente",
          "customer_support_desc": "por email ou por telefone: estamos aqui para ajudar!",
          "esignature": "Assinatura digital",
          "esignature_desc": "Envie arquivos para assinar diretamente da sua conta de ShareFile.",
          "sharefile_mobile": "Aplicativos móveis do ShareFile",
          "sharefile_mobile_desc": "Tenha acesso a arquivos e pastas a qualquer momento do seu smartphone ou tablet.",
          "sharefile_plugin": "ShareFile Plugin para Microsoft Outlook",
          "sharefile_plugin_desc": "Envie arquivos grandes de modo seguro diretamente do Outlook.",
          "total_security": "Segurança total",
          "total_security_desc": "Confie na proteção dos seus dados."
        },
        "form": {
          "account_name": "Nome da conta",
          "back_to_admin": "Voltar à administração de contas",
          "cancel_my_account": "Cancelar minha conta",
          "cancel_my_trial": "Cancelar avaliação",
          "cancellation_reason": {
            "Lacks_required_compliance": "Sem conformidade(s) obrigatória(s)",
            "lack_of_integrations": "Ausência de integrações",
            "lacks_required_feature": "Sem recurso(s) obrigatório(s)",
            "no_longer_needed": "Não é mais necessário",
            "poor_account_support": "Suporte de conta ruim (vendas, técnico)",
            "prefer_competitive_product": "Prefiro o produto concorrente",
            "security_concerns": "Problemas de segurança",
            "technical_issues": "Problemas técnicos",
            "too_difficult_to_use": "Muito difícil de usar",
            "too_expensive": "Muito caro"
          },
          "comments_label": "Comentários",
          "comments_placeholder": "Poderia nos dizer o motivo do cancelamento da conta? Se quiser, também adoraríamos saber o que poderíamos fazer para deixar o ShareFile melhor para você.",
          "employees_desc": "{{employeeCount}} de {{employeeMax}} comprados",
          "employees_title": "Funcionários",
          "forgot_your_password": "Esqueceu a senha?",
          "more_info": "Reserve um minuto para nos contar um pouco mais sobre por que você está cancelando sua conta.",
          "once_you_cancel": "Depois que você cancelar, o ShareFile excluirá seus arquivos após 30 dias.",
          "password_label": "Digite a senha da conta",
          "password_missing": "Digite a senha da conta",
          "password_placeholder": "Senha",
          "reason_missing": "Selecione um motivo",
          "required": "Obrigatório",
          "storage_usage_desc": "{{mbUsed}} MB de {{mbMax}} utilizados até {{dateFormatted}}",
          "storage_usage_title": "Uso do armazenamento",
          "title": "Estou cancelando minha conta do ShareFile porque:",
          "to_authorize": "Para autorizar o ShareFile a excluir seus arquivos depois de 30 dias, digite a senha da sua conta para continuar com o cancelamento da sua conta."
        },
        "in_progress_banner": "Estamos trabalhando para atualizar seu plano. Isso pode levar algum tempo, volte mais tarde.",
        "learn_more": "Saiba mais",
        "let_us_help_1": "Podemos ajudar você a obter o máximo da sua conta do ShareFile.",
        "let_us_help_2": "Entre em contato com nossa equipe de atendimento ao cliente",
        "let_us_help_3": "para saber mais sobre estes e outros recursos do ShareFile.",
        "modal_confirm": "OK",
        "modal_message": "Sua conta foi cancelada, mas continuará ativa até o fim do ciclo de cobrança. Você pode reativá-la clicando em \"Reativar conta\" no menu do administrador.",
        "modal_message_trial": "Sua avaliação foi cancelada. Obrigado por experimentar o ShareFile! Para reativar sua conta, clique em \"Reativar conta\" no menu de administração de conta.",
        "modal_title": "Conta cancelada",
        "modal_title_trial": "Avaliação cancelada",
        "password_was_incorrect": "A senha estava incorreta",
        "resources_card": {
          "ask_the_community": "Perguntar à comunidade",
          "sharefile_knowledgebase": "Base de conhecimento do ShareFile",
          "title": "Você experimentou estes recursos?",
          "training_videos": "Vídeos de treinamento"
        },
        "sorry_to_go": "Que pena que você vai embora!",
        "sorry_to_go_desc": "O ShareFile foi criado para você e estamos sempre tentando encontrar meios de melhorar nosso serviço e atender às suas necessidades de compartilhamento de arquivos e armazenamento."
      },
      "common": {
        "Back": "Back",
        "contact_support": "Contact support",
        "contact_us": "contact us",
        "generic_error": "Ocorreu um erro",
        "live_chat": "chat ao vivo",
        "sales_team": "equipe de vendas"
      },
      "convert_to_paid": {
        "billing_cycle_selection": {
          "annual_save": "(Economize 10%)",
          "choose_billing_cycle": "Escolha seu ciclo de faturamento",
          "choose_billing_cycle_text": "O preço é baseado no número total de usuários funcionários",
          "online_only": "(Somente online)",
          "pay_annually": "Pagamento anual",
          "pay_monthly": "Pagamento mensal"
        },
        "buttons": {
          "buy_now": "Comprar agora",
          "cancel": "Cancelar",
          "continue": "Continuar",
          "convert_now": "Converter agora",
          "convert_now_tooltip": "Certifique-se de que o endereço e o cartão de crédito foram confirmados antes da conversão."
        },
        "convert_modal": {
          "confirm_purchase": "Confirmar compra",
          "confirm_purchase_description": "Ao selecionar \"Converter agora\", você pagará {<billingRate>} (mais impostos aplicáveis) hoje e sua conta será convertida para uma conta paga."
        },
        "credit_card": {
          "add": "Adicionar",
          "confirmed": "Cartão de crédito confirmado",
          "confirmed_description": "As informações do seu cartão de crédito foram confirmadas.",
          "declined": "Cartão de crédito recusado",
          "declined_description": "Não conseguimos confirmar seu cartão. Confirme se você digitou corretamente e tente novamente.",
          "edit": "Editar",
          "error_message": "A confirmação do cartão de crédito falhou. Verifique as informações do cartão de crédito e tente novamente.",
          "information": "Informações do cartão"
        },
        "current_licenses": "Licenças de funcionários: {{users}}",
        "current_storage": "Armazenamento: {{storage}} GB",
        "employee_accounts": "Contas de funcionários",
        "employee_accounts_description": "No seu plano estão incluídas {{users}} contas de funcionários. Você pode adicionar contas adicionais ao seu plano abaixo.",
        "employee_accounts_description_vdr": "No seu plano estão incluídas {{users}} licenças de funcionários e {{storage}} GB de armazenamento. Você pode adicionar mais abaixo.",
        "employee_licenses": "Licenças de funcionários",
        "employee_licenses_storage": "Licenças e armazenamento de funcionários",
        "error_loading_plans": "Houve um erro na obtenção das informações do seu plano. Tente novamente mais tarde.",
        "left_nav_button_text": "Converter avaliação gratuita",
        "month": "por mês",
        "number_of_users_selection": {
          "title": "Número de usuários",
          "user_limit_message": "O plano selecionado permite no mínimo {{min}} usuários e no máximo {{max}} usuários."
        },
        "plan": {
          "base_employee_accounts": "{{employee}} contas de funcionários",
          "max_file_size": "100 GB",
          "max_storage": "1 TB/licença",
          "max_storage_vdr": "1 GB/licença",
          "storage": "Armazenamento {{storage}}"
        },
        "plan_chart": {
          "need_help": "Precisa de ajuda? Estamos aqui para ajudar. Entre em contato com o suporte pelo email sales@sharefile.com ou ligue para 1 (800) 441-3453 para outras opções de planos.",
          "upgrade_plan": "Fazer upgrade do plano",
          "view_detailed_comparison": "Ver comparação detalhada"
        },
        "plan_summary": {
          "annually": "Anual",
          "billing": "Faturamento",
          "monthly": "Mensal",
          "plan": "Plano {{name}}",
          "plus_applicable_taxes": "Se aplicável, o imposto final será incluído na fatura.",
          "storage_max_file_size": "Armazenamento/tamanho máx. de arquivo: {<storage_details>}",
          "users": "Usuários",
          "your_total": "Seu total"
        },
        "purchase_confirmed": "Compra confirmada",
        "something_went_wrong": "Houve um problema",
        "storage_distribution_description": "O armazenamento é compartilhado com todos os funcionários licenciados e não é limitado por usuário.",
        "storage_gb": "{{storage}} GB",
        "storage_only": "Armazenamento",
        "successful_conversion": "Sua conta foi convertida corretamente.",
        "title": "Converter avaliação gratuita",
        "try_again_or_contact_support": "Tente novamente ou entre em contato com o suporte para receber mais ajuda.",
        "upgrade_failed": "Falha no upgrade"
      },
      "credit_card_overdue": {
        "amount_due": "Amount due",
        "credit_card_number": "Credit card number",
        "description_admin": "Your current card has expired or couldn't be charged. Our system shows that you have unpaid invoices that are now overdue. To continue using our service, please resolve the balance on your account.",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to your administrator(s) on this account to resolve.",
        "error_modal": {
          "close": "Close",
          "sub_title": "Call us at 1-800-441-3453 to finish setting up your account.",
          "title": "We need a little more information"
        },
        "footer_note": "Access will be restored once your account is in good standing.",
        "loading_modal": {
          "sub_title": "Hang tight while we finish setting everything up.",
          "title": "We're reactivating your ShareFile account."
        },
        "outstanding_invoices": "outstanding invoices",
        "pay_and_update": "pay & update",
        "pay_option_review": "Review your {<outstanding_invoices>}",
        "pay_option_support": "If you need additional support, {<contact_us>} and we'll assist you.",
        "pay_option_update": "Click below to {<pay_and_update>} your credit card",
        "pay_options_header": "What you can do:"
      },
      "edit_billing_information": {
        "address": {
          "billing_address": "Endereço de faturamento",
          "city": "Cidade",
          "country": "País",
          "state_province": "Estado/província",
          "street": "Endereço postal",
          "zip_postal_code": "CEP/código postal"
        },
        "cancel": "Cancelar",
        "credit_card": {
          "card_details": "Dados do cartão de crédito",
          "card_exp_date": "Data de expiração",
          "card_first_name": "Nome",
          "card_last_name": "Sobrenome",
          "card_number": "Número do cartão",
          "card_type": "Tipo de cartão",
          "card_type_american_express": "American Express",
          "card_type_mastercard": "MasterCard",
          "card_type_not_supported": "Tipo de cartão de crédito não aceito. Use Visa, Mastercard ou American Express",
          "card_type_unknown": "Desconhecido",
          "card_type_visa": "Visa",
          "title": "Informações do cartão de crédito"
        },
        "credit_card_notifications": {
          "add_successful": "Informações do cartão de crédito adicionadas!",
          "save_failure": "Falha ao salvar as informações do cartão de crédito",
          "update_failure": "Falha na atualização das informações do cartão de crédito",
          "update_successful": "Informações do cartão de crédito atualizadas!"
        },
        "disable_trial_conversion_message": "Conecte-se com sua equipe para explorar o melhor plano para o seu país. Entre em contato via {<live_chat>}.",
        "edit": "Editar",
        "get_billing_info_failed": "Houve um erro na recuperação das suas informações de cobrança. Tente novamente mais tarde.",
        "info_banner": "Observação: as alterações nas informações de cobrança podem não ficar visíveis imediatamente. Aguarde até 24 horas para que as alterações apareçam abaixo.",
        "left_nav_button_text": "Editar informações de faturamento",
        "name_on_card": "Nome no cartão",
        "no_billing_info_banner": "Não conseguimos carregar esta página no momento. Entre em contato com nossa equipe de atendimento ao cliente para editar as informações de cobrança.",
        "province": "Província",
        "save": "Salvar",
        "state": "Estado",
        "support": {
          "chat_with_us": "Converse conosco",
          "contact_support": "Não foi possível confirmar o endereço, entre em contato com o suporte.",
          "contact_support_info": "falar com o suporte"
        },
        "title": "Editar informações de faturamento",
        "update": "Atualizar",
        "update_billing_type": {
          "info_message": "O tipo de faturamento atual é {<invoice>}. Você pode trocar por pagamentos com cartão de crédito.",
          "invoice": "fatura",
          "switch_to_credit_card": "Passar para cartão de crédito",
          "title": "Alterar tipo de cobrança"
        },
        "update_notifications": {
          "contact_support": "falar com o suporte",
          "save_failed": "Não é possível salvar",
          "save_success": "Suas alterações foram salvas.",
          "something_went_wrong": "Houve um problema",
          "try_again": "Não foi possível confirmar o endereço, tente novamente.",
          "try_again_or_contact_support": "Tente novamente ou {<contactSupport>} para receber mais ajuda."
        },
        "vat_id": "ID do IVA",
        "verify_address": "Verificar o endereço"
      },
      "expiration": {
        "account_canceled_first": "Cancelamos contas por solicitação dos administradores, vencimento do faturamento ou violação dos termos de serviço.",
        "account_canceled_second": "Esta conta e todos os dados serão excluídos permanentemente em (ou logo após) {{date}}. Você pode continuar a usar sua conta até recuperar tudo armazenado no ShareFile. Depois de excluir sua conta, todos os arquivos e usuários associados não poderão ser recuperados.",
        "account_canceled_title": "Esta conta foi cancelada",
        "ask_to_purchase": "Pedir para comprar",
        "continue_to_sharefile": "Continuar no ShareFile",
        "logo_alt_text": "Logotipo do ShareFile",
        "notification_error_message": "Falha ao enviar a notificação para o administrador. Tente novamente.",
        "purchase": {
          "error_modal": {
            "close": "Fechar",
            "sub_title": "Ligue para 1-800-441-3453 para terminar a configuração da conta. Indique o código de erro {<errorCode>}.",
            "title": "Precisamos de um pouco mais de informações"
          },
          "loading_modal": {
            "sub_title": "Aguarde enquanto terminamos a configuração.",
            "title": "Estamos fazendo o upgrade da sua conta do ShareFile"
          },
          "select_plan": "Selecionar plano",
          "title": "Comprar ShareFile"
        },
        "purchase_account": "Comprar conta",
        "reactivate_account": "Reativar conta",
        "request_reactivation": "Solicitar reativação",
        "request_sent": "Solicitação enviada",
        "something_went_wrong": "Houve um problema",
        "trial_ended_first": "Seu período de avaliação terminou em {{date}}. Para continuar a usar o ShareFile, compre sua conta.",
        "trial_ended_second": "Observe que as contas de avaliação são geralmente excluídas 60 dias após o fim do período de avaliação. Depois disso, não será possível recuperar todos os arquivos e usuários associados à conta.",
        "trial_ended_title": "Sua avaliação terminou"
      },
      "files": {
        "trial_expiration_info": {
          "day_count": "um dia",
          "day_count_plural": "{{count}} dias",
          "days_left_in_your_trial": "Você tem {<dayCount>} dias restantes na sua avaliação. ",
          "upgrade_to_a_plan": "Faça upgrade para um plano"
        }
      },
      "invalid_address_error": "O endereço que você informou é inválido. Tente novamente.",
      "invoice_overdue": {
        "already_paid": "If you've already paid your balance and still see this message, please contact our {<support_team>}.",
        "description_admin": "Our system shows that you have unpaid invoice(s) that are overdue. To keep using ShareFile, please take care of the unpaid invoices on your account. You can:",
        "description_emp": "Our system shows that this account has unpaid invoice(s) that are overdue. To keep using ShareFile, please reach out to the administrator on this account to resolve.",
        "footer_note": "Access will be restored once the account is in good standing. Credit card payments may take a few days to process.",
        "pay_now_button": "Pay now",
        "pay_option_1": "Click below to pay your unpaid invoice(s) by credit card",
        "pay_option_2": "Prefer another payment method? We're happy to help - {<contact_us>}",
        "support_team": "support team via chat",
        "title": "Your account is past due."
      },
      "lock_error": "Não foi possível processar esta solicitação, pois uma solicitação anterior estava sendo processada.",
      "manage_plan": {
        "add_storage_btn": "Adicionar armazenamento",
        "add_users_btn": "Adicionar usuários",
        "advanced": {
          "description": "Transferência segura de arquivos para equipes",
          "feature_access_control": "Controles de acesso detalhados e relatórios básicos",
          "feature_encryption": "Armazenamento e compartilhamento de arquivos criptografados",
          "feature_secure_email": "Integrações seguras de e-mail e edição colaborativa em tempo real",
          "features_header": "Recursos principais:",
          "title": "Advanced",
          "title_0gb": "Advanced 0GB"
        },
        "connectors": {
          "title_0gb": "Conectores 0GB"
        },
        "contact_support": "Entre em contato com o suporte para conhecer outras opções de planos",
        "current_plan": "Plano atual",
        "for_accounting": "Para Contabilidade",
        "get_usageplan_failed": "Houve um erro na obtenção das informações do seu plano. Tente novamente mais tarde.",
        "included": "Incluído",
        "industry_advantage": {
          "description": "Automação de fluxos de trabalho de documentos pré-configurada e específica para contabilidade",
          "feature_bulk_client_onboarding": "Integre vários clientes de uma só vez para serviços contábeis",
          "feature_centralized_view": "Visão centralizada de todos os contratos em um só lugar",
          "feature_tax_templates": "Modelos pré-configurados para serviços fiscais",
          "features_header": "Todos os recursos do Premium, mais:",
          "title": "Industry Advantage",
          "tooltip": "Fluxos de trabalho sob medida projetados para facilitar casos de uso completos e integrados nos processos contábeis e fiscais, aumentando a eficiência e a padronização"
        },
        "left_nav_button_text": "Gerenciar plano",
        "manage_plan_title": "Gerenciar plano",
        "message_after_update": "Estamos trabalhando para atualizar seu plano. Isso pode levar algum tempo, volte mais tarde.",
        "modals": {
          "add_button": "Adicionar",
          "additional_users": "Usuários adicionais",
          "alert_message": "Se você escolher {<boldText>}, cobraremos o valor proporcional à diferença no custo do plano.",
          "annual_billing_note": "Seu primeiro pagamento anual vencerá em {{date}}.",
          "annual_billing_text": "Você pode economizar 10% no seu plano do ShareFile pagando anualmente. Veja a seguir um resumo de quais seriam os custos do seu novo plano.",
          "annual_billing_title": "Faturamento anual",
          "cancel_button": "Cancelar",
          "error_alert": "Não foi possível atualizar seu plano. Tente novamente.",
          "extended_storage": "{{count}} TB de armazenamento estendido",
          "new_billing_amount": "Novo valor de cobrança",
          "new_monthly_total": "Novo total mensal",
          "new_plan_total": "Total do novo plano",
          "new_storage_total": "Novo total de armazenamento",
          "new_user_total": "Total de novos usuários",
          "per_month": "{{price}} por mês*",
          "per_quarter": "{{price}} por trimestre*",
          "per_year": "{{price}} por ano*",
          "plus_applicable_taxes": "*mais impostos vigentes",
          "price_per_TB": "{{price}} por 3 TB",
          "price_per_user": "{{price}} por usuário",
          "storage_add": "Adicionar armazenamento",
          "storage_data_breakdown_message": "Você está usando {<usedValue>} TB do seu total de {<total>} TB de armazenamento.",
          "storage_modal_title": "Adicionar armazenamento",
          "storage_need_additional": "Precisa de mais armazenamento?",
          "success_alert": "Plano atualizado.",
          "switch_to_annual_button": "Passar para o faturamento anual",
          "upgrade_button": "Fazer upgrade",
          "upgrade_plan_modal_title": "Fazer upgrade do plano",
          "users_add": "Adicionar usuários",
          "users_count": "{{count}} usuários",
          "users_data_breakdown_message": "Você está usando {<usedValue>} do seu total de {<total>} licenças de usuário.",
          "users_modal_title": "Adicionar usuários",
          "users_need_additional": "Precisa de mais usuários?",
          "value_gb": "{{value}} GB",
          "value_tb": "{{value}} TB"
        },
        "most_popular": "Mais procurado",
        "need_help": "Precisa de ajuda? Estamos à sua disposição. {<contact_support>}",
        "next_billing_date_pending": "na sua próxima data de cobrança",
        "per_month": "por mês",
        "per_quarter": "por trimestre",
        "per_year": "por ano",
        "plus_taxes": "*mais impostos vigentes",
        "premium": {
          "description": "Fluxos de trabalho completos de documentos para equipes e clientes",
          "feature_ai_powered": "Automação e geração de documentos com tecnologia de IA",
          "feature_client_portals": "Portais com a identidade visual de clientes",
          "feature_hippa_finra_support": "Suporte à conformidade regulatória com HIPAA, FINRA e SEC",
          "feature_tools": "Ferramentas de colaboração com clientes: assinatura eletrônica, solicitações, tarefas, formulários e automação de fluxos de trabalho",
          "features_header": "Todos os recursos do Advanced, mais:",
          "title": "Premium"
        },
        "save_with_annual_btn": "Economize 10% com o faturamento anual",
        "standard": {
          "feature_all_storage": "Todo o armazenamento de que você precisa",
          "feature_file_encryption": "Criptografia de arquivos",
          "feature_sync_edit_share": "Sincronize, edite, compartilhe",
          "feature_unlimited_client": "Usuários clientes ilimitados",
          "features_header": "Os recursos são:",
          "title": "Padrão",
          "title_0gb": "Padrão 0GB"
        },
        "storage": "Armazenamento",
        "storage_per_user": "{{storage}} por usuário",
        "upgrade_btn": "Fazer upgrade",
        "upgrade_plan": "Fazer upgrade do plano",
        "users": "Usuários",
        "users_count": "{{count}} usuários",
        "users_count_one": "{{count}} usuário",
        "vdr": {
          "feature_click_trails": "Trilhas de cliques",
          "feature_folder_qa": "Perguntas frequentes de pastas",
          "feature_visibility_analytics": "Visibilidade, análise de dados e outros",
          "features_header": "Proteção especializada, incluindo:",
          "title": "Virtual Data Room"
        }
      },
      "payment_gateway": {
        "authorization_error": "Não conseguimos confirmar seu cartão. Confirme se você digitou corretamente e tente novamente.",
        "authorization_error_title": "Falha na verificação do cartão",
        "contact_details": "Detalhes de contato",
        "form": {
          "card_number": "Número do cartão",
          "cardholder_name": "Nome do titular",
          "date_validation": {
            "expired": "O cartão está expirado",
            "invalid_date": "Data inválida",
            "invalid_month": "Mês inválido",
            "no_date_provided": "Digite uma data de validade"
          },
          "expiration_date": "Data de validade",
          "payment_details": "Detalhes do pagamento",
          "payment_details_description": "{<asterisk>} indica um campo obrigatório",
          "security_code": "Código de segurança",
          "security_code_description": "3 dígitos no verso do cartão ou 4 dígitos na frente do cartão"
        },
        "iframe_description": "Clique em “novo” para adicionar outro cartão de crédito.",
        "iframe_load_error": "Houve um erro no carregamento das informações do seu plano. Tente novamente mais tarde ou entre em contato com o suporte.",
        "modal_title": "Inserir detalhes de pagamento",
        "modal_title_legacy": "Adicionar/editar cartão de pagamento"
      },
      "reactivate": {
        "account_summary": {
          "account_name_label": "Nome de conta:",
          "account_owner_label": "Proprietário da conta:",
          "allocated_licenses_label": "Licenças alocadas:",
          "billing_cycle_month": "Mês",
          "billing_cycle_quarter": "Trimestre",
          "billing_cycle_year": "Ano",
          "cancel": "Cancelar",
          "esig_licenses_out_of": "{{count}} de {{max}} licenças de assinatura eletrônica usadas",
          "id_label": "ID:",
          "licenses_out_of": "{{count}} de {{max}} licenças de funcionário usadas",
          "next_billing_date_label": "Próxima data de cobrança: ",
          "plan_label": "Plano:",
          "save": "Salvar",
          "title": "Resumo da conta",
          "total_billing_cost_info_label": "Este é o custo total de todos os produtos ShareFile da sua organização.",
          "total_billing_cost_label": "Custo total de faturamento:",
          "view_receipts_label": "Exibir recibos"
        },
        "cancel": "Cancelar",
        "description": "A reativação de sua conta manterá seus serviços ativos e reativará o faturamento em sua conta.",
        "left_nav_button_text": "Reativar conta",
        "lock_error": "Não foi possível processar esta solicitação, pois uma solicitação anterior estava sendo processada.",
        "page_title": "Reativar conta",
        "reactivate_button": "Reativar",
        "reactivate_failed": "Sua conta não pode ser reativada, entre em contato com nossa equipe de suporte em sales@sharefile.com ou ligue para 1 (800)-441-3453.",
        "reactivate_success": "Sua conta foi reativada."
      },
      "receipts": {
        "actions": {
          "download": "Baixar",
          "pay": "Pagar",
          "title": "Ações"
        },
        "awaiting_payment_tooltip": "As faturas podem levar até 24 horas para aparecer como pagas nesta página.",
        "billing_system_change": "Recentemente, fizemos alterações em nossos sistemas de cobrança que afetarão a forma como você paga suas faturas do ShareFile. Para todas as faturas emitidas após {<migrationDate>} há um link de pagamento direto no arquivo da fatura. As faturas emitidas antes de {<migrationDate>} não conterão esse link. Entre em contato com o suporte para efetuar o pagamento.",
        "cancel": "Cancelar",
        "credit_card_notifications": {
          "payment_approved": "Pagamento aprovado, obrigado!",
          "payment_failure": "O pagamento com cartão de crédito falhou. Entre em contato com o suporte."
        },
        "date": "Data adicionada",
        "email": "Email",
        "error_getting_logs": "Houve um erro na recuperação das suas informações de cobrança. Tente novamente mais tarde.",
        "invoice_total": "Invoice total",
        "left_nav_button_text": "Recibos e notificações de cobrança",
        "open_payment": "Há um pagamento em aberto na sua conta.",
        "outstanding_intro": "This page lists out your unpaid invoices with ShareFile.",
        "outstanding_payment_instructions": "To pay, download the invoice and click the PayTrace link found on each invoice.",
        "outstanding_payment_processing_info": "Credit card payments may take 2-3 days to process. Need to process multiple invoices? Contact us at {<email>}",
        "outstanding_title": "Outstanding invoices",
        "page_infotip": "Esta página contém uma lista de todos os seus recibos de cobrança do ShareFile. As faturas podem levar até 24 horas para constarem como pagas nesta página.",
        "page_title": "Recibos e notificações de cobrança",
        "pay_now": "pagar",
        "phone": "Telefone",
        "phone_and_email": "{<phone>}: {{number}} | {<email>}: {{address}}",
        "status": "Status",
        "status_approved": "Aprovado",
        "status_awaiting_payment": "Aguardando pagamento",
        "status_cleared": "Pago",
        "status_failed": "Malsucedido",
        "status_invoice_payment_received": "Pagamento da fatura recebido",
        "status_negated": "Negado",
        "status_open": "Em aberto",
        "status_paid": "Pago",
        "status_pending": "Pendente",
        "status_tax_credited": "O imposto foi creditado",
        "status_tax_negated": "O imposto foi negado",
        "status_transaction_credited": "A transação foi creditada",
        "type": "Tipo"
      }
    }
  }
];